<template>
    <div class="app-content">
        <a-card :title="title">
            <template #extra>
                <a-button style="display: flex" @click="clear_model_data()" size="large">
                    <template #icon>
                        <span class="material-symbols-outlined">arrow_back_ios</span>
                    </template>
                     ย้อนกลับ
                </a-button>
            </template>
            <a-tabs v-if="model_type === 'Driver'" default-active-key="1">
                <a-tab-pane key="1" tab="เพิ่มพนักงานขับรถ">
                    <!-- ข้อมูลทั่วไป -->
                    <a-form :model="model_form" :layout="form_layout" :onFinish="confirmAndSubmit">
                        <a-row justify="center">
                            <a-col v-if="default_fields[model_type].photos" :span="8" style="margin: 1rem">
                                <a-card title="รูปภาพ" style="text-align: center; margin-top: 20px;">
                                    <a-row justify="center" :gutter="16">
                                        <a-col :span="12">
                                            <a-row justify="center"
                                                v-for="{ key, label, height, width, description } in default_fields[model_type].photos"
                                                :gutter="16">
                                                    <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                                    <p style="margin-top: 10;">{{ label }}</p>
                                                    <a-upload v-model:file-list="fileList" list-type="picture-card"
                                                            class="avatar-uploader" :show-upload-list="false"
                                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                            @change="upload_files($event, key)" method="PUT"
                                                            :before-upload="setFileType"
                                                            accept="image/*"
                                                            >
                                                        <img v-if="model_form[key]" :src="model_form[key]"
                                                            :style="`height: ${height}px;width: ${width}px;object-fit: cover`"
                                                            alt="avatar" />
                                                        <div v-else>
                                                            <p class="ant-upload-drag-icon">
                                                                <span class="material-symbols-outlined" style="font-size: 5rem">upload_file</span>
                                                            </p>
                                                            คลิกเพื่ออัพโหลดรูปภาพ
                                                        </div>
                                                    </a-upload>
                                                    <a-button danger type="primary" @click="(model_form[key] = '')"
                                                        v-if="model_form[key]">
                                                        <span class="material-symbols-outlined">remove</span>
                                                        ลบ
                                                    </a-button>
                                                    <p style="color: gray;">{{ description }}</p>
                                                </div> 
                                            </a-row>
                                        </a-col>
                                        <a-col :span="12" v-show="model_type == 'CarCompany'">
                                            <a-row justify="center" v-for="{ key, label, height, width, description } in default_fields[model_type].photos_payment" :gutter="16">
                                                <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                                    <p>{{ label }}</p>
                                                    <a-upload v-model:file-list="fileList" list-type="picture-card" 
                                                            class="avatar-uploader" :show-upload-list="false"
                                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6" 
                                                            @change="upload_files($event, key)" method="GET"
                                                            :before-upload="setFileType"
                                                            accept="image/*"
                                                            >
                                                        <img v-if="model_form[key]" :src="model_form[key]" :style="`height: ${height}px;width: ${width}px;object-fit: cover`" alt="avatar" />
                                                        <div v-else>
                                                            <p class="ant-upload-drag-icon">
                                                                <span class="material-symbols-outlined" style="font-size: 5rem">upload_file</span>
                                                            </p>
                                                            คลิกเพื่ออัพโหลดรูปภาพ
                                                        </div>
                                                    </a-upload>
                                                    <a-button danger type="primary" @click="(model_form[key] = '')" v-if="model_form[key]">
                                                        <span class="material-symbols-outlined">remove</span>
                                                        ลบ
                                                    </a-button>
                                                    <p style="color: gray;">{{ description }}</p>
                                                </div>
                                            </a-row>
                                        </a-col>
                                    </a-row>
                                </a-card>

                                <a-card  v-if="model_type === 'CarCompany'"  title="รูปภาพที่เกี่ยวข้อง" style="text-align: center; margin-top: 20px;">
                                    <a-row justify="center" :gutter="16">
                                        <a-col :span="12">
                                            <a-row justify="center" v-for="{ key, label, height, width, description } in default_fields[model_type].photos_social" style="margin: 1rem 0">
                                                <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                                    <p>{{ label }}</p>
                                                    <a-upload v-model:file-list="fileList" list-type="picture-card" 
                                                            class="avatar-uploader" :show-upload-list="false"
                                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6" 
                                                            @change="upload_files($event, key)" method="GET"
                                                            :before-upload="setFileType"
                                                            accept="image/*"
                                                            >
                                                        <img v-if="model_form[key]" :src="model_form[key]" :style="`height: ${height}px;width: ${width}px;object-fit: cover`" alt="avatar" />
                                                        <div v-else>
                                                            <p class="ant-upload-drag-icon">
                                                                <span class="material-symbols-outlined" style="font-size: 5rem">upload_file</span>
                                                            </p>
                                                            คลิกเพื่ออัพโหลดรูปภาพ
                                                        </div>
                                                    </a-upload>
                                                    <a-button danger type="primary" @click="(model_form[key] = '')" v-if="model_form[key]">
                                                        <span class="material-symbols-outlined">remove</span>
                                                        ลบ
                                                    </a-button>
                                                    <p style="color: gray;">{{ description }}</p>
                                                </div>
                                            </a-row>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-row justify="center" v-for="{ key, label, height, width, description } in default_fields[model_type].photos_iso" style="margin: 1rem 0">
                                                <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                                    <p>{{ label }}</p>
                                                    <a-upload v-model:file-list="fileList" list-type="picture-card" 
                                                            class="avatar-uploader" :show-upload-list="false"
                                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6" 
                                                            @change="upload_files($event, key)" method="GET"
                                                            :before-upload="setFileType"
                                                            accept="image/*"
                                                            >
                                                        <img v-if="model_form[key]" :src="model_form[key]" :style="`height: ${height}px;width: ${width}px;object-fit: cover`" alt="avatar" />
                                                        <div v-else>
                                                            <p class="ant-upload-drag-icon">
                                                                <span class="material-symbols-outlined" style="font-size: 5rem">upload_file</span>
                                                            </p>
                                                            คลิกเพื่ออัพโหลดรูปภาพ
                                                        </div>
                                                    </a-upload>
                                                    <a-button danger type="primary" @click="(model_form[key] = '')" v-if="model_form[key]">
                                                        <span class="material-symbols-outlined">remove</span>
                                                        ลบ
                                                    </a-button>
                                                    <p style="color: gray;">{{ description }}</p>
                                                </div>
                                            </a-row>
                                        </a-col>
                                    </a-row>
                                </a-card>
                            </a-col>

                            <a-col :span="15" style="margin: 1rem; width: 100%;">
                                <a-card title="ข้อมูล">
                                    <a-row>
                                        <a-col :style="key === 'company_3rd' ? { marginBottom: '1rem', marginLeft: '1rem', display: 'flex', alignItems: 'end' } : { margin: '1rem' }" :span="col_span" v-for="
                                                {
                                                    col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                                    target_key, target_modelname, drawer_title, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                                    on_change, accept
                                                }, key in default_fields[model_type].inputs">
                                            <div v-if="input_type== 'label'">{{ label }}</div>
                                            <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                                :rules="check_duplicate? check_rule: (non_editable ? null : ( input_type === 'password' ? [{ validator: validatePassword }] : [{ required, message: `โปรดระบุ ${placeholder}` }]) )">
                                                <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange('work_status' , on_change)">
                                                    <!-- <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id"> -->
                                                <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                                        {{ option.name }} 
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'car_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change,'plate')" :disabled="true">
                                                    <a-select-option v-for="option in car_list" :key="option.id" :value="option.id">
                                                        {{ option.plate_no }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'driver_job_position'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option value="พนักงานขับรถ (ตู้)">พนักงานขับรถ (ตู้)</a-select-option>
                                                    <a-select-option value="พนักงานขับรถ (บัส)">พนักงานขับรถ (บัส)</a-select-option>
                                                    <a-select-option value="พนักงานขับรถ (รถเก๋ง)">พนักงานขับรถ (รถเก๋ง)</a-select-option>
                                                    <a-select-option value="พนักงานขับรถ (รถ SUV)">พนักงานขับรถ (รถ SUV)</a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key == 'driver_bank'" v-model:value="model_form[key]">
                                                    <a-select-option value="กรุงเทพ">กรุงเทพ</a-select-option>
                                                    <a-select-option value="กสิกรไทย">กสิกรไทย</a-select-option>
                                                    <a-select-option value="กรุงไทย">กรุงไทย</a-select-option>
                                                    <a-select-option value="ไทยพาณิชย์">ไทยพาณิชย์</a-select-option>
                                                    <a-select-option value="ทหารไทย">ทหารไทย</a-select-option>
                                                    <a-select-option value="กรุงศรีอยุธยา">กรุงศรีอยุธยา</a-select-option>
                                                    <a-select-option value="เกียรตินาคิน">เกียรตินาคิน</a-select-option>
                                                    <a-select-option value="อื่นๆ">อื่นๆ</a-select-option>
                                                </a-select>
                                                <a-input v-else-if="key == 'driver_age_of_work'"
                                                    v-model:value="model_form.driver_age_of_work"
                                                    :placeholder="'อายุงาน (ปี)'"
                                                    :disabled="register_date"
                                                    readonly />
                                                    <div v-else-if="key == 'salary'">
                                                        <a-input-number 
                                                            v-model:value="model_form[key]" 
                                                            :placeholder="'เงินเดือน'" 
                                                            @change="handleSalaryChange"
                                                            :min="0"
                                                        />
                                                    </div>
                                                    <div v-else-if="key == 'salary'">
                                                        <a-input-number 
                                                            v-model:value="model_form[key]" 
                                                            :placeholder="'เงินเดือน'" 
                                                            @change="handleSalaryChange"
                                                            :min="0"
                                                        />
                                                    </div>
                                                    <div v-else-if="key == 'age'">
                                                        <a-input-number 
                                                            v-model:value="model_form[key]" 
                                                            :placeholder="'อายุ'" 
                                                            :min="0"
                                                        />
                                                    </div>
                                                <a-checkbox-group v-else-if="key == 'company_3rd'" v-model:value="model_form[key]">
                                                    <a-checkbox
                                                        @change="handleChange('disable', $event, field)"
                                                        v-model="model_form[key]"
                                                        value="บริษัทรถร่วม"
                                                        :disabled="this.$route.params.id != 'create'"
                                                    >
                                                        บริษัทรถร่วม
                                                    </a-checkbox>
                                                </a-checkbox-group>
                                                <a-select v-else-if="key === 'car_company_id'" v-model:value="model_form[key]"
                                                :key="car_company.length" 
                                                :disabled="disabletest || this.$route.params.id != 'create'"
                                                @change="handleChange(null_on_change , on_change)">
                                                <a-select-option
                                                        v-for="(company, index) in car_company"
                                                        :key="company.id"
                                                        :value="company.id"
                                                    >
                                                        {{ company.fullname }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                                        {{ item.name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-input v-else-if="key === 'age'" :value="model_form[key] ? model_form[key] : calculatedAge" @input="model_form[key] = $event.target.value" :placeholder="placeholder" :type="input_type"/>
                                                <!-- to change back to the original driving_license_type_id uncomment this add delete -->
                                                <!-- model_form.driving_license_type_id watcher filteredDrivingLicenseTypes compute and handleChangeDrivingLicenseType method -->
                                                <!-- <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option> -->
                                                <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChangeDrivingLicenseType">
                                                    <a-select-option v-for="option in filteredDrivingLicenseTypes" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                                    <!-- <a-date-picker 
                                                        v-else-if="key === 'card_id_expire'"
                                                        v-model="model_form[key]"
                                                        :placeholder="placeholder"
                                                        class="paddingTime"
                                                    /> -->
                                                    <a-input v-else-if="key === 'card_id' && car_rental_a" v-model:value="model_form[key]" :placeholder="placeholder" @change="handleChangeCardId()"
                                                        :type="input_type"
                                                    />
                                                <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'bank_Type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['getAllBankBranches']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'client_id'" 
                                                    show-search v-model:value="model_form[key]" 
                                                    @change="handleChange(null_on_change , on_change)" 
                                                    :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                                    :filter-option="filterOption">
                                                    <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                                        {{ option.fullname }}
                                                    </a-select-option>
                                                </a-select>
                                                <div v-else-if="key == 'driver_license_no'" >
                                                    <a-radio-group 
                                                        style="margin-bottom: 8px;"
                                                        v-model:value="is_check_license">
                                                        <a-radio :value="1">มี</a-radio>
                                                        <a-radio :value="0">ไม่มี</a-radio>
                                                    </a-radio-group>
                                                    <a-input
                                                        v-model:value="model_form[key]" :placeholder="placeholder"
                                                        :type="input_type"
                                                        :disabled="(non_editable || !is_check_license)"
                                                    />
                                                </div>
                                                <a-select
                                                    v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                                    v-model:value="model_form[key]"
                                                    show-search
                                                    :placeholder="placeholder"
                                                    :options="selectables[modelname].map((e) => ({ value: e.id, label: e[label_key] }))"
                                                    :filter-option="filterOption"
                                                    @change="handleChange(null_on_change)"
                                                ></a-select>
                                                <a-select v-else-if="input_type == 'sub_select'"
                                                    v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                                    <a-select-option 
                                                        v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                                        :value="id" 
                                                        selected
                                                    >
                                                        {{ name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-checkbox-group v-else-if="input_type == 'checkbox'"
                                                    v-model:value="model_form[key]"
                                                    :options="selectables[modelname]?.map(option => { return { label: option[label_key], value: option.id } })" />
                                                <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                                }}</a-divider>
                                                <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                                    <h5>{{ label }}</h5>
                                                </a-divider>
                                                <a-divider v-else-if="input_type == 'document'" orientation="left">{{ label
                                                }}</a-divider>
                                                <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                                    :table_columns="table_columns" :target_object="model_form"
                                                    :target_key="target_key" :drawer_title="drawer_title"
                                                    :drawer_fields="drawer_fields.inputs"
                                                    :drawer_button_text="drawer_button_text"
                                                    :drawer_button_text_edit="drawer_button_text_edit"
                                                    :target_modelname="target_modelname" />
                                                <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                                    :placeholder="placeholder"
                                                    format="DD/MM/YYYY"
                                                    :disabled="action_type == 'create' ? false : non_editable" />
                                                <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                                    :placeholder="placeholder"
                                                    :show-time="{ format: 'HH:mm' }"
                                                    format="DD/MM/YYYY HH:mm"
                                                    :disabled="action_type == 'create' ? false : non_editable" />
                                                <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                                    :placeholder="placeholder"
                                                    picker="month"
                                                    format="MMMM"
                                                    :disabled="action_type == 'create' ? false : non_editable" />
                                                <a-switch v-else-if="input_type == 'switch'" 
                                                    v-model:checked="model_form[key]"
                                                    :placeholder="placeholder"
                                                    :disabled="action_type == 'create' ? false : non_editable" />
                                                <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                                    :placeholder="placeholder"
                                                    :disabled="action_type == 'create' ? false : non_editable" />
                                                <div v-else-if="input_type == 'photos'" class="clearfix">
                                                    <a-upload v-model:file-list="model_form[target_key]"
                                                        action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                        @change="upload_files($event, key)" method="GET"
                                                        @remove="remove_uploaded_file($event)"
                                                        list-type="picture-card">
                                                        <div v-if="model_form[target_key]?.length < 5"
                                                            style="height: 104px; width: 104px; padding: 2rem">
                                                            <span style="font-size: 20px"
                                                                class="material-symbols-outlined">add</span>
                                                            <div style="margin-top: 8px">Upload</div>
                                                        </div>
                                                    </a-upload>
                                                </div>
                                                <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                                    <div>{{ label }}</div>
                                                    <a-upload 
                                                        v-model:file-list="fileList"
                                                        :show-upload-list="false"
                                                        action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                        @change="upload_files($event, key)" 
                                                        method="GET"
                                                        :before-upload="setFileType"
                                                        accept="image/*"
                                                    >
                                                        <div v-if="model_form[key]" class="upload-container">
                                                            <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                            <div class="icon-container">
                                                                <span
                                                                    class="material-symbols-outlined preview-icon"
                                                                    @click="handleIconClick('preview', model_form[key], $event)"
                                                                >
                                                                    visibility
                                                                </span>
                                                                <a :href="model_form[key]" download @click.stop>
                                                                    <span class="material-symbols-outlined download-icon"
                                                                >
                                                                        download
                                                                    </span>
                                                                </a>
                                                                <span
                                                                    class="material-symbols-outlined delete-icon"
                                                                    @click="handleIconClick('delete', key, $event)"
                                                                >
                                                                    delete
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                            <p class="ant-upload-drag-icon">
                                                                <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                            </p>
                                                            คลิกเพื่ออัพโหลดรูปภาพ
                                                        </div>
                                                    </a-upload>
                                                    <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                                        <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                                    </a-modal>
                                                </div>
                                                <!-- upload_file -->
                                                <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                                    <div>{{ label }}</div>
                                                    <a-upload 
                                                        v-model:file-list="fileList" 
                                                        v-if="!model_form[key]"
                                                        action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                        method="GET"
                                                        :show-upload-list="false"
                                                        @change="upload_files($event, key)"
                                                    >
                                                        <img v-if="model_form[key]" :src="model_form[key]"
                                                            style="width: 100%; height: 100px;"
                                                            alt="avatar"
                                                        />
                                                        <div style="display: flex; flex-direction: column; align-items: center;">
                                                            <p class="ant-upload-drag-icon">
                                                                <span class="material-symbols-outlined" 
                                                                    style="font-size: 5rem;">upload_file</span>
                                                            </p>
                                                            อัพโหลดไฟล์
                                                        </div>
                                                    </a-upload>
                                                    <a :href="model_form[key]" v-else="model_form[key]"
                                                        target="_blank" rel="doc"
                                                    >
                                                        {{ model_form[`${key}_file_name`] }}
                                                    </a>
                                                    <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                                        v-if="model_form[key]">
                                                        <span class="material-symbols-outlined">close</span>
                                                    </a-button>
                                                </div>
                                                <div  v-else-if="input_type == 'table_files'" >
                                                    <a-table
                                                        :columns="[
                                                            {
                                                                title: 'ชื่อเอกสาร',
                                                                dataIndex: 'name',
                                                                key: 'name',
                                                                width: 200,
                                                            },
                                                            {
                                                                title: 'ไฟล์เอกสาร',
                                                                dataIndex: 'file',
                                                                width: 100,
                                                                key: 'file',
                                                            },
                                                            {
                                                                title: 'ลบ',
                                                                dataIndex: 'id',
                                                                key: 'id',
                                                                width: 100,
                                                                align: 'center',
                                                            }
                                                        ]"
                                                        :dataSource="data_raw_files"
                                                        :pagination="false"
                                                        :scroll="{ y: 240 }"
                                                    >
                                                        <template #bodyCell="{ column, record, index}" >
                                                            <template v-if="column.key === 'name'">
                                                                <a-form-item>
                                                                    <a-input v-model:value="record.name"
                                                                    />
                                                                </a-form-item>
                                                            </template>
                                                            <template v-if="column.key === 'file'">
                                                                <a-form-item>
                                                                    <a :href="record.file" target="_blank" rel="doc"> 
                                                                        {{ record.file_name }}
                                                                    </a>
                                                                </a-form-item>
                                                            </template>
                                                            <template v-if="column.key === 'id'">
                                                                <a-form-item>
                                                                    <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                                        <span class="material-symbols-outlined">delete</span>
                                                                    </a-button>
                                                                </a-form-item>
                                                            </template>
                                                        </template>
                                                    </a-table>
                                                    <a-upload 
                                                        v-model:file-list="fileList" 
                                                        action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                        method="GET"
                                                        :show-upload-list="false"
                                                        @change="upload_file_multiple_driver($event, key)" :accept="accept ? accept : '*/*'"
                                                    >
                                                        <a-button style="margin-top: 10px;">
                                                            <span class="material-symbols-outlined">add</span>
                                                            เพิ่มไฟล์
                                                        </a-button>
                                                    </a-upload>
                                                </div>
                                                <div v-else-if="input_type== 'password'">
                                                    <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                                        :placeholder="placeholder" 
                                                        :type="input_type"
                                                        :disabled="action_type == 'create' ? false : non_editable"
                                                        autoComplete="new-password"
                                                    />
                                                    <a-input-password v-else v-model:value="model_form[key]" 
                                                        :placeholder="placeholder" 
                                                        :type="input_type"
                                                        :disabled="action_type == 'create' ? false : non_editable"
                                                        autoComplete="new-password"
                                                    />
                                                </div>
                                                <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                                    :type="input_type"
                                                    :disabled="action_type == 'create' ? false : non_editable"
                                                />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>

                                    <a-row justify="end">
                                        <a-form-item>
                                            <a-button type="primary" size="large" html-type="submit">
                                                <template #icon>
                                                    <span style="font-size: 20px; color: white" class="material-symbols-outlined">save</span>
                                                </template>
                                                บันทึกข้อมูล
                                            </a-button>
                                        </a-form-item>
                                    </a-row>
                                </a-card>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-tab-pane>          
                <a-tab-pane key="2" tab="ทะเบียนประวัติ">
                    <a-form :model="model_form" :layout="form_layout" :onFinish="confirmAndSubmit">
                        <a-row justify="center">
                            <a-col :span="15" style="margin: 1rem; width: 100%;">
                                <a-card title="ข้อมูลทั่วไป">
                                    <a-row>
                                        <a-col v-for="(field, key) in default_fields_driver[model_type].inputs" 
                                            :key="key" 
                                            :span="field.col_span" 
                                            style="margin: 1rem">
                                            <div v-if="field.input_type == 'label'">{{ field.label }}</div>
                                            <a-form-item v-else :name="key" :label="field.placeholder" :rules="[{ required: field.required, message: `โปรดระบุ ${field.placeholder}` }]">
                                                <a-input v-if="field.input_type == 'text'" v-model:value="model_form[key]" :placeholder="field.placeholder" :disabled="field.non_editable" />
                                                <div v-else-if="field.input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                                    <div>{{ label }}</div>
                                                    <a-upload 
                                                        v-model:file-list="fileList" 
                                                        v-if="!model_form[key]"
                                                        action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                        method="GET"
                                                        :show-upload-list="false"
                                                        :accept="field.accept ? field.accept : '*/*'"
                                                        @change="upload_files($event, key)"
                                                    >
                                                        <img v-if="model_form[key]" :src="model_form[key]"
                                                            style="width: 100%; height: 100px;"
                                                            alt="avatar"
                                                        />
                                                        <div style="display: flex; flex-direction: column; align-items: center;">
                                                            <p class="ant-upload-drag-icon">
                                                                <span class="material-symbols-outlined" 
                                                                    style="font-size: 5rem;">upload_file</span>
                                                            </p>
                                                            อัพโหลดไฟล์
                                                        </div>
                                                    </a-upload>
                                                    <a :href="model_form[key]" v-else="model_form[key]"
                                                        target="_blank" rel="doc"
                                                    >
                                                        {{ model_form[`${key}_file_name`] }}
                                                    </a>
                                                    <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                                        v-if="model_form[key]">
                                                        <span class="material-symbols-outlined">close</span>
                                                    </a-button>
                                                </div>
                                                <a-date-picker v-else-if="field.input_type == 'date'" v-model:value="model_form[key]" format="DD/MM/YYYY" :placeholder="field.placeholder" style="display: flex;" />
                                                <a-date-picker v-else-if="field.input_type == 'driving_license_exp'" v-model:value="model_form[key]" :placeholder="field.placeholder" style="display: flex;"  :disabled="car_rental_a"/>
                                                <a-date-picker v-else-if="field.input_type == 'card_id_expire'" v-model:value="model_form[key]" :placeholder="field.placeholder" style="display: flex;"  :disabled="car_rental_a"/>

                                                <a-input v-else-if="key === 'age'" :value="model_form[key] ? model_form[key] : calculatedAge" @input="model_form[key] = $event.target.value" :placeholder="placeholder" :type="input_type"/>
                                                <div v-else-if="field.input_type == 'checkbox'" style="display: flex;">
                                                    <a-checkbox-group v-model:value="model_form[key]" :placeholder="field.placeholder" style="display: flex;">
                                                    <a-checkbox
                                                        :disabled="end"
                                                        @change="handleChange('start', $event)"
                                                        v-model="start"
                                                        value="ทำงาน">ทำงาน</a-checkbox>
                                                    <a-checkbox
                                                        :disabled="start"
                                                        @change="handleChange('end', $event)"
                                                        v-model="end"
                                                        style="white-space: nowrap;"
                                                        value="สิ้นสุดการเป็นพนักงานตั้งแต่วันที่">สิ้นสุดการเป็นพนักงานตั้งแต่วันที่</a-checkbox>
                                                </a-checkbox-group>
                                                <a-date-picker v-if="car_rental_a"
                                                    v-show="end"
                                                    :placeholder="''"
                                                    v-model:value="model_form.driver_stoped_employment_date"
                                                    :disabled="start"
                                                    style="display: flex;" />
                                                </div>
                                                

                                                
                                                <a-date-picker v-if="key == 'driver_stoped_employment_date'"
                                                    v-show="end"
                                                    v-model:value="model_form.driver_stoped_employment_date"
                                                    :placeholder="field.placeholder"
                                                    :disabled="start"
                                                    style="display: flex;" />

                                                <a-date-picker v-else-if="field.input_type == 'register_date'"
                                                    v-model:value="model_form.register_date"
                                                    :placeholder="field.placeholder"
                                                    style="display: flex;" 
                                                    :disabled="car_rental_a"/>

                                                <a-input v-else-if="field.input_type == 'driver_age_of_work'"
                                                    v-model:value="model_form.driver_age_of_work"
                                                    :placeholder="field.placeholder"
                                                    :disabled="register_date || car_rental_a"
                                                    readonly />
                                                    <div v-else-if="field.input_type == 'date_of_birth'">
                                                        <a-date-picker 
                                                            v-model:value="model_form[key]" 
                                                            :placeholder="field.placeholder" 
                                                            :disabled="true"
                                                            format="YYYY-MM-DD"
                                                        />
                                                    </div>
                                                <a-divider v-else-if="field.input_type == 'bold'" orientation="left">
                                                    <p> {{ field.label }} </p>
                                                </a-divider>

                                                <a-select v-else-if="field.input_type == 'select_driver_work_ranks'" v-model:value="model_form[key]" :placeholder="field.placeholder" :disabled="car_rental_a">
                                                    <a-select-option value="พนักงานขับรถ (D)">พนักงานขับรถ (D)</a-select-option>
                                                    <a-select-option value="พนักงานขับรถชั่วคราว (DPT)">พนักงานขับรถชั่วคราว (DPT)</a-select-option>
                                                    <a-select-option value="พนักงานบริการประจำรถ (BA)">พนักงานบริการประจำรถ (BA)</a-select-option>
                                                    <a-select-option value="พนักงานบริการประจำรถชั่วคราว (BAPT)">พนักงานบริการประจำรถชั่วคราว (BAPT)</a-select-option>
                                                    <a-select-option value="พนักงานขับรถอาวุโส (SD)">พนักงานขับรถอาวุโส (SD)</a-select-option>
                                                    <a-select-option value="พนักงานบริการประจำรถอาวุโส (SBA)">พนักงานบริการประจำรถอาวุโส (SBA)</a-select-option>
                                                </a-select>
                                                <a-select v-else-if="field.input_type == 'select_driver_prefix_name'" v-model:value="model_form[key]" :placeholder="field.placeholder">
                                                    <a-select-option value="นาย">นาย</a-select-option>
                                                    <a-select-option value="นาง">นาง</a-select-option>
                                                    <a-select-option value="นางสาว">นางสาว</a-select-option>
                                                </a-select>
                                                <a-select v-else-if="field.input_type == 'select_driver_religions'" v-model:value="model_form[key]" :placeholder="field.placeholder">
                                                    <a-select-option value="พุทธ">พุทธ</a-select-option>
                                                    <a-select-option value="คริสต์">คริสต์</a-select-option>
                                                    <a-select-option value="อิสลาม">อิสลาม</a-select-option>
                                                    <a-select-option value="ไม่มีศาสนา">ไม่มีศาสนา</a-select-option>
                                                    <a-select-option value="อื่นๆ">อื่นๆ</a-select-option>
                                                </a-select>
                                                <a-select v-else-if="field.input_type == 'select_driver_educations'" v-model:value="model_form[key]" :placeholder="field.placeholder" @change="(value) => handleEducationChange(value, key)">
                                                    <a-select-option value="ประถมศึกษา">ประถมศึกษา</a-select-option>
                                                    <a-select-option value="มัธยมศึกษา">มัธยมศึกษา</a-select-option>
                                                    <a-select-option value="อาชีวศึกษา">อาชีวศึกษา</a-select-option>
                                                    <a-select-option value="ปริญญาบัณฑิต">ปริญญาบัณฑิต</a-select-option>
                                                    <a-select-option value="บัณฑิตศึกษา">บัณฑิตศึกษา</a-select-option>
                                                    <a-select-option value="อื่นๆ">อื่นๆ</a-select-option>
                                                </a-select>
                                                <a-select v-else-if="field.input_type == 'select_driver_license_type'" v-model:value="model_form[key]" :placeholder="field.placeholder">
                                                    <a-select-option value="ส่วนบุคคล (บ.)">ส่วนบุคคล (บ.)</a-select-option>
                                                    <a-select-option value="ทุกประเภท (ท.)">ทุกประเภท (ท.)</a-select-option>
                                                </a-select>
                                                <a-checkbox-group 
                                                    v-if="field.input_type === 'checkbox_result'"
                                                    v-model:value="model_form[key]" 
                                                    :placeholder="field.placeholder"
                                                    @change="handleCheckboxChange"
                                                >
                                                    <a-checkbox value="ผ่าน">ผ่าน</a-checkbox>
                                                    <a-checkbox value="ไม่ผ่าน">ไม่ผ่าน</a-checkbox>
                                                </a-checkbox-group>
                                                <a-select
                                                    v-else-if="field.input_type == 'select' && selectables[field.modelname]"
                                                    v-model:value="model_form[key]"
                                                    show-search
                                                    :placeholder="field.placeholder"
                                                    :options="selectables[field.modelname].map((e) => ({ value: e.id, label: e[field.label_key] }))"
                                                    :filter-option="filterOption"
                                                    @change="handleChange(null_on_change)"
                                                    :disabled="field.non_editable ? true : false"
                                                ></a-select>

                                                <a-select v-else-if="field.input_type == 'select_driver_bank'" v-model:value="model_form[key]" :placeholder="field.placeholder" :disabled="car_rental_a">
                                                    <a-select-option value="กรุงเทพ">กรุงเทพ</a-select-option>
                                                    <a-select-option value="กสิกรไทย">กสิกรไทย</a-select-option>
                                                    <a-select-option value="กรุงไทย">กรุงไทย</a-select-option>
                                                    <a-select-option value="ไทยพาณิชย์">ไทยพาณิชย์</a-select-option>
                                                    <a-select-option value="ทหารไทย">ทหารไทย</a-select-option>
                                                    <a-select-option value="กรุงศรีอยุธยา">กรุงศรีอยุธยา</a-select-option>
                                                    <a-select-option value="เกียรตินาคิน">เกียรตินาคิน</a-select-option>
                                                    <a-select-option value="อื่นๆ">อื่นๆ</a-select-option>
                                                </a-select>
                                                <TableCreateDrawer 
                                                    v-else-if="field.input_type == 'table'" 
                                                    :divider="field.drawer_title"
                                                    :table_columns="field.table_columns" 
                                                    :target_object="model_form"
                                                    :target_key="key" 
                                                    :drawer_title="field.drawer_title"
                                                    :drawer_fields="field.drawer_fields.inputs"
                                                    :drawer_button_text="field.drawer_button_text"
                                                    :drawer_button_text_edit="field.drawer_button_text_edit"
                                                    :target_modelname="field.target_modelname" 
                                                    class="left-aligned-button">
                                                </TableCreateDrawer>
                                                <!-- <template>
                                                  <table_create_drawer @update:data="updateDrawerData"/>
                                                </template> -->
                                                <a-modal v-model:visible="showOtherEducationModal" title="ระบุระดับการศึกษาอื่นๆ" @ok="handleModalOk" @cancel="handleModalCancel">
                                                    <a-input v-model:value="otherEducationInput" placeholder="ระบุระดับการศึกษาอื่นๆ" />
                                                </a-modal>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-row justify="end">
                                        <a-form-item>
                                            <a-button type="primary" size="large" html-type="submit">
                                                <template #icon>
                                                    <span style="font-size: 20px" class="material-symbols-outlined">save</span>
                                                </template>
                                                บันทึกข้อมูล
                                            </a-button>
                                        </a-form-item>
                                    </a-row>
                                </a-card>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-tab-pane>
            </a-tabs>
            <a-form v-else :model="model_form" :layout="form_layout" :onFinish="confirmAndSubmit">
                <a-row v-if="this.model_type !== 'Car'" justify="center">
                    <a-col v-if="default_fields[model_type].photos" :span="8" style="margin: 1rem">
                        <a-card title="รูปภาพ" style="text-align: center; margin-top: 20px;">
                            <a-row justify="center" :gutter="16">
                                <a-col :span="12">
                                    <a-row justify="center"
                                        v-for="{ key, label, height, width, description } in default_fields[model_type].photos"
                                        :gutter="16">
                                            <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                            <p style="margin-top: 10;">{{ label }}</p>
                                            <a-upload v-model:file-list="fileList" list-type="picture-card"
                                                class="avatar-uploader" :show-upload-list="false"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                @change="upload_files($event, key)" method="PUT"
                                                :before-upload="setFileType"
                                                accept="image/*"
                                                >
                                                <img v-if="model_form[key]" :src="model_form[key]"
                                                    :style="`height: ${height}px;width: ${width}px;object-fit: cover`"
                                                    alt="avatar" />
                                                <div v-else>
                                                    <p class="ant-upload-drag-icon">
                                                        <span class="material-symbols-outlined"
                                                            style="font-size: 5rem">upload_file</span>
                                                    </p>
                                                    คลิกเพื่ออัพโหลดรูปภาพ
                                                </div>
                                            </a-upload>
                                            <a-button danger type="primary" @click="(model_form[key] = '')"
                                                v-if="model_form[key]">
                                                <span class="material-symbols-outlined">remove</span>
                                                ลบ
                                            </a-button>
                                            <p style="color: gray;">{{ description }}</p>
                                        </div> 
                                    </a-row>
                                </a-col>
                                <a-col :span="12" v-show="model_type == 'CarCompany'">
                                    <a-row justify="center" v-for="{ key, label, height, width, description } in default_fields[model_type].photos_payment" :gutter="16">
                                        <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                            <p>{{ label }}</p>
                                            <a-upload v-model:file-list="fileList" list-type="picture-card" 
                                                class="avatar-uploader" :show-upload-list="false"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6" 
                                                @change="upload_files($event, key)" method="GET"
                                                :before-upload="setFileType"
                                                accept="image/*"
                                                >
                                                <img v-if="model_form[key]" :src="model_form[key]" :style="`height: ${height}px;width: ${width}px;object-fit: cover`" alt="avatar" />
                                                <div v-else>
                                                    <p class="ant-upload-drag-icon">
                                                        <span class="material-symbols-outlined" style="font-size: 5rem">upload_file</span>
                                                    </p>
                                                    คลิกเพื่ออัพโหลดรูปภาพ
                                                </div>
                                            </a-upload>
                                            <a-button danger type="primary" @click="(model_form[key] = '')" v-if="model_form[key]">
                                                <span class="material-symbols-outlined">remove</span>
                                                ลบ
                                            </a-button>
                                            <p style="color: gray;">{{ description }}</p>
                                        </div>
                                    </a-row>
                                </a-col>
                            </a-row>
                        </a-card>

                        <a-card  v-if="model_type === 'CarCompany'"  title="รูปภาพที่เกี่ยวข้อง" style="text-align: center; margin-top: 20px;">
                            <a-row justify="center" :gutter="16">
                                <a-col :span="12">
                                    <a-row justify="center" v-for="{ key, label, height, width, description } in default_fields[model_type].photos_social" style="margin: 1rem 0">
                                        <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                            <p>{{ label }}</p>
                                            <a-upload v-model:file-list="fileList" list-type="picture-card" 
                                                class="avatar-uploader" :show-upload-list="false"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6" 
                                                @change="upload_files($event, key)" method="GET"
                                                :before-upload="setFileType"
                                                accept="image/*"
                                                >
                                                <img v-if="model_form[key]" :src="model_form[key]" :style="`height: ${height}px;width: ${width}px;object-fit: cover`" alt="avatar" />
                                                <div v-else>
                                                    <p class="ant-upload-drag-icon">
                                                        <span class="material-symbols-outlined" style="font-size: 5rem">upload_file</span>
                                                    </p>
                                                    คลิกเพื่ออัพโหลดรูปภาพ
                                                </div>
                                            </a-upload>
                                            <a-button danger type="primary" @click="(model_form[key] = '')" v-if="model_form[key]">
                                                <span class="material-symbols-outlined">remove</span>
                                                ลบ
                                            </a-button>
                                            <p style="color: gray;">{{ description }}</p>
                                        </div>
                                    </a-row>
                                </a-col>
                                <a-col :span="12">
                                    <a-row justify="center" v-for="{ key, label, height, width, description } in default_fields[model_type].photos_iso" style="margin: 1rem 0">
                                        <div style="display: flex;flex-direction: column;height: fit-content; margin-bottom: 1rem;">
                                            <p>{{ label }}</p>
                                            <a-upload v-model:file-list="fileList" list-type="picture-card" 
                                                class="avatar-uploader" :show-upload-list="false"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6" 
                                                @change="upload_files($event, key)" method="GET"
                                                :before-upload="setFileType"
                                                accept="image/*"
                                                >
                                                <img v-if="model_form[key]" :src="model_form[key]" :style="`height: ${height}px;width: ${width}px;object-fit: cover`" alt="avatar" />
                                                <div v-else>
                                                    <p class="ant-upload-drag-icon">
                                                        <span class="material-symbols-outlined" style="font-size: 5rem">upload_file</span>
                                                    </p>
                                                    คลิกเพื่ออัพโหลดรูปภาพ
                                                </div>
                                            </a-upload>
                                            <a-button danger type="primary" @click="(model_form[key] = '')" v-if="model_form[key]">
                                                <span class="material-symbols-outlined">remove</span>
                                                ลบ
                                            </a-button>
                                            <p style="color: gray;">{{ description }}</p>
                                        </div>
                                    </a-row>
                                </a-col>
                            </a-row>
                        </a-card>
                    </a-col>

                    <a-col :span="15" style="margin: 1rem; width: 100%;">
                        <a-card title="ข้อมูล">
                            <a-row v-if="this.model_type !== 'Car'">
                                <a-col style="margin: 1rem" :span="col_span" v-for="
                                        {
                                            col_span, non_editable, input_type, search_select, modelname, label_key, label, place, placeholder, maxlength, required,
                                            target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                            on_change,bank_type,step
                                        }, key in default_fields[model_type].inputs">
                                    <div v-if="input_type== 'label'">{{ label }}</div>
                                    <div v-else-if="bank_type">
                                        <div v-if="key == 'type_payment_id'" style="display: flex; align-items: center;">
                                            <span style="margin-right: 8px;">ประเภทการชำระเงิน :</span>
                                            <a-radio-group 
                                                v-model:value="model_form[key]"
                                                :options="selectables['TypePayment']?.map(option => ({ label: option.label, value: option.id }))"
                                            />
                                        </div>
                                        <div v-if="model_form['type_payment_id'] == 1 && bank_type == 1">
                                            <a-form-item :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                                :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                                <a-select v-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select v-else-if="key === 'bank_Type_id'" v-if="model_form['type_payment_id'] == 1" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['getAllBankBranches']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                                    :type="input_type"
                                                    :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                                />
                                            </a-form-item>
                                        </div>
                                        <div v-else-if="model_form['type_payment_id'] == 2 && bank_type == 2">
                                            <a-form-item :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                                :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                                <a-input v-model:value="model_form[key]" :placeholder="placeholder"
                                                    :type="input_type"
                                                    :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                                />
                                            </a-form-item>
                                        </div>
                                    </div>
                                    <a-form-item
                                        v-else
                                        :name="key"
                                        :label="placeholder"
                                        :has-feedback="!!model_form[key] && check_duplicate" 
                                        :rules="non_editable ? null : arrays_old_rule.includes(model_type) ? check_rule : [
                                            { required, message: `โปรดระบุ ${placeholder}`, trigger: ['change', 'blur'] },
                                            ...computedRules(key)
                                        ]"
                                        >
                                        <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                            <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                                {{ option.name }} 
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="key === 'car_company_id'" 
                                                v-model:value="model_form[key]" 
                                                show-search 
                                                :placeholder="placeholder"
                                                :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                                :filter-option="filterOption"
                                                @change="handleChange(null_on_change)">
                                            <a-select-option 
                                                v-for="option in selectables['CarCompany']" 
                                                :key="option.id" 
                                                :value="option.id">
                                                {{ option.fullname }}
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                                v-model:value="model_form[key]" 
                                                show-search 
                                                :placeholder="placeholder"
                                                :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                                :filter-option="filterOption"
                                                @change="handleChange(null_on_change)">
                                            <a-select-option 
                                                v-for="option in selectables[modelname]" 
                                                :key="option.id" 
                                                :value="option.id">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-input v-else-if="key === 'withdraw_type_id' && model_type == 'StockHistory'"  value="เบิกออก" 
                                            type="text"
                                            :disabled="true"
                                        />
                                        <a-input v-else-if="key === 'withdraw_type_id' && model_type == 'Part'"  value="เบิกเข้า" 
                                            type="text"
                                            :disabled="true"
                                        />
                                        <a-select v-else-if="key === 'withdraw_type_id' && model_type != 'StockHistory' && model_type != 'Part'" 
                                                v-model:value="model_form[key]" 
                                                show-search 
                                                :placeholder="placeholder"
                                                :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                                :filter-option="filterOption"
                                                :disabled="true"
                                                @change="handleChange(null_on_change)">
                                            <a-select-option 
                                                v-for="option in selectables['WithdrawType']" 
                                                :key="option.id" 
                                                :value="option.id">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-date-picker
                                            v-else-if="key === 'withdrawed_at' && model_type == 'StockHistory'"
                                            v-model:value="model_form[key]"
                                            :disabled="model_form.withdraw_status_id === 2 || this.model_form?.withdraw_status_id === 3 || this.model_form?.withdraw_status_id === 4"
                                            placeholder="ระบุวันที่เบิก"
                                            format="YYYY-MM-DD"
                                        />
                                        <a-textarea
                                            v-else-if="key === 'remark' && model_type == 'StockHistory'"  
                                            v-model:value="model_form[key]"
                                            :disabled="model_form.withdraw_status_id === 2 || this.model_form?.withdraw_status_id === 3 || this.model_form?.withdraw_status_id === 4"
                                            placeholder="หมายเหตุ"
                                            style="resize: vertical;"
                                        />
                                        <a-select v-else-if="key === 'tour_type_id'" 
                                                v-model:value="model_form[key]" 
                                                show-search 
                                                :placeholder="placeholder"
                                                :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                                :filter-option="filterOption"
                                                @change="handleChange(null_on_change)">
                                            <a-select-option 
                                                v-for="option in selectables['TourType']" 
                                                :key="option.id" 
                                                :value="option.id">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-row v-else-if="key === 'color_id'" gutter="16">
                                                    <template v-if="selectables['Colorrandom'] && selectables['Colorrandom'].length > 0">
                                                        <a-col 
                                                            v-for="color in selectables['Colorrandom']" 
                                                            :key="color.color_id" 
                                                            @click="handleColorSelect(color)"
                                                            :span="6"
                                                            style="cursor: pointer; border: 1px solid #ddd; border-radius: 5px; padding: 5px; text-align: center; margin-bottom: 10px;">
                                                            <div 
                                                                :style="{ 
                                                                    width: '100%', 
                                                                    height: '20px', 
                                                                    backgroundColor: color.color
                                                                }">
                                                            </div>
                                                        </a-col>
                                                        <a-col :span="6">
                                                            <a-tooltip title="Reset Color">
                                                                <div 
                                                                    @click="resetColor"
                                                                    style="cursor: pointer; display: flex; align-items: center; justify-content: center; width: 35px; height: 35px; border: 1px solid #ddd; border-radius: 50%; background: #f5f5f5;">
                                                                    <reload-outlined style="font-size: 20px; color: #555;" />
                                                                </div>
                                                            </a-tooltip>
                                                        </a-col>
                                                    </template>

                                                    <!-- กรณีไม่มีสีให้เลือก -->
                                                    <template v-else>
                                                        <a-col :span="6">
                                                            <div style="text-align: center; color: #888; font-size: 14px; border: 1px solid #ddd; padding: 5px; border-radius: 2px;">
                                                                ไม่มีสี
                                                            </div>
                                                        </a-col>
                                                    </template>
                                                </a-row>
                                        <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                            <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                                {{ item.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                            <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)" :disabled="(this.$route.params.id != 'create' && model_type == 'CarCompany')">
                                            <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="key === 'bank_id'"  v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                            <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="key === 'bank_Type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                                    <a-select-option v-for="option in selectables['getAllBankBranches']" :key="option.id" :value="option.id">
                                                        {{ option.name }}
                                                    </a-select-option>
                                                </a-select>
                                        <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                            <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="key === 'client_id'" 
                                            show-search v-model:value="model_form[key]" 
                                            @change="handleChange(null_on_change , on_change)" 
                                            :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption">
                                            <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                                {{ option.fullname }}
                                            </a-select-option>
                                        </a-select>
                                        <div v-else-if="key === 'type_payment_id'" style="display: flex; align-items: center;">
                                            <a-radio-group 
                                                v-model:value="model_form[key]"
                                                :options="selectables['TypePayment']?.map(option => ({ label: option.label, value: option.id }))"
                                            />
                                        </div>
                                        <a-select
                                            v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                            v-model:value="model_form[key]"
                                            show-search
                                            :placeholder="placeholder"
                                            :options="modelname == 'Driver' ? selectables[modelname]
                                                .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                                .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                                selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)"
                                        ></a-select>
                                        <a-select v-else-if="input_type == 'sub_select'"
                                            v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                            <a-select-option 
                                                v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                                :value="id" 
                                                selected
                                            >
                                                {{ name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-checkbox-group v-else-if="input_type == 'checkbox'"
                                            v-model:value="model_form[key]"
                                            :options="selectables[modelname]?.map(option => { return { label: option[label_key], value: option.id } })" />
                                        <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                        }}</a-divider>
                                        <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                            <h5>{{ label }}</h5>
                                        </a-divider>
                                        <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                            :table_columns="table_columns" :target_object="model_form"
                                            :target_key="target_key" :drawer_title="drawer_title"
                                            :drawer_fields="drawer_fields.inputs"
                                            :drawer_button_text="drawer_button_text"
                                            :drawer_button_text_edit="drawer_button_text_edit"
                                            :target_modelname="target_modelname" 
                                            :withdraw_status_id="model_form.withdraw_status_id"/>
                                        <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                            :placeholder="placeholder" style="display: flex;"
                                            format="DD/MM/YYYY"
                                            :disabled="action_type == 'create' ? false : non_editable" />
                                        <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                            :placeholder="placeholder"
                                            :show-time="{ format: 'HH:mm' }"
                                            format="DD/MM/YYYY HH:mm"
                                            :disabled="action_type == 'create' ? false : non_editable" />
                                        <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                            :placeholder="placeholder" style="display: flex;"
                                            picker="month"
                                            format="MMMM"
                                            :disabled="action_type == 'create' ? false : non_editable" />
                                        <a-row v-else-if="input_type == 'switch'" type="flex" justify="center" :style="{ marginTop: '30px' }">
                                                <a-col>
                                                <a-checkbox
                                                    :disabled="start || (this.$route.params.id != 'create' && model_type == 'CarCompany')"  
                                                    v-model:checked="model_form[key]" 
                                                    @change="handleChange('end', $event)" 
                                                    :placeholder="placeholder"  
                                                    value="บริษัทรถร่วม"  
                                                >
                                                    บริษัทรถร่วม
                                                </a-checkbox>
                                            </a-col>
                                        </a-row>

                                        <a-switch v-else-if="input_type == 'switch'" 
                                            v-model:checked="model_form[key]"
                                            :placeholder="placeholder"
                                            :disabled="action_type == 'create' ? false : non_editable" /> 
                                        <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                            :placeholder="placeholder"
                                            :disabled="action_type == 'create' ? false : non_editable" />
                                        <div v-else-if="input_type === 'textlabel'">
                                            <!-- <div style="padding:0 0 8px;line-height: 1.5715; white-space:initial;text-align:left;">{{ label }}</div> -->
                                            <a-input :placeholder="place" v-model:value="model_form[key]" :required="required" />
                                        </div>
                                        <div v-else-if="input_type == 'photos'" class="clearfix">
                                            <a-upload v-model:file-list="model_form[target_key]"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                @change="upload_files($event, key)" method="GET"
                                                @remove="remove_uploaded_file($event)"
                                                list-type="picture-card">
                                                <div v-if="model_form[target_key]?.length < 5"
                                                    style="height: 104px; width: 104px; padding: 2rem">
                                                    <span style="font-size: 20px"
                                                        class="material-symbols-outlined">add</span>
                                                    <div style="margin-top: 8px">Upload</div>
                                                </div>
                                            </a-upload>
                                        </div>
                                        <div v-else-if="input_type === 'maxtext'">
                                            <a-input :placeholder="place" v-model:value="model_form[key]" @input="formatPhoneNumber(key)" />
                                        </div>
                                        <div v-else-if="input_type === 'empty'" style="display: none"></div>
                                        <a-select v-else-if="key === 'bank'"  
                                                v-model:value="model_form[key]" 
                                                show-search 
                                                placeholder="เลือกธนาคาร"
                                                :options="selectables['Bank']?.map(e => ({ value: e.name, label: e.name }))"
                                                :filter-option="filterOption"
                                                @change="handleChange(null_on_change)">
                                            <a-select-option 
                                                v-for="option in selectables['Bank']"  
                                                :key="option.name" 
                                                :value="option.name">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select>
                                        <a-select v-else-if="key === 'account_type'"  
                                                v-model:value="model_form[key]" 
                                                show-search 
                                                placeholder="เลือกประเภทบัญชี"
                                                :options="accountTypes?.map(e => ({ value: e.label, label: e.label }))"
                                                :filter-option="filterOption"
                                                @change="handleChange(null_on_change)">
                                            <a-select-option 
                                                v-for="option in accountTypes"
                                                :key="option.label" 
                                                :value="option.label">
                                                {{ option.label }}
                                            </a-select-option>
                                        </a-select>
                                        <!-- <a-select v-else-if="key === 'bank'" v-model:value="model_form[key]" placeholder="เลือกธนาคาร" @change="handleChange(null_on_change , on_change)">
                                            <a-select-option v-for="option in selectables['Bank']" :key="option.name" :value="option.name">
                                                {{ option.name }}
                                            </a-select-option>
                                        </a-select> -->
                                        <!-- <a-select v-else-if="key === 'account_type'" v-model:value="model_form[key]" placeholder="เลือกประเภทบัญชี" @change="handleChange(null_on_change , on_change)">
                                            <a-select-option :value="1" label="บัญชีเงินฝากออมทรัพย์">บัญชีเงินฝากออมทรัพย์</a-select-option>
                                            <a-select-option :value="2" label="บัญชีเงินฝากประจำ">บัญชีเงินฝากประจำ</a-select-option>
                                            <a-select-option :value="3" label="บัญชีเงินฝากประจำรายเดือนแบบปลอดภาษี">บัญชีเงินฝากประจำรายเดือนแบบปลอดภาษี</a-select-option>
                                            <a-select-option :value="4" label="บัญชีเงินฝากกระแสรายวัน">บัญชีเงินฝากกระแสรายวัน</a-select-option>
                                            <a-select-option :value="5" label="บัญชีเงินตราระหว่างประเทศ">บัญชีเงินตราระหว่างประเทศ</a-select-option>
                                            <a-select-option :value="6" label="บัญชีเงินฝากแบบขั้นบันได">บัญชีเงินฝากแบบขั้นบันได</a-select-option>
                                        </a-select> -->
                                        <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                            <div>{{ label }}</div>
                                            <a-upload 
                                                v-model:file-list="fileList"
                                                :show-upload-list="false"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                @change="upload_files($event, key)" 
                                                method="GET"
                                                :before-upload="setFileType"
                                                accept="image/*"
                                            >
                                                <div v-if="model_form[key]" class="upload-container">
                                                    <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                    <div class="icon-container">
                                                        <span
                                                            class="material-symbols-outlined preview-icon"
                                                            @click="handleIconClick('preview', model_form[key], $event)"
                                                        >
                                                            visibility
                                                        </span>
                                                        <a :href="model_form[key]" download @click.stop>
                                                            <span class="material-symbols-outlined download-icon"
                                                        >
                                                                download
                                                            </span>
                                                        </a>
                                                        <span
                                                            class="material-symbols-outlined delete-icon"
                                                            @click="handleIconClick('delete', key, $event)"
                                                        >
                                                            delete
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                    <p class="ant-upload-drag-icon">
                                                        <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                    </p>
                                                    คลิกเพื่ออัพโหลดรูปภาพ
                                                </div>
                                            </a-upload>
                                            <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                                <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                            </a-modal>
                                        </div>
                                        <a-divider v-else-if="input_type == 'document'" orientation="left">{{ label
                                                }}</a-divider>
                                        <!-- upload_file -->
                                        <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                            <div>{{ label }}</div>
                                            <a-upload 
                                                v-model:file-list="fileList" 
                                                v-if="!model_form[key]"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                method="GET"
                                                :show-upload-list="false"
                                                @change="upload_files($event, key)"
                                            >
                                                <img v-if="model_form[key]" :src="model_form[key]"
                                                    style="width: 100%; height: 100px;"
                                                    alt="avatar"
                                                />
                                                <div style="display: flex; flex-direction: column; align-items: center;">
                                                    <p class="ant-upload-drag-icon">
                                                        <span class="material-symbols-outlined" 
                                                            style="font-size: 5rem;">upload_file</span>
                                                    </p>
                                                    อัพโหลดไฟล์
                                                </div>
                                            </a-upload>
                                            <a :href="model_form[key]" v-else="model_form[key]"
                                                target="_blank" rel="doc"
                                            >
                                                {{ model_form[`${key}_file_name`] }}
                                            </a>
                                            <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                                v-if="model_form[key]">
                                                <span class="material-symbols-outlined">close</span>
                                            </a-button>
                                        </div>
                                        <div  v-else-if="input_type == 'table_files'" >
                                            <a-table
                                                :columns="[
                                                    {
                                                        title: 'ชื่อเอกสาร',
                                                        dataIndex: 'name',
                                                        key: 'name',
                                                        width: 400,
                                                    },
                                                    {
                                                        title: 'ไฟล์เอกสาร',
                                                        dataIndex: 'file',
                                                        key: 'file',
                                                    },
                                                    {
                                                        title: 'ลบ',
                                                        dataIndex: 'id',
                                                        key: 'id',
                                                        width: 100,
                                                        align: 'center',
                                                    }
                                                ]"
                                                :dataSource="data_raw_files"
                                                :pagination="false"
                                                :scroll="{ y: 240 }"
                                            >
                                                <template #bodyCell="{ column, record, index}" >
                                                    <template v-if="column.key === 'name'">
                                                        <a-form-item>
                                                            <a-input v-model:value="record.name"
                                                            />
                                                        </a-form-item>
                                                    </template>
                                                    <template v-if="column.key === 'file'">
                                                        <a-form-item>
                                                            <a
                                                            href="#"
                                                            @click.prevent="downloadFile(record)"
                                                            >{{ record.file_name }}</a>
                                                        </a-form-item>
                                                    </template>
                                                    <template v-if="column.key === 'id'">
                                                        <a-form-item>
                                                            <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                                <span class="material-symbols-outlined">delete</span>
                                                            </a-button>
                                                        </a-form-item>
                                                    </template>
                                                </template>
                                            </a-table>
                                            <a-upload v-model:file-list="model_form[key]"
                                                action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                                method="GET"
                                                @change="upload_file_multiple($event, key)"
                                                :show-upload-list="false"
                                                :accept="this.model_type === 'CarCompany' ? '.pdf' :'.pdf, .png, .jpg, .jpeg'"
                                                >
                                                <a-button style="margin-top: 10px;">
                                                    <span class="material-symbols-outlined">add</span>
                                                    เพิ่มไฟล์
                                                </a-button>
                                            </a-upload>
                                        </div>
                                        <div v-else-if="input_type== 'password'">
                                            <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                                :placeholder="placeholder" 
                                                :type="input_type"
                                                :disabled="action_type == 'create' ? false : non_editable"
                                                autoComplete="new-password"
                                            />
                                            <a-input-password v-else v-model:value="model_form[key]" 
                                                :placeholder="placeholder" 
                                                :type="input_type"
                                                :disabled="action_type == 'create' ? false : non_editable"
                                                autoComplete="new-password"
                                            />
                                        </div>
                                        <a-input-number v-else-if="input_type == 'number' && step" 
                                            v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :style="{ width: '100%' }"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            :step="step || 0.01"
                                        />
                                        <a-input v-else v-model:value="model_form[key]" :placeholder="key == 'email'? placeholder + 'เช่น example@gmail.com':key == 'fax_no'? 'เบอร์แฟกซ์ เช่น 021234567' : placeholder"
                                            :type="input_type"
                                            :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>

                            <a-row justify="end" v-if="!isWithdrawCanceled">
                                <a-form-item>
                                    <a-button type="primary" size="large" html-type="submit" :disabled="disableConfirmButton">
                                        <template #icon>
                                            <span style="font-size: 20px; color: white" class="material-symbols-outlined">save</span>
                                        </template>
                                        บันทึกข้อมูล
                                    </a-button>
                                </a-form-item>
                            </a-row>
                        </a-card>
                    </a-col>
                </a-row>
                <a-collapse v-if="this.model_type === 'Car'" class="add_car" style="border-radius: 4px" v-model:activeKey="activeKey">
                    <a-collapse-panel key="1" :header="`ข้อมูลรถ`">
                        <template #extra>
                            <p v-if="requireCarFields" style="margin: 0; color: grey">
                                {{ `(ต้องระบุอีก ${requireCarFields})` }}
                            </p>
                        </template>
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required, place,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.Car.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_source_id' && logistic_a" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="carSoureLogisticA?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in carSoureLogisticA" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>

                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" placeholder="ประเภทรถ" @change="handleChange('CarType' , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <div v-else-if="key === 'car_company_id'" style="margin-left: -20px;">
                                        <label for="car_company_id">บริษัทรถ</label>
                                        <a-select id="car_company_id" v-model:value="model_form[key]"
                                                :key="car_company.length" 
                                                :disabled="disabletest || this.$route.params.id != 'create'"
                                                @change="handleChange(null_on_change , on_change)">
                                            <a-select-option
                                                v-for="(company, index) in car_company"
                                                :key="company.id"
                                                :value="company.id"
                                            >
                                                {{ company.fullname }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                    <div v-else-if="key === 'topic_truck_size'" style="position: relative; display: inline-block;">ขนาดของตู้บรรทุก (หน่วยเป็นเมตร) :</div>
                                    <div v-else-if="key === 'car_width'">
                                        <a-input v-model:value="model_form[key]" :placeholder="placeholder"/>
                                    </div>
                                    <div v-else-if="key === 'car_length'">
                                        <a-input v-model:value="model_form[key]" :placeholder="placeholder"/>
                                    </div>
                                    <div v-else-if="key === 'car_height'">
                                        <a-input v-model:value="model_form[key]" :placeholder="placeholder"/>
                                    </div>
                                    <div v-else-if="key === 'consumption_rate' || key === 'unit'">
                                        <a-input v-model:value="model_form[key]" :placeholder="placeholder" :disabled="true"/>
                                    </div>
                                    <a-date-picker v-else-if="key === 'start_gas_date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="true" />
                                    <div v-else-if="key === 'remark_gas'">
                                        <a-input v-model:value="model_form[key]" :placeholder="placeholder" @change="handleChange('remark_gas', $event)"/>
                                    </div>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => {
                                                const isCarAvailable = !usedDriver.some((ud)=> ud.id == driver.id) || driver.id === model_form[key];
                                                const isCompanyMatch = model_form['company_3rd'] === 'บริษัทรถร่วม'
                                                    ? driver.company_3rd === 'บริษัทรถร่วม'
                                                    : true;
                                                const isCarCompanyMatch = model_form['car_company_id'] == driver.car_company_id;
                                                return isCarAvailable && isCompanyMatch && isCarCompanyMatch;
                                            })
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(modelname, null_on_change)"
                                    > </a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-checkbox-group v-else-if="key == 'company_3rd'" v-model:value="model_form[key]" style="margin-top: 12px;">
                                        <a-checkbox
                                            @change="handleChange('disable', $event, field)"
                                            v-model="model_form[key]"
                                            value="บริษัทรถร่วม"
                                            :disabled="this.$route.params.id != 'create'"
                                        >
                                            บริษัทรถร่วม
                                        </a-checkbox>
                                    </a-checkbox-group>
                                    <div v-else-if="input_type === 'textlabel'">
                                            <!-- <div style="padding:0 0 8px;line-height: 1.5715; white-space:initial;text-align:left;">{{ label }}</div> -->
                                            <a-input :placeholder="place" v-model:value="model_form[key]" :required="required" />
                                        </div>
                                    <div v-else-if="key === 'check_head_registration'" style="display: flex; align-items: center; gap: 12px; flex-wrap: nowrap;">
                                    <a-checkbox
                                        @change="handleChangeregistration('head', $event, field)"
                                        v-model:value="model_form[key]"
                                        style="display: inline-flex; white-space: nowrap;"
                                        value="ทะเบียนหัว"
                                    >
                                        ทะเบียนหัว:
                                    </a-checkbox>

                                    <!-- Input -->
                                    <a-input
                                        v-model:value="model_form.head_registration"
                                        :placeholder="'ทะเบียนหัว'"
                                        style="width: 800px;"
                                        :disabled="headRegistration"
                                    />

                                    <!-- Checkbox ทะเบียนหาง -->
                                    <a-checkbox
                                        @change="handleChangeregistration('tail', $event, field)"
                                        v-model:value="model_form.check_tail_registration"
                                        style="display: inline-flex; white-space: nowrap;"
                                        value="ทะเบียนหาง"
                                    >
                                        ทะเบียนหาง:
                                    </a-checkbox>
                                    <a-input
                                        v-model:value="model_form.tail_registration"
                                        :placeholder="'ทะเบียนหาง'"
                                        style="width: 800px;"
                                        :disabled="tailRegistration"
                                    />
                                    </div>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_file_car($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]?.[0]?.file || '#'" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[key]?.[0]?.file_name }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>

                    <a-collapse-panel key="2" :header="`ข้อมูลด้านประกันภัย`">
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change, step
                                    }, key in default_fields.Insure.inputs">
                                <div v-if="input_type== 'label'" style="font-weight: bold; color: #1d39c4;">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_company_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['CarCompany']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_files($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[`${key}_file_name`] }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files_insure"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                        <a :href="record.file" :download="record.file_name" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files_insure.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    <a-input-number 
                                        v-else-if="input_type == 'number' && step" 
                                        v-model:value="model_form[key]" 
                                        :placeholder="placeholder" 
                                        :style="{ width: '100%' }"
                                        :disabled="action_type == 'create' ? false : non_editable"
                                        :step="step || 0.01"
                                    />
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>

                    <a-collapse-panel v-if="business !==4" key="3" :header="`ข้อมูลด้านทะเบียน / ชำระภาษี`">
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.RegistrationAndTax.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_company_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['CarCompany']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_files($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[`${key}_file_name`] }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>

                    <a-collapse-panel key="4" :header="logistic_a ? `Fuel card & GPS Brand`:`Fleet oil & Sim GPS`">
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.FleetAndSim.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_company_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['CarCompany']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_file_car($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key][0].file" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[key][0].file_name }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>

                    <a-collapse-panel key="5" :header="`เอกสารสำคัญต่างๆ`">
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.Document.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_company_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['CarCompany']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_files($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[`${key}_file_name`] }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>

                    <a-collapse-panel key="6" :header="`ข้อมูลออฟชั่นรถ`" v-if="car_rental_a">
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.Option.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_company_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['CarCompany']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                        
                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-checkbox-group v-else-if="input_type == 'checkbox'"
                                        v-model:value="model_form[key]"
                                        :options="optionsList"/>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_files($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[`${key}_file_name`] }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>

                    <a-collapse-panel key="7" :header="`รูปพรรณ`" v-if="car_rental_a">
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.Appearance.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_company_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['CarCompany']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                   
                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_files($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[`${key}_file_name`] }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>

                    <a-collapse-panel key="8" :header="`เครื่องยนต์`" v-if="car_rental_a">
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.Engine.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'work_status_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DriverStatus']" :key="option.id" :value="option.id">
                                            {{ option.name }} 
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_company_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['CarCompany']?.map(e => ({ value: e.id, label: e.fullname }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['CarCompany']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="['vendor_id', 'part_unit_id', 'part_type_id'].includes(key)"
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables[modelname]?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables[modelname]" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withdraw_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['WithdrawType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['WithdrawType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'tour_type_id'" 
                                            v-model:value="model_form[key]" 
                                            show-search 
                                            :placeholder="placeholder"
                                            :options="selectables['TourType']?.map(e => ({ value: e.id, label: e.name }))"
                                            :filter-option="filterOption"
                                            @change="handleChange(null_on_change)">
                                        <a-select-option 
                                            v-for="option in selectables['TourType']" 
                                            :key="option.id" 
                                            :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    
                                    <a-select v-else-if="key === 'sex'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="(item, i) in sex_types" :key="i" :value="item.name">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'driving_license_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['DrivingLicenseType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'withholding_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Withholding']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'bank_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['Bank']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'car_type_id'" v-model:value="model_form[key]" @change="handleChange(null_on_change , on_change)">
                                        <a-select-option v-for="option in selectables['CarType']" :key="option.id" :value="option.id">
                                            {{ option.name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select v-else-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => driver.car_id === null || driver.id === model_form[key])
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        format="DD/MM/YYYY"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_files($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[`${key}_file_name`] }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>
                </a-collapse>
                <a-row v-if="this.model_type === 'Car' && requireCarFields == 0" justify="end" style="margin-top: 14px;">
                    <a-form-item>
                        <a-button type="primary" size="large" html-type="submit">
                            <template #icon>
                                <span style="font-size: 20px; color: white" class="material-symbols-outlined">save</span>
                            </template>
                            บันทึกข้อมูล
                        </a-button>
                    </a-form-item>
                </a-row>
                <a-row v-if="this.model_type === 'Car' && requireCarFields > 0" justify="end" style="margin-top: 14px;">
                    <a-form-item>
                        <a-button type="primary" size="large" @click="showRequireFiledsCarInfo = true">
                            <template #icon>
                                <span style="font-size: 20px; color: white" class="material-symbols-outlined">save</span>
                            </template>
                            บันทึกข้อมูล
                        </a-button>
                    </a-form-item>
                </a-row>
             </a-form>
        </a-card>
        <a-modal v-model:visible="showRequireFiledsCarInfo" @ok="showRequireFiledsCarInfo=false" >
            <div style="display: flex; flex-direction: column ;justify-items:center;align-items: center">
                <span class="material-symbols-outlined" style="font-size: 50px;margin-right: 4px;color:red;margin-bottom: 5px">Info</span>
                <p>กรุณาระบุข้อมูลรถ</p>
            </div>
            <template #footer>
                <a-button type="primary" @click="showRequireFiledsCarInfo=false">
                ตกลง
                </a-button>
            </template> 
        </a-modal>
        <a-modal 
            v-model:visible="showAlertSubmit" 
            :footer="null"
            :width="450"
            :centered="true"
            >
            <div style="display: flex; flex-direction: column ;justify-items:center;align-items: center">
                <p style="font-size: x-large; margin-bottom: 10px; margin-top: 50px;">คุณแน่ใจหรือไม่ที่จะบันทึกข้อมูลนี้?</p>
                <p> {{this.model_type == "CarCompany" ? 'เมื่อบันทึกแล้วจะไม่สามารถแก้ไขบริษัทรถที่เลือกไว้ได้ในภายหลัง' : 'เมื่อบันทึกแล้วจะไม่สามารถแก้ไขบริษัทหรือรถที่เลือกไว้ได้ในภายหลัง'}}</p>
            </div>
            <div style="display: flex; justify-content: center; gap: 8px; margin-top: 10px; margin-bottom: 30px;">
                <a-button type="primary"
                    :style="{ borderRadius: '5px' }"
                    @click="submit_model_data()">
                    ยืนยันบันทึก
                </a-button>
                <a-button type="danger" 
                    :style="{ borderRadius: '5px' }"
                    @click="showAlertSubmit=false">
                    ยกเลิก
                </a-button>
            </div> 
        </a-modal>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import SystemService from '../../api/SystemService'
import TableCreateDrawer from '@/components/table_create_drawer.vue'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
dayjs.extend(buddhistEra);
import CarField from '../../field_config/car_fields'
import CarFieldLogistic from '../../field_config/car_fields_logistic'
import InsureField from '../../field_config/insure_fields'
import RegistrationAndTaxField from '../../field_config/registration_and_tax_fields'
import FleetAndSimField from '../../field_config/fleet_and_sim_fields'
import DocumentField from '../../field_config/document_fields'
import OptionField from '../../field_config/option_fields'
import AppearanceField from '../../field_config/appearance_fields'
import EngineField from '../../field_config/engine_fields'

import DriverService from '../../api/DriverService.js'
import WithholdingService from '../../api/WithholdingService.js'
import BankService from '../../api/BankService.js'
import DriverInfo from '../../api/DriverInfo'
import CarService from '../../api/CarService'
import { ReloadOutlined } from '@ant-design/icons-vue';
import CarCompanyService from '../../api/CarCompanyService'
import UserService from '../../api/UserService'
import CompanyService from '../../api/CompanyService'
import CarTypeService from '../../api/CarTypeService'
import CheckInHistoryService from '../../api/CheckInHistoryService'
import { validateBarcode, validateCarRepairType, validateCarTypeName, validateDecimal, validateEmail, validateFaxNo, validateNumber, validatePart, validatePartType, validatePhoneNo, validateTaxId } from '../../components/helpers'
export default {
    components: {
    ReloadOutlined, 
    TableCreateDrawer, 
  },    props: {
        create: Boolean,
        model: String,
        model_data: Object,
    },
    name: 'update_or_create',
    computed: {
        isWithdrawCanceled() {
            return this.model_form?.withdraw_status_id === 2 || this.model_form?.withdraw_status_id === 3 || this.model_form?.withdraw_status_id === 4;
        },
        requireCarFields() {
            const fieldsToCheck = ['car_type_id', 'plate_no'];
            return fieldsToCheck.filter(field => !this.model_form[field]).length;
        },
        isStartSelected() {
            return this.start;
        },
        isEndSelected() {
            return this.end;
        },
        model_type() {
            return this.$route.params.model
        },
        action_type() {
            return this.$route.params.id
        },
        title() {
            return this.default_fields[this.$route.params.model].title[this.$route.params.id] ?
                this.default_fields[this.$route.params.model].title[this.$route.params.id] :
                `${this.default_fields[this.$route.params.model].title['edit']}`
        },
        form_layout() {
            const model_horizontal_form = ['Car']
            if(model_horizontal_form.includes(this.model_type)) {
                return 'horizontal'
            }else{
                return 'vertical'
            }
        },
        calculatedAge() {
            const birthDate = this.model_form.date_of_birth;
            if (!birthDate) return '';
            const today = dayjs();
            const birth = dayjs(birthDate);
            let age = today.year() - birth.year();
            const m = today.month() - birth.month();
            if (m < 0 || (m === 0 && today.date() < birth.date())) {
                age--;
            }
            return age;
        },
        filteredDrivingLicenseTypes() {
            return this.selectables['DrivingLicenseType'].filter(option => [1, 2, 3].includes(option.id));
        },
        disableConfirmButton() {
        const isPartHistoryEmpty = this.model_type === 'StockHistory' && this.action_type === 'create' && (!this.model_form['part_histories'] || this.model_form['part_histories']?.length === 0);
        return isPartHistoryEmpty;
        },
        isAddPartDisabled() {
        const drawerData = this.drawer_create_data;
        const selectedPart = this.part_list.find(p => p.id === drawerData.part_id);
        if (!selectedPart) return false;

        const usedAmount = this.model_form.part_histories
        ?.filter(p => p.part_id === drawerData.part_id)
        ?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;

        const available = Math.max((selectedPart.amount || 0) - usedAmount, 0);
        return drawerData.amount > available;
    },
    },
    watch: {
        'model_form.price': {
            handler(newVal) {
            if (newVal !== undefined && newVal !== null && newVal !== '') {
                const parsed = parseFloat(newVal);
                if (!isNaN(parsed)) {
                this.model_form.price = Math.trunc(parsed).toString();
                }
            }
            },
            immediate: false,
        },
        business: {
            handler(newValue) {
                if (this.business === 4) {  
                    this.BasedOnBusiness(); 
                    return;  
                } else {
                    this.updateFieldsBasedOnBusiness(newValue);  
                }
            },
            immediate: true,
            deep: true 
        },  
        car_rental_a: {
            handler(newValue) {
                this.updateFieldBusiness4(newValue);
            },
        immediate: true
        },
    'selectables.Colorrandom': {
        handler(newVal, oldVal) {
            if (Array.isArray(newVal) && newVal.length > 0) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                    return;
                }
                if (!this.model_form['color_id']) {
                    const lastColor = newVal[newVal.length - 1];
                    this.model_form['color_id'] = lastColor?.id || null;
                    this.selectables['Colorrandom'] = [lastColor];
                } else {
                    const matchingColor = newVal.find(color => color.id === this.model_form['color_id']);
                    this.selectables['Colorrandom'] = matchingColor ? [matchingColor] : [];
                }
            } else {
                this.model_form['color_id'] = null;
            }
        },
        immediate: true // ทำงานทันที
    },
         'model_form.register_date': function(newDate) {
            if (newDate) {
                this.updateWorkAge();
            } else {
                this.model_form.driver_age_of_work = '';
            }
        },
        start(newVal) {
            if (newVal) {
                this.end = false;
            }
        },
        end(newVal) {
            if (newVal) {
                this.start = false;
            }
        }
    },
    data() {
        return {
            stockHistoryData: {
            part_histories: []
            },
            accountTypes: [
                { value: 1, label: "บัญชีเงินฝากออมทรัพย์" },
                { value: 2, label: "บัญชีเงินฝากประจำ" },
                { value: 3, label: "บัญชีเงินฝากประจำรายเดือนแบบปลอดภาษี" },
                { value: 4, label: "บัญชีเงินฝากกระแสรายวัน" },
                { value: 5, label: "บัญชีเงินตราระหว่างประเทศ" },
                { value: 6, label: "บัญชีเงินฝากแบบขั้นบันได" },
            ],
            carSoureLogisticA: [
                {id: 1, name: "เช่า"},
                {id: 2, name: "ประกอบการ"},
                {id: 3, name: "รถให้เช่า"}
            ],
            showRequireFiledsCarInfo: false,
            optionsList: [],
            showAlertSubmit: false,
            disableId: "บริษัทรถ",
            car_company_3rd: [],
            companyId: 0,
            activeKey: [],
            disabletest: true,
            isLoading: false,
            start: false,
            end: false,
            business: false,
            car_rental_a: false,
            headRegistration: true,
            tailRegistration: true,
            car_list: [],
            register_date: null,
            driver_age_of_work: null,
            model_form: {
                driver_stoped_employment_date: null
            },
            today: new Date(),
            company_id: JSON.parse(localStorage.getItem('companyData')).id,
            permissions:"1",
            previewVisible: false,
            previewImage: '',
            fileList: [],
            data_raw_files: [],
            data_raw_files_insure: [],
            default_rules: [],
            car_company: [],
            myArray: [],
            is_check_license: 0,
            default_fields: {
                Sale: {
                    title: {
                        create: 'เพิ่มข้อมูลพนักงานขาย',
                        edit: 'แก้ไขข้อมูลพนักงานขาย'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: 'ภาพประจำตัว',
                            height: 275,
                            width: 275
                        }, {
                            key: 'signature',
                            label: 'ลายเซ็นพนักงานขาย',
                            height: 60,
                            width: 300,
                            description: 'ขนาด 400 x 60 px'
                        }
                    ],
                    inputs: {
                        username: {
                            input_type: 'text',
                            placeholder: 'ชื่อผู้ใช้',
                            check_duplicate: true,
                            check_rule: [{
                                required: false,
                                validator: this.validate_duplicate,
                                trigger: 'change',
                            }],
                            required: true,
                            non_editable: true,
                            col_span: 11
                        },
                        password: {
                            input_type: 'password',
                            placeholder: 'รหัสผ่าน',
                            required: true,
                            non_editable: true,
                            col_span: 11
                        },
                        email: {
                            input_type: 'email',
                            placeholder: 'อีเมล',
                            required: false,
                            col_span: 11
                        },
                        firstname: {
                            input_type: 'text',
                            placeholder: 'ชื่อพนักงาน',
                            required: true,
                            col_span: 11
                        },
                        lastname: {
                            input_type: 'text',
                            placeholder: 'นามสกุลพนักงานขาย',
                            required: true,
                            col_span: 11
                        },
                        nickname: {
                            input_type: 'text',
                            placeholder: 'ชื่อเล่น',
                            required: true,
                            col_span: 11
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทร',
                            required: true,
                            col_span: 11
                        },
                        phone_backup: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรสำรอง',
                            required: false,
                            col_span: 11
                        },
                        commission: {
                            input_type: 'number',
                            placeholder: 'คอมมิชชั่น',
                            required: true,
                            col_span: 11
                        },
                    }
                },
                CarRepairType: {
                    title: {
                        create: 'เพิ่มประเภทการซ่อม',
                        edit: 'แก้ไขประเภทการซ่อม'
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อประเภท',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_repair_type_duplicate,
                                    trigger: "change",
                                },
                            ],
                            col_span: 24
                        }
                    }
                },
                Client: {
                    title: {
                        create: 'เพิ่มข้อมูลลูกค้า',
                        edit: 'แก้ไขข้อมูลลูกค้า'
                    },
                    photos: [
                        {
                            key: 'logo',
                            label: 'ภาพประจำตัว',
                            height: 275,
                            width: 275
                        }
                    ],
                    inputs: {
                        fullname: {
                            input_type: 'text',
                            placeholder: 'ชื่อบริษัท',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            
                        },
                        car_company_id: {
                            input_type: 'select',
                            modelname: 'CarCompany',
                            label_key: 'fullname',
                            placeholder: 'บริษัทรถ',
                            required: false,
                            col_span: 11,
                            check_duplicate: false,
                                        check_rule: [
                                            { 
                                                required: true, 
                                                validator: (rule, value) => this.validate_duplicate_conf(rule, value),
                                                trigger: ['change', 'blur']
                                            }
                                        ]   
                        },
                        create_branch: {
                            col_span: 23,
                            input_type: 'table',
                            target_key: 'branches',
                            target_modelname: 'ClientBranch',
                            drawer_title: 'สาขาของบริษัท',
                            drawer_button_text: 'เพิ่มสาขา',
                            drawer_button_text_edit: 'แก้ไขสาขา',
                            table_columns: [
                                {
                                    title: 'ชื่อสาขา',
                                    dataIndex: 'name',
                                    width: 120,
                                    key: 'name',
                                },
                                {
                                    title: 'ที่อยู่',
                                    dataIndex: 'address',
                                    key: 'address',
                                },
                                {
                                    title: 'เบอร์โทร',
                                    dataIndex: 'phone_no',
                                    key: 'phone_no',
                                },
                                {
                                    title: 'Google map',
                                    dataIndex: 'google_map',
                                    width: 120,
                                    key: 'google_map',
                                },
                                {
                                    title: 'พิกัด',
                                    dataIndex: 'latlng',
                                    width: 120,
                                    key: 'latlng',
                                },
                                {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 100,
                                    align: 'center',
                                },
                            ],
                            drawer_fields: {
                                title: 'เพิ่มสาขาของบริษัท',
                                show: false,
                                type: 'drawer',
                                instance: {},
                                inputs: {
                                    name: {
                                        input_type: 'text',
                                        placeholder: 'ชื่อสาขา',
                                        required: true,
                                    },
                                    address: {
                                        input_type: 'text',
                                        placeholder: 'ที่อยู่',
                                        required: true,
                                    },
                                    phone_no: {
                                        input_type: 'text',
                                        placeholder: 'เบอร์โทร',
                                        required: true,
                                    },
                                    google_map: {
                                        input_type: 'text',
                                        placeholder: 'Google map',
                                        required: true,
                                    },
                                    latlng: {
                                        input_type: 'text',
                                        placeholder: 'พิกัด',
                                        required: false,
                                    },
                                }
                            }
                        },
                        email: {
                            input_type: 'email',
                            placeholder: 'อีเมล',
                            required: false,
                            col_span: 11
                        },
                        // tour_type_id: {
                        //     input_type: 'select',
                        //     modelname: 'TourType',
                        //     label_key: 'name',
                        //     placeholder: 'ประเภทกลุ่มลูกค้า',
                        //     on_change: this.client_no_on_change,
                        //     required: false,
                        //     col_span: 11
                        // },
                        empty_space1: {
                            input_type: 'empty',  // หรือจะใช้ 'none' ขึ้นอยู่กับระบบของคุณ
                            col_span: 5,
                        },
                        client_no: {
                            input_type: 'text',
                            placeholder: 'รหัสลูกค้า',
                            required: false,
                            col_span: 11,
                            non_editable: true,
                            // non_editable: this.action_type === 'create'
                        },
                        tax_id: {
                            input_type: 'text',
                            placeholder: 'เลขประจำตัวผู้เสียภาษี',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        email: {
                            input_type: 'email',
                            placeholder: 'อีเมลองค์กร',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทร',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        phone_backup: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรสำรอง',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        // fax_no: {
                        //     input_type: 'text',
                        //     placeholder: 'เบอร์แฟกซ์',
                        //     required: false,
                        //     col_span: 11
                        // },
                        address: {
                            input_type: 'textarea',
                            placeholder: 'ที่อยู่',
                            required: true,
                            check_duplicate: false,
                            col_span: 23
                        },
                        accounting_contact : {
                            input_type: 'textlabel',
                            placeholder: 'ข้อมูลผู้ติดต่อฝ่ายบัญชี',
                            label:"ข้อมูลผู้ติดต่อฝ่ายบัญชี",
                            place:"ชื่อ-นามสกุล",
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        accounting_email: {
                            input_type: 'email',
                            placeholder: 'อีเมลผู้ติดต่อฝ่ายบัญชี',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        accounting_phone: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรผู้ติดต่อฝ่ายบัญชี',
                            required: false,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        empty_space2: {
                            input_type: 'empty',
                            col_span: 5,
                        },
                        organ_accout_number: {
                            input_type: 'maxtext',
                            placeholder: 'เลขบัญชีองค์กร',
                            label:"เลขบัญชีองค์กร",
                            place:"ระบุเลขที่บัญชี",
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator:(rule, value) => this.validate_Client(rule, value),
                                trigger: 'change',
                            }],
                            required: true,
                            maxlength: 15,
                            col_span: 11
                        },
                        bank: {
                            input_type: 'select',
                            modelname: 'Bank',
                            label_key: 'name',
                            placeholder: 'ธนาคาร',
                            required: true,
                            col_span: 11,
                        },
                        account_type: {
                            input_type: 'select',
                            // modelname: 'CarCompany',
                            label_key: 'label',
                            placeholder: 'ประเภทบัญชี',
                            required: false,
                            col_span: 11,
                        },
                        branch: {
                            input_type: 'textlabel',
                            placeholder: 'สาขา',
                            label:"สาขา",
                            place:"ระบุสาขา",
                            required: false,
                            col_span: 11
                        },
                        remark: {
                            input_type: 'textarea',
                            placeholder: 'หมายเหตุ',
                            required: false,
                            col_span: 23
                        },
                        document: {
                            input_type: 'document',
                            label: 'เอกสารที่เกี่ยวข้อง',
                            col_span: 24
                        },
                        data_raw_files: {
                        input_type: 'table_files',
                        required: false,
                        col_span: 23,                        
                        },
                    }
                },
                CarCompany: {
                    title: {
                        create: 'เพิ่มข้อมูลบริษัทรถ',
                        edit: 'แก้ไขข้อมูลบริษัทรถ'
                    },
                    photos: [
                        {
                            key: 'logo',
                            label: 'Logo บริษัท',
                            height: 275,
                            width: 275
                        }
                    ],
                    photos_social: [
                        {
                            key: 'logoSc',
                            label: 'ช่องทางติดต่อ social',
                            height: 275,
                            width: 275
                        }
                    ],
                    photos_iso: [
                        {
                            key: 'logoIso',
                            label: 'มาตรฐาน ISO',
                            height: 275,
                            width: 275
                        }
                    ],
                    photos_payment: [
                        {
                            key: 'image_payment',
                            label: 'ช่องทางการจ่ายเงิน',
                            height: 275,
                            width: 275
                        }
                    ],
                    inputs: {
                            is_3rd_party: {
                                input_type: 'switch',
                                // placeholder: 'บริษัทรถร่วม',
                                required: false,
                                col_span: 3
                            },
                        withholding_id: {
                            input_type: 'select',
                            placeholder: 'ประเภทบริษัท',
                            modelname: 'Withholding',
                            label_key: 'name',
                            required: false,
                            col_span: 19
                        },

                        fullname: {
                            input_type: 'text',
                            placeholder: 'ชื่อบริษัทรถ',
                            required: true,
                            col_span: 23
                        },
                        // car_company_type_id: {
                        //     input_type: 'select',
                        //     modelname: 'CarCompanyType',
                        //     label_key: 'name',
                        //     placeholder: 'ประเภทบริษัท',
                        //     required: false,
                        //     col_span: 11
                        // },
                        phone_no: {
                            input_type: 'maxtext',
                            placeholder: 'เบอร์โทร',
                            place:'เบอร์โทร',
                            required: true,
                            col_span: 11,
                            maxlength: 10,
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_Car_Company,
                                trigger: 'change',
                            }],

                        },
                        office: {
                            input_type: 'text',
                            placeholder: 'สำนักงาน',
                            required: false,
                            col_span: 11
                        },
                        email: {
                            input_type: 'email',
                            placeholder: 'อีเมล',
                            required: true,
                            col_span: 11
                        },
                        tax_id: {
                            input_type: 'text',
                            placeholder: 'เลขประจำตัวผู้เสียภาษี',
                            required: true,
                            col_span: 11
                        },
                        // fax_no: {
                        //     input_type: 'text',
                        //     placeholder: 'เบอร์แฟกซ์',
                        //     required: false,
                        //     col_span: 11
                        // },
                        facebook_url: {
                            input_type: 'text',
                            placeholder: 'เฟสบุ๊ค',
                            required: false,
                            col_span: 11
                        },
                        line_id: {
                            input_type: 'text',
                            placeholder: 'ไลน์',
                            required: false,
                            col_span: 11
                        },
                        website: {
                            input_type: 'text',
                            placeholder: 'เว็บไซต์',
                            required: false,
                            col_span: 11
                        },
                        address: {
                            input_type: 'textarea',
                            placeholder: 'ที่อยู่',
                            required: false,
                            col_span: 23
                        },
                        billing_address: {
                            input_type: 'textarea',
                            placeholder: 'ที่อยู่สำหรับออกเอกสาร',
                            required: true,
                            col_span: 23
                        },
                        divider_4: {
                            input_type: 'divider',
                            label: 'ข้อมูลผู้ติดต่อลูกค้า',
                            col_span: 23
                        },
                        information_name: {
                            input_type: 'text',
                            placeholder: 'ชื่อ-นามสกุล',
                            required: false,
                            col_span: 11
                        },
                        information_line: {
                            input_type: 'text',
                            placeholder: 'ไลน์',
                            required: false,
                            col_span: 11
                        },
                        information_email: {
                            input_type: 'email',
                            placeholder: 'อีเมล',
                            required: false,
                            col_span: 11
                        },
                        information_telephone_number: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรศัพท์',
                            required: false,
                            col_span: 11
                        },
                        information_department: {
                            input_type: 'text',
                            placeholder: 'แผนก/ตำแหน่ง',
                            required: false,
                            col_span: 11
                        },
                        divider_5: {
                            input_type: 'divider',
                            label: 'ข้อมูลผู้ติดต่อด้านบัญชี',
                            col_span: 23
                        },
                        account_information_name: {
                            input_type: 'text',
                            placeholder: 'ชื่อ-นามสกุล',
                            required: false,
                            col_span: 11
                        },
                        account_information_line: {
                            input_type: 'text',
                            placeholder: 'ไลน์',
                            required: false,
                            col_span: 11
                        },
                        account_information_email: {
                            input_type: 'email',
                            placeholder: 'อีเมล',
                            required: false,
                            col_span: 11
                        },
                        account_information_telephone_number: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรศัพท์',
                            required: false,
                            col_span: 11
                        },
                        account_information_department: {
                            input_type: 'text',
                            placeholder: 'แผนก/ตำแหน่ง',
                            required: false,
                            col_span: 11
                        },

                        // divider_1: {
                        //     input_type: 'divider',
                        //     label: 'ภาษาอื่น ๆ',
                        //     col_span: 23
                        // },
                        // fullname_en: {
                        //     input_type: 'text',
                        //     placeholder: 'ชื่อบริษัท (ภาษาอื่นๆ)',
                        //     required: false,
                        //     col_span: 23
                        // },
                        // address_en: {
                        //     input_type: 'textarea',
                        //     placeholder: 'ที่อยู่ (ภาษาอื่นๆ)',
                        //     required: false,
                        //     col_span: 23
                        // },
                        // billing_address_en: {
                        //     input_type: 'textarea',
                        //     placeholder: 'ที่อยู่สำหรับออกเอกสาร (ภาษาอื่นๆ)',
                        //     required: false,
                        //     col_span: 23
                        // },
                        divider_2: {
                            input_type: 'divider',
                            label: 'รายละเอียดบัญชีธนาคาร',
                            col_span: 23
                        },
                        type_payment_id: {
                            input_type: 'radio',
                            placeholder: 'ประเภทการชำระเงิน',
                            required: false,
                            col_span: 23,
                            bank_type:3,
                        },
                        check_amount: {
                            input_type: 'number',
                            placeholder: 'จำนวนเงินสด/เช็ค',
                            required: false,
                            col_span: 23,
                            bank_type:2,
                        },
                        bank_id: {
                            input_type: 'select',
                            modelname: 'Bank',
                            label_key: 'name',
                            placeholder: 'ชื่อธนาคาร',
                            required: true,
                            col_span: 11,
                            bank_type:1,
                        },
                        bank_branch: {
                            input_type: 'text',
                            placeholder: 'ชื่อสาขาของธนาคาร',
                            required: true,
                            col_span: 11,
                            bank_type:1,
                        },
                        bank_account_name: {
                            input_type: 'text',
                            placeholder: 'ชื่อบัญชี',
                            required: true,
                            col_span: 11,
                            bank_type:1,
                        },
                        bank_account_no: {
                            input_type: 'text',
                            placeholder: 'เลขที่บัญชี',
                            required: true,
                            col_span: 11,
                            bank_type:1,
                        },
                        bank_Type_id: {
                            input_type: 'select',
                            modelname: 'getAllBankBranches',
                            label_key: 'name',
                            placeholder: 'ประเภทบัญชี',
                            col_span: 23,
                            bank_type:1,
                        },
                        divider_3: {
                            input_type: 'divider',
                            label: 'เอกสารที่เกี่ยวข้อง',
                            col_span: 23
                        },
                        document_file: {
                            input_type: 'table_files',
                            col_span: 23,                        
                        },
                    }
                },
                CarType: {
                    title: {
                        create: 'เพิ่มชนิดรถ',
                        edit: 'แก้ไขชนิดรถ'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: 'รูปชนิดรถ',
                            height: 275,
                            width: 275
                        }
                    ],
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อชนิดรถ',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_cartype_name_duplicate,
                                    trigger: "change",
                                },
                            ],
                            col_span: 23
                        }
                    }
                },
                DriverCost: {
                    title: {
                        create: 'เพิ่มเบี้ยเลี้ยง',
                        edit: 'แก้ไขเบี้ยเลี้ยง'
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อเบี้ยเลี้ยง',
                            required: true,
                            col_span: 24,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value, 'name'), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        business_type: {
                            input_type: 'select',
                            modelname: 'BookingType',
                            label_key: 'name',
                            placeholder: 'ชื่อประเภทการจอง',
                            required: true,
                            col_span: 24,
                             check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value, 'business_type'), 
                                field: 'business_type',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        cost_per_day: {
                            input_type: 'number',
                            placeholder: 'ราคาต่อวัน',
                            required: true,
                            col_span: 24,
                        }
                    }
                },
                CarGroup: {
                    title: {
                        create: 'เพิ่มประเภทรถ',
                        edit: 'แก้ไขประเภทรถ'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: 'รูปประเภทรถ',
                            height: 275,
                            width: 275
                        }
                    ],
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อประเภทรถ',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change', 'blur']
                            }
                        ]
                        },
                        car_type_id: {
                            input_type: 'select',
                            modelname: 'CarType',
                            label_key: 'name',
                            placeholder: 'ชื่อชนิดรถ',
                            required: true,
                            col_span: 11
                        },
                        seats: {
                            input_type: 'number',
                            placeholder: 'จำนวนที่นั่ง',
                            required: true,
                            col_span: 11,
                        },
                        price: {
                            input_type: 'number',
                            placeholder: 'ราคาต่อวัน',
                            required: true,
                            col_span: 11,
                        },
                    }
                },
                Driver: {
                    title: {
                        create: 'เพิ่มพนักงานขับรถ',
                        edit: 'แก้ไขพนักงานขับรถ'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: 'รูปพนักงานขับรถ',
                            height: 275,
                            width: 275
                        },
                        {
                            key: 'driving_license_photo',
                            label: 'รูปใบขับขี่',
                            height: 275,
                            width: 275
                        },
                        {
                            key: 'id_no_photo',
                            label: 'รูปบัตรประชาชน',
                            height: 275,
                            width: 275
                        }
                    ],
                    inputs: {
                        company_3rd: {
                            input_type: 'checkbox',
                            label_key: 'name',
                            required: false,
                            col_span: 3,
                        },
                        car_company_id: {
                            input_type: 'select',
                            // modelname: 'CarCompany',
                            label_key: 'name',
                            placeholder: 'บริษัทรถ',
                            required: false,
                            col_span: 19,
                        },
                        username: {
                            input_type: 'text',
                            placeholder: 'ชื่อผู้ใช้',
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_driver,
                                trigger: 'change',
                            }],
                            required: true,
                            non_editable: true,
                            col_span: 11
                        },
                        password: {
                            input_type: 'password',
                            placeholder: this.action_type == 'create' ? 'รหัสผ่าน' : 'รหัสผ่านใหม่',
                            // required: true,
                            // non_editable: true,
                            col_span: 11,
                        },
                        // email: {
                        //     input_type: 'text',
                        //     placeholder: 'อีเมล',
                        //     required: true,
                        //     col_span: 11
                        // },
                        driver_no: {
                            input_type: 'text',
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_duplicate,
                                trigger: 'change',
                            }],
                            placeholder: 'รหัสพนักงานขับรถ',
                            required: true,
                            col_span: 11
                        },
                        social_hospital: {
                            input_type: 'text',
                            placeholder: 'โรงพยาบาลประกันสังคม',
                            required: false,
                            col_span: 11
                        },
                        firstname: {
                            input_type: 'text',
                            placeholder: 'ชื่อ',
                            required: true,
                            col_span: 11
                        },
                        lastname: {
                            input_type: 'text',
                            placeholder: 'นามสกุล',
                            required: true,
                            col_span: 11
                        },
                        nickname: {
                            input_type: 'text',
                            placeholder: 'ชื่อเล่น',
                            required: false,
                            col_span: 11
                        },
                        affiliation: {
                            input_type: 'text',
                            placeholder: 'สังกัด',
                            required: false,
                            col_span: 11
                        },
                        driver_bank: {
                            input_type: 'select',
                            modelname: 'DriverStatus',
                            label_key: 'name',
                            placeholder: 'ธนาคาร',
                            required: false,
                            col_span: 11
                        },
                        bank_accno: {
                            input_type: 'text',
                            placeholder: 'เลขบัญชีธนาคาร',
                            required: false,
                            col_span: 11
                        },
                        salary: {
                            input_type: 'number',
                            placeholder: 'เงินเดือน',
                            required: false,
                            col_span: 11
                        },
                        set_leader: {
                            input_type: 'text',
                            placeholder: 'หัวหน้าชุด',
                            required: false,
                            col_span: 11
                        },
                        price_gps: {
                            input_type: 'text',
                            placeholder: 'ค่าใช้จ่าย GPS',
                            required: false,
                            col_span: 11
                        },
                        diligence_allowance: {
                            input_type: 'text',
                            placeholder: 'เบี้ยขยัน',
                            required: false,
                            col_span: 11
                        },
                        driver_job_position: {
                            input_type: 'select',
                            placeholder: 'ตำแหน่ง',
                            required: false,
                            col_span: 11
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรศัพท์',
                            required: true,
                            col_span: 11
                        },
                        phone_emergency: {
                            input_type: 'text',
                            placeholder: 'เบอร์ติดต่อฉุกเฉิน',
                            required: false,
                            col_span: 11
                        },
                        work_status_id: {
                            input_type: 'select',
                            modelname: 'DriverStatus',
                            label_key: 'name',
                            placeholder: 'สถานะพนักงาน',
                            required: false,
                            col_span: 11
                        },
                        register_date: {
                            input_type: 'date',
                            placeholder: 'วันเริ่มงาน',
                            required: false,
                            col_span: 11
                        },
                        driver_age_of_work: {
                            input_type: 'driver_age_of_work',
                            placeholder: 'อายุงาน (ปี)',
                            required: false,
                            col_span: 11
                        },
                        date_of_birth: {
                            input_type: 'date',
                            placeholder: 'วันเดือนปีเกิด',
                            required: false,
                            col_span: 11
                        },
                        age: {
                            input_type: 'number',
                            placeholder: 'อายุ',
                            required: false,
                            col_span: 11
                        },
                        sex: {
                            input_type: 'select',
                            modelname: 'SexType',
                            label_key: 'name',
                            placeholder: 'เพศ',
                            required: false,
                            col_span: 11
                        },
                        id_no: {
                            input_type: 'text',
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_duplicate,
                                trigger: 'change',
                            }],
                            placeholder: 'เลขบัตรประชาชน',
                            required: true,
                            col_span: 11
                        },
                        card_id_expire: {
                            input_type: 'date',
                            placeholder: 'วันหมดอายุบัตรประชาชน',
                            required: false,
                            col_span: 11
                        },
                        car_code: {
                            input_type: 'text',
                            placeholder: 'รหัสรถ',
                            required: false,
                            col_span: 11
                        },
                        car_id: {
                            input_type: 'select',
                            placeholder: 'ทะเบียนรถ',
                            required: false,
                            col_span: 11
                        },
                        car_line: {
                            input_type: 'text',
                            placeholder: 'สายรถ',
                            required: false,
                            col_span: 11
                        },
                        gps: {
                            input_type: 'text',
                            placeholder: 'GPS',
                            required: false,
                            col_span: 11
                        },
                        divider: {
                            input_type: 'divider',
                            label: 'ใบขับขี่',
                            col_span: 24
                        },
                        driver_license_no: {
                            input_type: 'text',
                            placeholder: 'ใบอนุญาตขับรถเลขที่',
                            required: false,
                            col_span: 22
                        },
                        driving_license_exp: {
                            input_type: 'date',
                            placeholder: 'วันหมดอายุใบขับขี่',
                            required: false,
                            col_span: 11
                        },
                        driving_license_type_id: {
                            input_type: 'select',
                            modelname: 'DrivingLicenseType',
                            label_key: 'name',
                            placeholder: 'ประเภทใบขับขี่',
                            required: false,
                            col_span: 11

                        },
                        remark: {
                            input_type: 'textarea',
                            placeholder: 'หมายเหตุ',
                            required: false,
                            col_span: 23
                        },
                        document: {
                            input_type: 'document',
                            label: 'เอกสารที่เกี่ยวข้อง',
                            col_span: 24
                        },
                        document_file: {
                        input_type: 'table_files',
                        // required: false,
                        col_span: 23,
                        accept: '.jpg, .jpeg, .png, .pdf, .doc, .docx'                        
                        },
                    }
                },
                Guide: {
                    title: {
                        create: 'เพิ่มไกด์/ผู้ประสานงาน',
                        edit: 'แก้ไขไกด์/ผู้ประสานงาน'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: 'รูปไกด์/ผู้ประสานงาน',
                            height: 275,
                            width: 275
                        }
                    ],
                    inputs: {
                        firstname: {
                            input_type: 'text',
                            placeholder: 'ชื่อ',
                            required: true,
                            col_span: 11
                        },
                        lastname: {
                            input_type: 'text',
                            placeholder: 'นามสกุล',
                            required: true,
                            col_span: 11
                        },
                        nickname: {
                            input_type: 'text',
                            placeholder: 'ชื่อเล่น',
                            required: true,
                            col_span: 11
                        },
                        email: {
                            input_type: 'text',
                            placeholder: 'อีเมล',
                            required: true,
                            col_span: 11
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรศัพท์',
                            required: true,
                            col_span: 11
                        },
                        phone_backup: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรศัพท์สำรอง',
                            required: false,
                            col_span: 11
                        },
                        license: {
                            input_type: 'text',
                            placeholder: 'เลขที่ใบอนุญาต',
                            required: false,
                            col_span: 11
                        },
                        license_expire: {
                            input_type: 'date',
                            placeholder: 'วันหมดอายุใบอนุญาต',
                            required: false,
                            col_span: 11
                        },
                        remark: {
                            input_type: 'textarea',
                            placeholder: 'หมายเหตุ',
                            required: false,
                            col_span: 23
                        },
                    }
                },
                ClientContact: {
                    title: {
                        create: 'เพิ่มผู้ประสานงาน',
                        edit: 'แก้ไขผู้ประสานงาน'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: 'รูปผู้ประสานงาน',
                            height: 275,
                            width: 275
                        }
                    ],
                    inputs: {
                        client_id: {
                            input_type: 'select',
                            search_select: true,
                            placeholder: 'เลือกบริษัท',
                            modelname: 'Client',
                            label_key: 'fullname',
                            null_on_change: 'client_branch_id',
                            required: true,
                            col_span: 11,
                        },
                        client_branch_id: {
                            input_type: 'sub_select',
                            placeholder: 'เลือกสาขา',
                            modelname: 'ClientBranch',
                            label_key: 'name',
                            parent: {
                                list: 'Client',
                                sub_list_name: 'branches',
                                key: 'client_id'
                            },
                            required: false,
                            col_span: 11,
                        },
                        firstname: {
                            input_type: 'text',
                            placeholder: 'ชื่อ',
                            required: true,
                            col_span: 11
                        },
                        lastname: {
                            input_type: 'text',
                            placeholder: 'นามสกุล',
                            required: true,
                            col_span: 11
                        },
                        email: {
                            input_type: 'text',
                            placeholder: 'อีเมล',
                            required: true,
                            col_span: 11
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรศัพท์',
                            required: false,
                            col_span: 11
                        },
                    }
                },
                Car: {
                    ...CarField,
                    inputs: {
                        ...CarField.inputs || {},
                    }
                },
                Insure: {
                    ...InsureField,
                    inputs: {
                        ...InsureField.inputs || {},
                    }
                },
                RegistrationAndTax: {
                    ...RegistrationAndTaxField,
                    inputs: {
                        ...RegistrationAndTaxField.inputs || {},
                    }
                },
                FleetAndSim: {
                    ...FleetAndSimField,
                    inputs: {
                        ...FleetAndSimField.inputs || {},
                    }
                },
                Document: {
                    ...DocumentField,
                    inputs: {
                        ...DocumentField.inputs || {},
                    }
                },
                Option: {
                    ...OptionField,
                    inputs: {
                        ...OptionField.inputs || {},
                    }
                },
                Appearance: {
                    ...AppearanceField,
                    inputs: {
                        ...AppearanceField.inputs || {},
                    }
                },
                Engine: {
                    ...EngineField,
                    inputs: {
                        ...EngineField.inputs || {},
                    }
                },
                Parking: {
                    title: {
                        create: 'เพิ่มที่จอดยานพาหนะ',
                        edit: 'แก้ไขที่จอดยานพาหนะ',
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อที่จอดยานพาหนะ',
                            required: true,
                            col_span: 23
                        },
                        max_lots: {
                            input_type: 'number',
                            placeholder: 'จำนวนที่จอด',
                            required: true,
                            col_span: 23
                        },
                        lat: {
                            input_type: 'number',
                            placeholder: 'ละติจูด',
                            required: true,
                            col_span: 11
                        },
                        lng: {
                            input_type: 'number',
                            placeholder: 'ลองติจูด',
                            required: true,
                            col_span: 11
                        },
                    }
                },
                Expense: {
                    title: {
                        create: 'เพิ่มประเภทค่าใช้จ่าย',
                        edit: 'แก้ไขประเภทค่าใช้จ่าย',
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อประเภทค่าใช้จ่าย',
                            required: true,
                            col_span: 23,
                            check_duplicate: true,
                            check_rule: [
                             { 
                                required: true, 
                                validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                field: 'name',
                                trigger: ['change']
                            }
                        ]
                        }
                    }
                },
                Extra: {
                    title: {
                        create: 'เพิ่มค่าใช้จ่ายส่วนเกิน',
                        edit: 'แก้ไขค่าใช้จ่ายส่วนเกิน',
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อค่าใช้จ่าย',
                            required: true,
                            col_span: 23
                        },
                        price: {
                            input_type: 'number',
                            placeholder: 'ราคา',
                            required: true,
                            col_span: 23
                        },
                    }
                },
                Trip: {
                    title: {
                        create: 'เพิ่มจุดประสงค์การเดินทาง',
                        edit: 'แก้ไขจุดประสงค์การเดินทาง',
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อจุดประสงค์การเดินทาง',
                            required: true,
                            col_span: 23
                        }
                    }
                },
                Tour: {
                    title: {
                        create: 'เพิ่มทัวร์',
                        edit: 'แก้ไขทัวร์',
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อทัวร์',
                            required: false,
                            col_span: 11
                        },
                        tour_type_id: {
                            input_type: 'select',
                            modelname: 'TourType',
                            label_key: 'name',
                            placeholder: 'ประเภทกลุ่มลูกค้า',
                            required: true,
                            col_span: 11
                        },
                        client_id: {
                            input_type: 'select',
                            modelname: 'Client',
                            label_key: 'fullname',
                            placeholder: 'ลูกค้า/บริษัท',
                            required: true,
                            col_span: 11
                        },
                        description: {
                            input_type: 'text',
                            placeholder: 'สถานที่เที่ยว',
                            required: false,
                            col_span: 11
                        }
                    }
                },
                TourType: {
                    title: {
                        create: 'เพิ่มประเภทกลุ่มลูกค้า',
                        edit: 'แก้ไขประเภทกลุ่มลูกค้า',
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อประเภทกลุ่มลูกค้า',
                            required: true,
                            col_span: 11
                        },
                        color_id: {
                            input_type: 'select',
                            modelname: 'Colorrandom',
                            label_key: 'name',
                            placeholder: 'สีประเภทกลุ่มลูกค้า',
                            required: false,
                            col_span: 11
                        }
                    }
                },
                PartType: {
                    title: {
                        create: 'เพิ่มประเภทอะไหล่',
                        edit: 'แก้ไขประเภทอะไหล่'
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อประเภทอะไหล่',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_part_type_duplicate,
                                    trigger: "change",
                                },
                            ],
                            col_span: 23
                        },
                    }
                },
                PartUnit: {
                    title: {
                        create: 'เพิ่มหน่วยอะไหล่',
                        edit: 'แก้ไขหน่วยอะไหล่'
                    },
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อหน่วยอะไหล่',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_part_type_duplicate,
                                    trigger: "change",
                                },
                            ],
                            col_span: 23
                        },
                    }
                },
                Vendor: {
                    title: {
                        create: 'เพิ่มผู้ขาย',
                        edit: 'แก้ไขผู้ขาย'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: '',
                            height: 275,
                            width: 275
                        },
                    ],
                    inputs: {
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่อผู้ขาย',
                            required: true,
                            col_span: 11
                        },
                        contact_name: {
                            input_type: 'text',
                            placeholder: 'ชื่อผู้ติดต่อ',
                            required: true,
                            col_span: 11
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทร',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_phone,
                                    trigger: "change",
                                },
                            ],
                            col_span: 11
                        },
                        fax_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์แฟกซ์',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    validator: this.validate_fax,
                                    trigger: "change",
                                },
                            ],
                            col_span: 11
                        },
                        tax_id: {
                            input_type: 'text',
                            placeholder: 'เลขประจำตัวผู้เสียภาษี',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_tax_duplicate,
                                    trigger: "change",
                                },
                            ],
                            col_span: 11
                        },
                        address: {
                            input_type: 'textarea',
                            placeholder: 'ที่อยู่',
                            required: true,
                            col_span: 23
                        },
                    }
                },
                Technician: {
                    title: {
                        create: 'เพิ่มช่าง (Technician)',
                        edit: 'แก้ไขช่าง'
                    },
                    photos: [
                        {
                            key: 'avatar',
                            label: '',
                            height: 275,
                            width: 275
                        },
                    ],
                    inputs: {
                        car_company_id: {
                            input_type: 'select',
                            modelname: 'CarCompany',
                            label_key: 'fullname',
                            placeholder: 'บริษัท',
                            required: true,
                            col_span: 23
                        },
                        firstname: {
                            input_type: 'text',
                            placeholder: 'ชื่อช่าง',
                            required: true,
                            col_span: 11
                        },
                        lastname: {
                            input_type: 'text',
                            placeholder: 'นามสกุล',
                            required: true,
                            col_span: 11
                        },
                        nickname: {
                            input_type: 'text',
                            placeholder: 'ชื่อเล่น',
                            col_span: 11
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทร',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_phone,
                                    trigger: "change",
                                },
                            ],
                            col_span: 11
                        },
                        tax_id: {
                            input_type: 'text',
                            placeholder: 'เลขประจำตัวผู้เสียภาษี',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    required: true,
                                    validator: this.validate_tax_duplicate,
                                    trigger: "change",
                                },
                            ],
                            col_span: 11
                        },
                        address: {
                            input_type: 'text',
                            placeholder: 'ที่อยู่',
                            required: true,
                            col_span: 11
                        },
                        phone_backup: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรสำรอง',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    validator: this.validate_phone,
                                    trigger: "change",
                                },
                            ],
                            col_span: 11
                        },
                        email: {
                            input_type: 'text',
                            placeholder: 'อีเมล',
                            check_duplicate: true,
                            check_rule: [
                                {
                                    validator: this.validate_email_duplicate,
                                    trigger: "change",
                                },
                            ],
                            col_span: 11
                        },
                    }
                },
                Part: {
                    title: {
                        create: 'เพิ่มอะไหล่',
                        edit: 'แก้ไขอะไหล่'
                    },
                    photos: [
                        {
                            key: 'photo',
                            label: '',
                            height: 275,
                            width: 275
                        },
                    ],
                    inputs: {
                        barcode: {
                            input_type: 'text',
                            placeholder: 'รหัส',
                            required: true,
                            col_span: 11,
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_barcode_duplicate,
                                trigger: 'change',
                            }],
                        },
                        name: {
                            input_type: 'text',
                            placeholder: 'ชื่ออะไหล่',
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_part_duplicate,
                                trigger: 'change',
                            }],
                            col_span: 11
                        },
                        amount: {
                            input_type: 'text',
                            placeholder: 'จำนวน',
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_number,
                                trigger: 'change',
                            }],
                            col_span: 5
                        },
                        part_unit_id: {
                            input_type: 'select',
                            modelname: 'PartUnit',
                            label_key: 'name',
                            placeholder: 'เลือกหน่วย',
                            required: true,
                            col_span: 5
                        },
                        price: {
                            input_type: 'text',
                            placeholder: 'ราคา',
                            check_duplicate: true,
                            check_rule: [{
                                required: true,
                                validator: this.validate_number,
                                trigger: 'change',
                            }],
                            customRender: ({ text }) => parseInt(text),
                            col_span: 5,
                        },
                        part_type_id: {
                            input_type: 'select',
                            modelname: 'PartType',
                            label_key: 'name',
                            placeholder: 'เลือกประเภทอะไหล่',
                            required: true,
                            col_span: 5
                        },
                        vendor_id: {
                            input_type: 'select',
                            modelname: 'Vendor',
                            label_key: 'name',
                            placeholder: 'เลือกผู้ขาย',
                            required: true,
                            col_span: 11
                        },
                        claim_date: {
                            input_type: 'date',
                            placeholder: 'วันที่เบิกอะไหล่',
                            required: true,
                            col_span: 11
                        },
                        withdraw_type_id: {
                            input_type: 'select',
                            modelname: 'WithdrawType',
                            label_key: 'name',
                            placeholder: 'ประเภท',
                            required: true,
                            col_span: 11
                        },
                        remark: {
                            input_type: 'text',
                            placeholder: 'อื่นๆ',
                            col_span: 11
                        },
                    }
                },
                StockHistory: {
                    title: {
                        create: 'เพิ่มรายการ',
                        edit: 'แก้ไขรายการ'
                    },
                    inputs: {        
                        withdraw_type_id: {
                            input_type: 'select',
                            modelname: 'WithdrawType',
                            label_key: 'name',
                            placeholder: 'ประเภทการเบิก',
                            required: true,
                            col_span: 6
                        },
                        withdrawed_at: {
                            input_type: 'date',
                            placeholder: 'ระบุวันที่เบิก',
                            required: true,
                        },
                        remark: {
                            input_type: 'textarea',
                            placeholder: 'หมายเหตุ',
                            col_span: 23
                        },
                        create_part_withdraw: {
                            col_span: 23,
                            input_type: 'table',
                            drawer_title: 'รายการอะไหล่',
                            drawer_button_text: 'เพิ่มอะไหล่',
                            target_key: 'part_histories',
                            target_modelname: 'PartHistory',
                            target_object: [],
                            table_columns: [
                                {
                                    title: 'ลำดับ',
                                    dataIndex: 'index',
                                    key: 'index',
                                },
                                {
                                    title: 'รหัสอะไหล่',
                                    dataIndex: 'part_barcode',
                                    key: 'part_barcode',
                                },
                                {
                                    title: 'ชื่ออะไหล่',
                                    dataIndex: 'part_id',
                                    key: 'part_id',
                                }, 
                                {
                                    title: 'จำนวน',
                                    dataIndex: 'amount',
                                    key: 'amount',
                                },
                                {
                                    title: 'หน่วย',
                                    dataIndex: 'part_unit_id',
                                    key: 'part_unit_id',
                                },
                                {
                                    title: 'หมายเหตุ',
                                    dataIndex: 'remark',
                                    key: 'remark',
                                },
                                {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 100,
                                    align: 'center',
                                },
                            ],
                            drawer_fields: {
                                title: 'เพิ่มอะไหล่',
                                show: false,
                                type: 'drawer',
                                inputs: {
                                    part_id: {
                                        input_type: 'selects',
                                        modelname: 'Part',
                                        label_key: 'name',
                                        placeholder: 'ชื่ออะไหล่',
                                        required: true,
                                    },
                                    amount: {
                                        input_type: 'number',
                                        placeholder: 'จำนวน',
                                        required: true,
                                    },
                                    part_unit_id: {
                                        input_type: 'selects',
                                        modelname: 'PartUnit',
                                        placeholder: 'เลือกหน่วย',
                                        required: true,
                                    },
                                    remark: {
                                        input_type: 'textarea',
                                        placeholder: 'หมายเหตุ',
                                        required: false,
                                    }
                                }
                            }
                        },
                    },
                },
            },
            selectables: {
                Client: [],
                ClientBranch: [],
                DriverStatus: [],
                SexType: [],
                DrivingLicenseType: [],
                Withholding: [],
                Bank: [],
                getAllBankBranches: [],
                CarType: [],
                CarGroup: [],
            },
            default_fields_driver: {        
                Driver: {
                    inputs: {
                        driver_no: {
                            input_type: 'text',
                            placeholder: 'รหัสประจำตัวพนักงาน',
                            check_duplicate: true,
                            required: false,
                            // non_editable: true,
                            col_span: 11
                        },
                        driver_job_position: {
                            input_type: 'select_driver_work_ranks',
                            placeholder: 'ตำแหน่งหน้าที่',
                            required: false,
                            col_span: 11
                        },
                        driver_prefix_name: {
                            input_type: 'select_driver_prefix_name',
                            placeholder: 'คำนำหน้านาม',
                            required: false,
                            col_span: 6
                        },
                        firstname: {
                            input_type: 'text',
                            placeholder: 'ชื่อ',
                            required: false,
                            col_span: 8
                        },
                        lastname: {
                            input_type: 'text',
                            placeholder: 'นามสกุล',
                            required: false,
                            col_span: 8
                        },
                        nickname: {
                            input_type: 'text',
                            placeholder: 'ชื่อเล่น',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        affiliation: {
                            input_type: 'text',
                            placeholder: 'สังกัด',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        phone_no: {
                            input_type: 'text',
                            placeholder: 'เบอร์โทรศัพท์',
                            required: false,
                            non_editable: false,
                            col_span: 6
                        },
                        phone_emergency: {
                            input_type: 'text',
                            placeholder: 'เบอร์ติดต่อฉุกเฉิน',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        register_date: {
                            input_type: 'register_date',
                            placeholder: 'วันที่เริ่มงาน',
                            required: false,
                            non_editable: false,
                            col_span: 8
                        },
                        driver_age_of_work: {
                            input_type: 'driver_age_of_work',
                            placeholder: 'อายุงาน',
                            required: false,
                            non_editable: false,
                            col_span: 8
                        },
                        driver_work_status: {
                            input_type: 'checkbox',
                            label_key: 'name',
                            placeholder: 'สถานะทำงาน',
                            required: false,
                            col_span: 8,
                        },
                        driver_stoped_employment_date: {
                            input_type: 'date_end',
                            placeholder: ' ',
                            required: false,
                            col_span: 7
                        },
                        driver_current_car_no: {
                            input_type: 'text',
                            placeholder: 'ปัจจุบันประจำเบอร์รถ',
                            required: false,
                            non_editable: false,
                            col_span: 7
                        },
                        date_of_birth: {
                            input_type: 'date',
                            placeholder: 'วันเดือนปีเกิด',
                            required: false,
                            non_editable: false,
                            col_span: 11,
                        },
                        age: {
                            input_type: 'number',
                            placeholder: 'อายุ',
                            required: false,
                            non_editable: false,
                            col_span: 11
                        },
                        driver_religions: {
                            input_type: 'select_driver_religions',
                            placeholder: 'ศาสนา',
                            required: false,
                            col_span: 11
                        },
                        driver_educations: {
                            input_type: 'select_driver_educations',
                            placeholder: 'ระดับการศึกษา',
                            showOtherEducationModal: false, // ตัวแปรสำหรับควบคุมการแสดงผลของ Modal
                            otherEducationInput: '', // ตัวแปรสำหรับเก็บค่าจาก Modal
                            currentFieldKey: '',
                            required: false,
                            col_span: 11
                        },
                        id_no: {
                            input_type: 'text',
                            placeholder: 'หมายเลขบัตรประจำตัวประชาชน',
                            required: false,
                            non_editable: false,
                            col_span: 23
                        },
                        card_id_expire: {
                            input_type: 'card_id_expire',
                            placeholder: 'วันหมดอายุบัตรประชาชน',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        driver_address_no: {
                            input_type: 'text',
                            placeholder: 'เลขที่',
                            required: false,
                            col_span: 11
                        },
                        driver_address_village: {
                            input_type: 'text',
                            placeholder: 'อาคาร/หมู่บ้าน',
                            required: false,
                            col_span: 11
                        },
                        driver_address_sub_district: {
                            input_type: 'text',
                            placeholder: 'หมู่ที่',
                            required: false,
                            col_span: 6
                        },
                        driver_address_alley: {
                            input_type: 'text',
                            placeholder: 'ตรอก/ซอย',
                            required: false,
                            col_span: 8
                        },
                        driver_address_road: {
                            input_type: 'text',
                            placeholder: 'ถนน',
                            required: false,
                            col_span: 8
                        },
                        driver_address_district: {
                            input_type: 'text',
                            placeholder: 'แขวง/ตำบล',
                            required: false,
                            col_span: 11
                        },
                        driver_address_city: {
                            input_type: 'text',
                            placeholder: 'เขต/อำเภอ',
                            required: false,
                            col_span: 11
                        },
                        driver_address_province: {
                            input_type: 'text',
                            placeholder: 'จังหวัด',
                            required: false,
                            col_span: 11
                        },
                        driver_address_postal_code: {
                            input_type: 'text',
                            placeholder: 'รหัสไปรษณีย์',
                            required: false,
                            col_span: 11
                        },
                        driving_license_type_id: {
                            input_type: 'select',
                            modelname: 'DrivingLicenseType',
                            label_key: 'name',
                            placeholder: 'ประเภทใบขับขี่',
                            required: false,
                            col_span: 11,
                            non_editable: true,

                        },
                        driving_license_exp: {
                            input_type: 'driving_license_exp',
                            placeholder: 'วันหมดอายุใบขับขี่',
                            required: false,
                            col_span: 11,
                        },
                        car_code: {
                            input_type: 'text',
                            placeholder: 'รหัสรถ',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        car_line: {
                            input_type: 'text',
                            placeholder: 'สายรถ',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        gps: {
                            input_type: 'text',
                            placeholder: 'GPS',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        salary_rate: {
                            input_type: 'text',
                            placeholder: 'เงินเดือน',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        set_leader: {
                            input_type: 'text',
                            placeholder: 'หัวหน้าชุด',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        price_gps: {
                            input_type: 'text',
                            placeholder: 'ค่าใช้จ่าย GPS',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        diligence_allowance: {
                            input_type: 'text',
                            placeholder: 'เบี้ยขยัน',
                            required: false,
                            non_editable: true,
                            col_span: 11
                        },
                        // driver_license_type: {
                        //     input_type: 'select_driver_license_type',
                        //     placeholder: 'ประเภทใบอนุญาต',
                        //     required: false,
                        //     col_span: 11
                        // },
                        driver_bank: {
                            input_type: 'select_driver_bank',
                            placeholder: 'ธนาคาร',
                            required: false,
                            col_span: 11
                        },
                        bank_accno: {
                            input_type: 'text',
                            placeholder: 'หมายเลยบัญชีธนาคาร',
                            required: false,
                            non_editable: false,
                            col_span: 11
                        },
                        salary: {
                            input_type: 'text',
                            placeholder: 'อัตราเงินเดือน',
                            required: false,
                            col_span: 23
                        },
                        driver_tax_rate_service: {
                            input_type: 'text',
                            placeholder: 'อัตราดอกเบี้ยบริการ',
                            required: false,
                            col_span: 23
                        },
                        topic_important: {
                            input_type: 'bold',
                            col_span: 23,
                            label: 'เอกสารสำคัญ',
                        },
                        important_doc1: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        important_doc2: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        important_doc3: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        important_doc4: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        important_doc5: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        topic_other: {
                            input_type: 'bold',
                            col_span: 23,
                            label: 'เอกสารต่างๆ',
                        },
                        other_doc1: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        other_doc2: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        other_doc3: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        other_doc4: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        other_doc5: {
                            input_type: 'file',
                            required: false,
                            col_span: 4,
                            accept: '.pdf'
                        },
                        document_field_3: {
                        input_type: 'table',
                        required: false,
                        col_span: 23,
                        drawer_title: 'ผลคะแนนการทดสอบ',
                        table_columns: [
                            { title: 'วัน/เดือน/ปี', dataIndex: 'driver_document_date', key: 'driver_document_date' },
                            { title: 'รายการทดสอบ', dataIndex: 'driver_document_list', key: 'driver_document_list' },
                            { title: 'คะแนนเต็ม', dataIndex: 'driver_document_maxscore', key: 'driver_document_maxscore' },
                            { title: 'คะแนนที่ได้', dataIndex: 'driver_document_getscore', key: 'driver_document_getscore' },
                            { title: 'ผลการทดสอบ', dataIndex: 'driver_document_result', key: 'driver_document_result' },
                            { title: 'เอกสารแนบ', dataIndex: 'file_name', key: 'file_name' },
                            {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 100,
                                    align: 'center',
                            },
                        ],
                        drawer_fields: {
                            inputs: {
                                driver_document_date: {
                                    input_type: 'date',
                                    placeholder: 'วัน/เดือน/ปี',
                                    required: false,
                                    col_span: 23
                                },
                                driver_document_list: {
                                    input_type: 'select',
                                    placeholder: 'รายการทดสอบ',
                                    required: false,
                                    col_span: 23,
                                    options: [
                                          { label: 'ประเมินขวัญกำลังใจ', value: 'ประเมินขวัญกำลังใจ' },
                                          { label: 'การคิดจินตนาการ', value: 'การคิดจินตนาการ' },
                                          { label: 'การรับรู้รูปแบบ', value: 'การรับรู้รูปแบบ' },
                                          { label: 'การควบคุมอารมณ์ขณะขับ', value: 'การควบคุมอารมณ์ขณะขับ' },
                                          { label: 'ความสามารถของพนักงานขับรถ', value: 'ความสามารถของพนักงานขับรถ' },
                                          { label: 'ทดสอบขับรถ (ก่อนรับเข้าปฏิบัติงาน)', value: 'ทดสอบขับรถ (ก่อนรับเข้าปฏิบัติงาน)' },
                                          { label: 'อื่นๆ', value: 'OTHER' }
                                    ]
                                },
                                driver_document_maxscore: {
                                    input_type: 'text',
                                    placeholder: 'คะแนนเต็ม',
                                    required: false,
                                    col_span: 23
                                },
                                driver_document_getscore: {
                                    input_type: 'text',
                                    placeholder: 'คะแนนที่ได้',
                                    required: false,
                                    col_span: 23
                                },
                                driver_document_result: {
                                    input_type: 'select',
                                    placeholder: 'ผลการทดสอบ',
                                    required: false,
                                    col_span: 23,
                                    options: [
                                        { label: 'ผ่าน', value: 'ผ่าน' },
                                        { label: 'ไม่ผ่าน', value: 'ไม่ผ่าน' }
                                    ]
                                },
                                file: {
                                    input_type: 'file',
                                    placeholder: 'เอกสารแนบ',
                                    required: false,
                                    col_span: 23,
                                    accept: '.pdf'
                                },
                                file_name:{
                                    input_type: 'none',
                                },
                            }
                        },
                        drawer_button_text: 'เพิ่ม',
                        drawer_button_text_edit: 'แก้ไขไฟล์'
                        },
                        document_field_4: {
                        input_type: 'table',
                        required: false,
                        col_span: 23,
                        drawer_title: 'ประวัติการโยกย้ายประจำรถ',
                        table_columns: [
                            { title: 'วัน/เดือน/ปี', dataIndex: 'driver_history_movecar_date', key: 'driver_history_movecar_date' },
                            { title: 'ประจำเบอร์รถ', dataIndex: 'driver_main_car', key: 'driver_main_car' },
                            { title: 'บันทึกการตรวจรับรถ', dataIndex: 'driver_check_car', key: 'driver_check_car' },
                            { title: 'หมายเหตุ', dataIndex: 'driver_history_movecar_description', key: 'driver_history_movecar_description' },
                            { title: 'เอกสารแนบ', dataIndex: 'file_name', key: 'file_name' },
                            {
                                title: 'ตัวเลือก', dataIndex: 'id', key: 'id', width: 100, align: 'center'
                            },
                        ],
                        drawer_fields: {
                            inputs: {
                                driver_history_movecar_date: {
                                    input_type: 'date',
                                    placeholder: 'วัน/เดือน/ปี',
                                    required: false,
                                    col_span: 23
                                },
                                driver_main_car: {
                                    input_type: 'select',
                                    placeholder: 'ประจำเบอร์รถ',
                                    required: false,
                                    col_span: 23,
                                    options:  [],       
                                },
                                driver_check_car: {
                                    input_type: 'text',
                                    placeholder: 'บันทึกการตรวจรับรถ',
                                    required: false,
                                    col_span: 23
                                },
                                driver_history_movecar_description: {
                                    input_type: 'text',
                                    placeholder: 'หมายเหตุ',
                                    required: false,
                                    col_span: 23
                                },
                                file: {
                                    input_type: 'file',
                                    placeholder: 'แนบหลักฐาน(PDF)',
                                    required: false,
                                    col_span: 23,
                                    accept: '.pdf'
                                },
                                file_name:{
                                    input_type: 'none',
                                },
                            }
                        },
                        drawer_button_text: 'เพิ่ม',
                        drawer_button_text_edit: 'แก้ไขไฟล์'
                        },
                        document_field_5: {
                        input_type: 'table',
                        required: false,
                        col_span: 23,
                        drawer_title: 'ประวัติการลางาน',
                        table_columns: [
                            { title: 'วัน/เดือน/ปี', dataIndex: 'driver_leave_date', key: 'driver_leave_date' },
                            { title: 'ประเภทการลา', dataIndex: 'driver_leave_date_type', key: 'driver_leave_date_type' },
                            { title: 'จำนวนวัน', dataIndex: 'driver_leave_date_day', key: 'driver_leave_date_day' },
                            { title: 'แนบเอกสาร', dataIndex: 'file_name', key: 'file_name' },
                            { title: 'หมายเหตุ', dataIndex: 'driver_leave_date_description', key: 'driver_leave_date_description' },
                            {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 100,
                                    align: 'center',
                            },
                        ],
                        drawer_fields: {
                            inputs: {
                                driver_leave_date: {
                                    input_type: 'date',
                                    placeholder: 'วัน/เดือน/ปี',
                                    required: false,
                                    col_span: 23
                                },
                                driver_leave_date_type: {
                                    input_type: 'select',
                                    placeholder: 'ประเภทการลา',
                                    required: false,
                                    col_span: 23,
                                    options: [
                                        { label: 'ลากิจ', value: 'ลากิจ' },
                                        { label: 'ลาป่วย', value: 'ลาป่วย' }
                                    ]
                                },
                                driver_leave_date_day: {
                                    input_type: 'text',
                                    placeholder: 'จำนวนวัน',
                                    required: false,
                                    col_span: 23
                                },
                                file: {
                                    input_type: 'file',
                                    placeholder: 'แนบเอกสาร',
                                    required: false,
                                    col_span: 23,
                                    accept: '.pdf'
                                },
                                file_name:{
                                    input_type: 'none',
                                },
                                driver_leave_date_description: {
                                    input_type: 'text',
                                    placeholder: 'หมายเหตุ',
                                    required: false,
                                    col_span: 23
                                },
                            }
                        },
                        drawer_button_text: 'เพิ่ม',
                        drawer_button_text_edit: 'แก้ไขไฟล์'
                        },
                        document_field_6: {
                        input_type: 'table',
                        required: false,
                        col_span: 23,
                        drawer_title: 'รายละเอียดประวัติการฝึกอบรม',
                        table_columns: [
                            { title: 'วัน/เดือน/ปี', dataIndex: 'driver_train_date', key: 'driver_train_date' },
                            { title: 'ชื่อหลักสูตรการอบรม', dataIndex: 'driver_train_subject', key: 'driver_train_subject' },
                            { title: 'ประเภท', dataIndex: 'driver_train_type', key: 'driver_train_type' },
                            { title: 'สถานที่อบรม', dataIndex: 'driver_train_location', key: 'driver_train_location' },
                            { title: 'เอกสาร/ใบประกาศ (ถ้ามี)', dataIndex: 'file_name', key: 'file_name' },
                            { title: 'หมายเหตุ', dataIndex: 'driver_train_description', key: 'driver_train_description' },
                            {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 100,
                                    align: 'center',
                            },
                        ],
                        drawer_fields: {
                            inputs: {
                                driver_train_date: {
                                    input_type: 'date',
                                    placeholder: 'วัน/เดือน/ปี',
                                    required: false,
                                    col_span: 23
                                },
                                driver_train_subject: {
                                    input_type: 'text',
                                    placeholder: 'ชื่อหลักสูตรการอบรม',
                                    required: false,
                                    col_span: 23
                                },
                                driver_train_type: {
                                    input_type: 'select',
                                    placeholder: 'ประเภท',
                                    required: false,
                                    col_span: 23,
                                    options: [
                                        { label: 'KM', value: 'KM' },
                                        { label: 'อบรมภายใน', value: 'อบรมภายใน' },
                                        { label: 'อบรมภายนอก', value: 'อบรมภายนอก' },
                                        { label: 'OJT พนักงานใหม่ - กลุ่ม1', value: 'OJT พนักงานใหม่ - กลุ่ม1' },
                                        { label: 'OJT การทำงานฝ่าย', value: 'OJT การทำงานฝ่าย' },
                                        { label: 'อื่นๆ', value: 'OTHER' }
                                    ],
                                    
                                },
                                driver_train_location: {
                                    input_type: 'text',
                                    placeholder: 'สถานที่อบรม',
                                    required: false,
                                    col_span: 23
                                },
                                file: {
                                    input_type: 'file',
                                    placeholder: 'เอกสาร/ใบประกาศ (ถ้ามี)',
                                    required: false,
                                    col_span: 23,
                                    accept: '.pdf'
                                },
                                file_name:{
                                    input_type: 'none',
                                },
                                driver_train_description: {
                                    input_type: 'text',
                                    placeholder: 'หมายเหตุ',
                                    required: false,
                                    col_span: 23
                                },
                            }
                        },
                        drawer_button_text: 'เพิ่ม',
                        drawer_button_text_edit: 'แก้ไขไฟล์'
                        },
                        document_field_7: {
                        input_type: 'table',
                        required: false,
                        col_span: 23,
                        drawer_title: 'ประวัติการทำงานบกพร่อง',
                        table_columns: [
                            { title: 'วัน/เดือน/ปี', dataIndex: 'driver_work_defect_date', key: 'driver_work_defect_date' },
                            { title: 'เบอร์รถตอนเกิดเหตุ', dataIndex: 'driver_work_defect_car', key: 'driver_work_defect_car' },
                            { title: 'ประเภทข้อบกพร่อง', dataIndex: 'driver_work_defect_type', key: 'driver_work_defect_type' },
                            { title: 'รายละเอียด', dataIndex: 'driver_work_defect_detail', key: 'driver_work_defect_detail' },
                            { title: 'การลงโทษ', dataIndex: 'driver_work_defect_punishment', key: 'driver_work_defect_punishment' },
                            { title: 'แนบเอกสาร', dataIndex: 'file_name', key: 'file_name' },
                            {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 100,
                                    align: 'center',
                            },
                        ],
                        drawer_fields: {
                            inputs: {
                                driver_work_defect_date: {
                                    input_type: 'date',
                                    placeholder: 'วัน/เดือน/ปี',
                                    required: false,
                                    col_span: 23
                                },
                                driver_work_defect_car: {
                                    input_type: 'select',
                                    placeholder: 'เบอร์รถตอนเกิดเหตุ',
                                    required: false,
                                    col_span: 23,
                                    options: []
                                },
                                driver_work_defect_type: {
                                    input_type: 'select',
                                    placeholder: 'ประเภทข้อบกพร่อง',
                                    required: false,
                                    col_span: 23,
                                    options: [
                                        { label: 'ข้อร้องเรียนจากลูกค้า', value: 'ข้อร้องเรียนจากลูกค้า' },
                                        { label: 'ข้อร้องเรียนผู้ร่วมทาง', value: 'ข้อร้องเรียนผู้ร่วมทาง' },
                                        { label: 'ข้อบกพร่องการทำงาน (ระบุ)', value: 'ข้อบกพร่องการทำงาน (ระบุ)' },
                                        { label: 'ประพฤติผิดวินัย (ระบุ)', value: 'ประพฤติผิดวินัย (ระบุ)' },
                                        { label: 'อื่นๆ', value: 'OTHER' }
                                    ],
                                },
                                driver_work_defect_detail: {
                                    input_type: 'text',
                                    placeholder: 'รายละเอียด',
                                    required: false,
                                    col_span: 23
                                },
                                driver_work_defect_punishment: {
                                    input_type: 'text',
                                    placeholder: 'การลงโทษ',
                                    required: false,
                                    col_span: 23
                                },
                                file: {
                                    input_type: 'file',
                                    placeholder: 'เอกสาร/ใบประกาศ (ถ้ามี)',
                                    required: false,
                                    col_span: 23,
                                    accept: '.pdf'
                                },
                                file_name:{
                                    input_type: 'none',
                                },
                            }
                        },
                        drawer_button_text: 'เพิ่ม',
                        drawer_button_text_edit: 'แก้ไขไฟล์'
                        },
                        document_field_8: {
                        options: [],
                        input_type: 'table',
                        required: false,
                        col_span: 23,
                        drawer_title: 'ประวัติการเกิดอุบัติเหตุ',
                        table_columns: [
                            { title: 'วัน/เดือน/ปี', dataIndex: 'driver_accident_date', key: 'driver_accident_date' },
                            { title: 'เบอร์รถตอนเกิดเหตุ', dataIndex: 'driver_accident_car', key: 'driver_accident_car' },
                            { title: 'ผิด/ถูก', dataIndex: 'driver_accident_result', key: 'driver_accident_result' },
                            { title: 'รายละเอียด', dataIndex: 'driver_accident_detail', key: 'driver_accident_detail' },
                            { title: 'ค่าเสียหาย', dataIndex: 'driver_accident_total', key: 'driver_accident_total' },
                            { title: 'หมายเหตุ', dataIndex: 'driver_accident_description', key: 'driver_accident_description' },
                            {
                                    title: 'ตัวเลือก',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width: 100,
                                    align: 'center',
                            },
                        ],
                        drawer_fields: {
                            inputs: {
                                driver_accident_date: {
                                    input_type: 'date',
                                    placeholder: 'วัน/เดือน/ปี',
                                    required: false,
                                    col_span: 23
                                },
                                driver_accident_car: {
                                    input_type: 'select',
                                    placeholder: 'เบอร์รถตอนเกิดเหตุ',
                                    required: false,
                                    col_span: 23,
                                    options:  [],       
                                },
                                driver_accident_result: {
                                    input_type: 'select',
                                    placeholder: 'ฝ่าย(ผิด/ถูก)',
                                    required: false,
                                    col_span: 23,
                                    options: [
                                        { label: 'ฝ่ายผิด', value: 'ฝ่ายผิด' },
                                        { label: 'ฝ่ายถูก', value: 'ฝ่ายถูก' }
                                    ]
                                },
                                driver_accident_detail: {
                                    input_type: 'text',
                                    placeholder: 'รายละเอียด',
                                    required: false,
                                    col_span: 23
                                },
                                driver_accident_total: {
                                    input_type: 'text',
                                    placeholder: 'ค่าเสียหาย',
                                    required: false,
                                    col_span: 23
                                },
                                driver_accident_description: {
                                    input_type: 'text',
                                    placeholder: 'หมายเหตุ',
                                    required: false,
                                    col_span: 23
                                },
                            }
                        },
                        drawer_button_text: 'เพิ่ม',
                        drawer_button_text_edit: 'แก้ไขไฟล์'
                        }
                    }
                }
            },
            model_form: {
                key: null // Initialize with your appropriate key
            },
            sex_types: [],
            check_keys_to_modelname: {
                driver_no: 'Driver',
                username: 'ClientContact',
                plate_no: 'Car'
            },
            delayed: null,
            oldPassword: null,
            changeWorkStatus: false,
            usedDriver: [],
            old_part_type: null,
            old_tax_id: null,
            old_barcode: null,
            old_part: null,
            arrays_old_rule: ['PartType','PartUnit','Vendor','Technician','Part','StockHistory','CarRepairType','CarType'],        }
    },
    methods: {
        printCheck(data){
            console.log("ssssa",data)
        },
        validate_part_type_duplicate: validatePartType,
        validate_phone: validatePhoneNo,
        validate_tax_duplicate: validateTaxId,
        validate_fax: validateFaxNo,
        validate_email_duplicate: validateEmail,
        validate_number: validateNumber,
        validate_decimal: validateDecimal,
        validate_part_duplicate: validatePart,
        validate_barcode_duplicate: validateBarcode,
        validate_repair_type_duplicate: validateCarRepairType,
        validate_cartype_name_duplicate: validateCarTypeName,
        updateFieldsBasedOnBusiness(businessValue) {
            
            if (businessValue) {
                this.default_fields.CarGroup.inputs.price.col_span = 23;  
                this.default_fields.CarGroup.inputs.seats.col_span = 0;  
                this.default_fields.CarGroup.inputs.seats.required = false;
                this.default_fields.Car.inputs.car_brand.col_span = 5;
                this.default_fields.Car.inputs.car_model.col_span = 6;
                this.default_fields.Car.inputs.year_registration.col_span = 5;
                this.default_fields.Car.inputs.chassis_number.col_span = 6;
                delete this.default_fields.Driver.inputs.driver_job_position;
            } else {
                this.default_fields.CarGroup.inputs.price.col_span = 11; 
                this.default_fields.CarGroup.inputs.seats.col_span = 11;  
                this.default_fields.Car.inputs.year_registration.col_span = 0;

            }
        },
        updateFieldBusiness4 (value) {
            if (value) {
                this.default_fields.Driver.inputs.affiliation.col_span = 11;
                this.default_fields.Driver.inputs.nickname.col_span = 11;
                this.default_fields.Driver.inputs.driver_bank.col_span = 11;
                this.default_fields.Driver.inputs.set_leader.col_span = 11;
                this.default_fields.Driver.inputs.price_gps.col_span = 11;
                this.default_fields.Driver.inputs.car_id.col_span = 11;
                this.default_fields.Driver.inputs.car_code.col_span = 11;
                this.default_fields.Driver.inputs.car_line.col_span = 11;
                this.default_fields.Driver.inputs.gps.col_span = 11;
                this.default_fields.Driver.inputs.diligence_allowance.col_span = 11;
                // this.default_fields.Driver.inputs.driver_license_no.col_span = 11;
                this.default_fields.Driver.inputs.phone_emergency.col_span = 11;
                this.default_fields.Driver.inputs.driver_age_of_work.col_span = 11;
                this.default_fields_driver.Driver.inputs.card_id_expire.col_span = 11;
                this.default_fields_driver.Driver.inputs.phone_emergency.col_span = 11;
                this.default_fields_driver.Driver.inputs.phone_no.col_span = 11;
                this.default_fields_driver.Driver.inputs.phone_no.non_editable = true;
                this.default_fields_driver.Driver.inputs.register_date.col_span = 11;
                this.default_fields_driver.Driver.inputs.driver_age_of_work.col_span = 11;
                this.default_fields_driver.Driver.inputs.driver_current_car_no.non_editable = true;
                this.default_fields_driver.Driver.inputs.driver_current_car_no.col_span = 11;
                this.default_fields_driver.Driver.inputs.driver_stoped_employment_date.col_span = 0;
                this.default_fields_driver.Driver.inputs.driver_work_status.col_span = 22;
                this.default_fields_driver.Driver.inputs.driver_address_sub_district.col_span = 11;
                this.default_fields_driver.Driver.inputs.driver_address_village.col_span = 11;
                this.default_fields_driver.Driver.inputs.driver_address_alley.col_span = 11;
                this.default_fields_driver.Driver.inputs.driver_address_road.col_span = 11;
                this.default_fields_driver.Driver.inputs.id_no.non_editable = true;
                this.default_fields_driver.Driver.inputs.date_of_birth.non_editable = true;
                this.default_fields_driver.Driver.inputs.age.non_editable = true;
                this.default_fields.Driver.inputs.nickname.required = true;
                this.default_fields.Driver.inputs.affiliation.required = true;
                this.default_fields_driver.Driver.inputs.nickname.col_span = 11;
                this.default_fields_driver.Driver.inputs.affiliation.col_span = 11;
                this.default_fields_driver.Driver.inputs.nickname.col_span = 11;
                this.default_fields_driver.Driver.inputs.card_id_expire.col_span = 11;
                this.default_fields_driver.Driver.inputs.driving_license_exp.col_span = 11;
                this.default_fields_driver.Driver.inputs.car_code.col_span = 11;
                this.default_fields_driver.Driver.inputs.car_line.col_span = 11;
                this.default_fields_driver.Driver.inputs.gps.col_span = 11;
                this.default_fields_driver.Driver.inputs.salary_rate.col_span = 11;
                this.default_fields_driver.Driver.inputs.set_leader.col_span = 11;
                this.default_fields_driver.Driver.inputs.price_gps.col_span = 11;
                this.default_fields_driver.Driver.inputs.diligence_allowance.col_span = 11;
                this.default_fields_driver.Driver.inputs.document_field_7.drawer_fields.inputs.driver_work_defect_type.options = [
                { label: 'ขับรถไม่เกิน 90 กิโลเมตรต่อชั่วโมง', value: 'ขับรถไม่เกิน 90 กิโลเมตรต่อชั่วโมง' },
                { label: 'ปฏิบัติหน้าที่ให้ตรงตามเวลที่กำหนด', value: 'ปฏิบัติหน้าที่ให้ตรงตามเวลที่กำหนด' },
                { label: 'ต้องไม่มีเรื่องร้องเรียนจากลูกค้าหรือบุคคลที่ใช้รถบนถนนร่วมกัน', value: 'ต้องไม่มีเรื่องร้องเรียนจากลูกค้าหรือบุคคลที่ใช้รถบนถนนร่วมกัน' },
                { label: 'ต้องเปิดสัญญาณไฟทุกครั้งก่อนเปลี่ยนช่องทางการจราจร', value: 'ต้องเปิดสัญญาณไฟทุกครั้งก่อนเปลี่ยนช่องทางการจราจร' },
                { label: 'ห้ามสูบบุหรี่และดื่มแอลกอฮอล์ในขณะที่ปฏิบัติหน้าที่', value: 'ห้ามสูบบุหรี่และดื่มแอลกอฮอล์ในขณะที่ปฏิบัติหน้าที่' },
                { label: 'ขณะขับรถต้องใช้อุปกรณ์เสริมเท่านั้น (หูฟังบลูทูธ , สมอลทอร์ค)', value: 'ขณะขับรถต้องใช้อุปกรณ์เสริมเท่านั้น (หูฟังบลูทูธ , สมอลทอร์ค)' },
                { label: 'ห้ามนำสิ่งของมาปิดบังตัวกล้องทุกกรณี', value: 'ห้ามนำสิ่งของมาปิดบังตัวกล้องทุกกรณี' },
                { label: 'ห้ามนำอาหารมารับประทานในรถ', value: 'ข้อร้องเรียนจากลูกค้า' },
                { label: 'แต่งกายตามยูนิฟอร์มของบริษัทฯ เท่านั้น', value: 'แต่งกายตามยูนิฟอร์มของบริษัทฯ เท่านั้น' },
                { label: 'ปฏิบัติตามกฎจราจรอย่างเคร่งครัด (ในกรณีที่มีค่าปรับ ทางลูกจ้างต้องรับผิดชอบค่าใช้จ่ายทั้งหมด)', value: 'ปฏิบัติตามกฎจราจรอย่างเคร่งครัด (ในกรณีที่มีค่าปรับ ทางลูกจ้างต้องรับผิดชอบค่าใช้จ่ายทั้งหมด)' },
                { label: 'ห้ามใช้ตัวตัดสัญญาณ GPS ทุกกรณี', value: 'ห้ามใช้ตัวตัดสัญญาณ GPS ทุกกรณี' },
                { label: 'กรณีที่ลูกจ้างทำผิดกฎระเบียบ และนายจ้างได้มีการสอบสวนแล้ว แต่ยังมีการกระทำความผิดซ้ำในทุกกรณีทางนายจ้างจะทำการปรับเป็นจำนวนครั้งละ 1,000 บาท (โดยหักจากเงินเดือน)', value: 'กรณีที่ลูกจ้างทำผิดกฎระเบียบ และนายจ้างได้มีการสอบสวนแล้ว แต่ยังมีการกระทำความผิดซ้ำในทุกกรณีทางนายจ้างจะทำการปรับเป็นจำนวนครั้งละ 1,000 บาท (โดยหักจากเงินเดือน)' },
                { label: 'ต้องคาดเข็มขัดนิรภัยในขณะที่ปฏิบัติหน้าที่ทุกครั้ง', value: 'ต้องคาดเข็มขัดนิรภัยในขณะที่ปฏิบัติหน้าที่ทุกครั้ง' },
                { label: 'ต้องไม่นำรถไปใช้นอกเส้นทางทุกกรณี (มีการแจ้งปรับ 5 บาท/กิโลเมตร , ไม่มีการแจ้งปรับ 10 บาท/กิโลเมตร)', value: 'ต้องไม่นำรถไปใช้นอกเส้นทางทุกกรณี (มีการแจ้งปรับ 5 บาท/กิโลเมตร , ไม่มีการแจ้งปรับ 10 บาท/กิโลเมตร)' },
                { label: 'ต้องไม่แสดงพฤติกรรมเชิงชู้สาวกับผู้ใช้บริการ', value: 'ต้องไม่แสดงพฤติกรรมเชิงชู้สาวกับผู้ใช้บริการ' },
                { label: 'ต้องปฏิบัติตามคำสั่งของผู้บังคับบัญชาอย่างเคร่งครัด', value: 'ต้องปฏิบัติตามคำสั่งของผู้บังคับบัญชาอย่างเคร่งครัด' },
                ]
                this.default_fields_driver.Driver.inputs.salary.col_span = 0;
                this.default_fields_driver.Driver.inputs.driver_tax_rate_service.col_span = 0;
                this.default_fields_driver.Driver.inputs.id_no.col_span = 11;
                this.default_fields_driver.Driver.inputs.bank_accno.non_editable = true;
                this.default_fields_driver.Driver.inputs.driver_no.non_editable = true;
                this.default_fields_driver.Driver.inputs.driver_job_position.non_editable = true;
                // this.default_fields_driver.Driver.inputs.driver_license_no.non_editable = true;
                this.default_fields_driver.Driver.inputs.firstname.non_editable = true;
                this.default_fields_driver.Driver.inputs.lastname.non_editable = true;
                this.default_fields_driver.Driver.inputs.age.input_type = 'text';
                this.default_fields_driver.Driver.inputs.date_of_birth.input_type = 'date_of_birth';
                delete this.default_fields.Insure.inputs.insure_premium_capital;
                delete this.default_fields.Insure.inputs.insure_premium_protection;
                delete this.default_fields.Insure.inputs.product_premium_capital;
                delete this.default_fields.Insure.inputs.product_premium_protection;
                delete this.default_fields.Car.inputs.photo_1;
                delete this.default_fields.Car.inputs.photo_2;
                delete this.default_fields.Car.inputs.photo_3;
                delete this.default_fields.Car.inputs.photo_4;
                delete this.default_fields.Car.inputs.check_head_registration_registration;
            } else {
                this.default_fields.Driver.inputs.affiliation.col_span = 0;
                this.default_fields.Driver.inputs.car_id.col_span = 0;
                this.default_fields.Driver.inputs.car_code.col_span = 0;
                this.default_fields.Driver.inputs.car_line.col_span = 0;
                this.default_fields.Driver.inputs.gps.col_span = 0;
                this.default_fields.Driver.inputs.nickname.col_span = 0;
                this.default_fields.Driver.inputs.driver_bank.col_span = 0;
                this.default_fields.Driver.inputs.set_leader.col_span = 0;
                this.default_fields.Driver.inputs.price_gps.col_span = 0;
                this.default_fields.Driver.inputs.diligence_allowance.col_span = 0;
                this.default_fields.Driver.inputs.phone_emergency.col_span = 0;
                this.default_fields.Driver.inputs.driver_age_of_work.col_span = 0;
                this.default_fields_driver.Driver.inputs.phone_emergency.col_span = 0;
                this.default_fields_driver.Driver.inputs.nickname.col_span = 0;
                this.default_fields_driver.Driver.inputs.affiliation.col_span = 0;
                this.default_fields_driver.Driver.inputs.card_id_expire.col_span = 0;
                this.default_fields_driver.Driver.inputs.driving_license_exp.col_span = 0;
                this.default_fields_driver.Driver.inputs.car_code.col_span = 0;
                this.default_fields_driver.Driver.inputs.car_line.col_span = 0;
                this.default_fields_driver.Driver.inputs.gps.col_span = 0;
                this.default_fields_driver.Driver.inputs.salary_rate.col_span = 0;
                this.default_fields_driver.Driver.inputs.set_leader.col_span = 0;
                this.default_fields_driver.Driver.inputs.price_gps.col_span = 0;
                this.default_fields_driver.Driver.inputs.diligence_allowance.col_span = 0;
                // this.default_fields_driver.Driver.inputs.driver_work_defect_type.options = [{label: 'test',value:'test'}];
                
            }
        },
        async handleSalaryChange(value) {
            if (this.car_rental_a) {
                this.model_form['salary_rate'] = this.model_form['salary']
            }
        },
        BasedOnBusiness() {
            this.default_fields.Car.inputs.car_brand.col_span = 7;
            this.default_fields.Car.inputs.car_model.col_span = 7;
            this.default_fields.Car.inputs.chassis_number.col_span = 8;

            this.default_fields.Insure.inputs.divider_3.col_span = 23;
          this.default_fields.Insure.inputs.car_register_date.col_span = 7;
          this.default_fields.Insure.inputs.car_tax_rate.col_span = 7;
          this.default_fields.Insure.inputs.car_appearance.col_span = 7;
          this.default_fields.Insure.inputs.car_inspect_1.col_span = 10;
          this.default_fields.Insure.inputs.car_inspect_2.col_span = 10;

            this.default_fields.Car.inputs.car_width.col_span = 0;
            this.default_fields.Car.inputs.car_length.col_span = 0;
            this.default_fields.Car.inputs.car_height.col_span = 0;
            this.default_fields.Car.inputs.loadable_weight.col_span = 0;
            this.default_fields.Car.inputs.head_registration.col_span = 0;
            this.default_fields.Car.inputs.tail_registration.col_span = 0;
            this.default_fields.Car.inputs.topic_truck_size.col_span = 0;
        },
        
        async options() {
            const response = await SystemService.get_core('getOptions');
            this.optionsList = response.map(option => ({
            label: option.name,
            value: option.id
            }));
        },
        updateWorkAge() {
            if (!this.model_form.register_date) {
                this.model_form.driver_age_of_work = '';
                return;
            }

            const startDate = new Date(this.model_form.register_date);
            if (isNaN(startDate)) {
                this.model_form.driver_age_of_work = '';
                return;
            }

            const today = new Date(this.today);
            const diffTime = Math.abs(today - startDate);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            this.model_form.driver_age_of_work = `${diffDays} วัน`;
        },
        async handleChangeCardId() {
            if (this.car_rental_a) {
                this.model_form['id_no'] = this.model_form['card_id']
            }
        },
        async handleChange(type, event,action) {
            if (action === 'plate' && this.car_rental_a) {
                this.model_form['driver_current_car_no'] = this.car_list.find(item => item.id === this.model_form['car_id'])?.plate_no
            }
            if(type === 'CarType'){
                this.model_form['consumption_rate'] = this.selectables['CarType'].find(item => item.id === this.model_form['car_type_id'])?.consumption_rate;
                this.model_form['start_gas_date'] = dayjs();
            }
            if(type === 'GasType') {
                this.model_form['unit'] = this.selectables['GasType'].find(item => item.id === this.model_form['gas_type_id'])?.unit;
                this.model_form['start_gas_date'] = dayjs();
            }
            if (type === 'start') {
                this.start = event.target.checked;
                if (this.start) {
                    this.end = false;
                    this.model_form.driver_stoped_employment_date = null;
                }
            } else if (type === 'end') {
                this.end = event.target.checked;
                if (this.end) {
                    this.start = false;
                }
            }
            if (type === 'disable') {
                this.disabletest = !this.disabletest;
                if (this.disabletest) {
                    this.disableId = "บริษัทรถ"
                    this.car_company = await SystemService.get_all("CarCompany")
                    this.model_form.car_company_id = this.car_company[0]?.id
                } else {
                    this.car_company = await CarCompanyService.get_car_companies_3rd();
                    this.disableId = "บริษัทรถร่วม"
                    this.model_form.car_company_id = this.car_company[0]?.id
                }
            }
            if(type == 'work_status',this.model_type == 'Driver'){
                if(this.model_form.work_status_id == 2 || this.model_form.work_status_id == 3){
                    this.changeWorkStatus = true;
                }
            }
            this.showEmploymentEndDate = !this.start;
        },
        formatPhoneNumber(e) {
            let text = this.model_form[e] || '';
  
            let numbers = text.match(/\d/g) || [];

            if (e === 'phone_no') {
                if (text.length  > 10 || numbers.length > 10) {
                let count = 0;
                let newText = '';

                for (let char of text) {
                if (newText.length >= 10) break;

                if (/\d/.test(char)) {
                    if (count >= 10) {
                    continue;
                    }
                    count++;
                }
                newText += char;
                }
                return this.model_form[e] = newText;
            } else {
                return this.model_form[e] = text;
            }
            }
            if (text.length  > 20 || numbers.length > 15) {
                let count = 0;
                let newText = '';

                for (let char of text) {
                if (newText.length >= 20) break;

                if (/\d/.test(char)) {
                    if (count >= 15) {
                    continue;
                    }
                    count++;
                }
                newText += char;
                }
                this.model_form[e] = newText;
            } else {
                this.model_form[e] = text;
            }
        },
        async handleChangeregistration(type, event,action) {
            if (action === 'plate' && this.car_rental_a) {
                this.model_form['driver_current_car_no'] = this.car_list.find(item => item.id === this.model_form['car_id'])?.plate_no
            }
            if (type === 'head') {
                this.headRegistration = !this.headRegistration
                if (this.headRegistration) {
                    this.model_form.head_registration = null
                }
            } else if (type === 'tail') {
                this.tailRegistration = !this.tailRegistration
                if (this.tailRegistration) {
                    this.model_form.tail_registration = null
                }
            }
        },
        setFileType(file) {
            const fileType = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif' 
            || file.type === 'image/raw' || file.type === 'image/webp' || file.type === 'image/tif' || file.type === 'image/psd' || file.type === 'image/svg';
                if (!fileType) {
                    this.$message.error('คุณสามารถอัปโหลดได้เฉพาะไฟล์รูปภาพเท่านั้น!');
                }
            return fileType
        },
        handleChangeDrivingLicenseType(value) {
            if (![1, 2, 3].includes(value)) {
                this.model_form.driving_license_type_id = null;
            } else {
                this.model_form.driving_license_type_id = value;
            }
        },
        handleEducationChange(value, key) {
            if (value === 'อื่นๆ') {
                this.currentFieldKey = key;
                this.showOtherEducationModal = true;
            }
        },
        handleModalOk() {
            this.model_form[this.currentFieldKey] = this.otherEducationInput;
            this.showOtherEducationModal = false;
            this.otherEducationInput = '';
        },
        handleModalCancel() {
            this.showOtherEducationModal = false;
            this.otherEducationInput = '';
        },
        handleIconClick(action, payload, event) {
            event.stopPropagation();
            if (action === 'preview') {
                this.showPreview(payload);
            } else if (action === 'delete') {
                this.model_form[payload] = '';
                this.fileList = [];
            }
        },
        showPreview(imageUrl) {
            this.previewImage = imageUrl;
            this.previewVisible = true;
        },
        // upload_files(event, key) {
            // Your upload file logic here
        // },
        async client_no_on_change() {
            this.model_form.client_no = this.model_form.client_no || await SystemService.get_client_no();
        },
        validatePassword(_, value) {
			if (value?.length < 6 || value?.length > 15) {
				return Promise.reject('ยืนยันรหัสผ่านต้องมีความยาว 6-15 ตัวอักษร')
			}
            const passwordPattern = /^[a-zA-Z0-9@#$%^&*()\-_=+]+$/;
			if (!passwordPattern.test(value)) {
				return Promise.reject('ยืนยันรหัสผ่านต้องมีแค่ตัวพิมพ์ใหญ่ ตัวเลข และอักขระพิเศษเท่านั้น')
			}
			return Promise.resolve()
		},
        async validate_driver(_rule, value) {
            const currentValue = value;
            return new Promise((resolve, reject) => {
                if(_rule.required && !value) {
                        reject('โปรดระบุ');
                }

                const allowedPattern = /^[a-zA-Z0-9_.]+$/;
                // เช็ก pattern ถ้ามี
                if (!allowedPattern.test(currentValue) || currentValue.length < 4 || currentValue.length > 30) {
                    reject("ชื่อผู้ใช้ต้องมีความยาว 4–30 ตัวอักษร และต้องไม่มีอักขระพิเศษ");
                    return;
                }

                const onlyNumbers = /^[0-9]+$/;
                if (onlyNumbers.test(currentValue)) {
                    reject("ไม่สามารถใช้ตัวเลขล้วนได้");
                    return;
                }
                setTimeout(() => {
                    this.$route.params.id == 'create' ? 
                    SystemService.check_duplicate(
                        this.model_type,
                        // this.check_keys_to_modelname[_rule.field],
                        `field=${_rule.field}&value=${value}&id=${this.action_type}`
                    ).then((res) => {
                        if (this.model_form?.username !== currentValue) {
                            return;
                        }
                        if (res) {
                            reject("มีข้อมูลนี้อยู่แล้ว");
                        } else {
                            resolve();
                        }
                    })
                    : resolve();
                }, 0);
            });
        },
         async validate_duplicate(_rule, value) {
            const currentValue = value;
            return new Promise((resolve, reject) => { 
                if (_rule.required && !currentValue) {
                    reject('โปรดระบุ');
                }
                setTimeout(() => {
                    SystemService.check_duplicate(
                        this.model_type,
                        `field=${_rule.field}&value=${currentValue}&id=${this.action_type}`
                    ).then((res) => {
                        if (this.model_form?.[_rule.field] !== currentValue) {
                            return;
                        }
                        if (res) {
                            reject("มีข้อมูลนี้อยู่แล้ว");
                        } else {
                            resolve();
                        }
                    }).catch(() => {
                        resolve(); // ถ้า API error ให้ผ่านไปเลย
                    });
                }, 0);
            });
        },

        async validate_duplicate_conf(_rule, value) {
            return new Promise((resolve, reject) => {
                if (_rule.required && !value) {
                    reject('โปรดระบุ');
                    return;
                }
                const field = _rule.field;
                const pattern = /^[a-zA-Zก-๙0-9\s\-]+$/;
                
                if (this.model_type === 'CarType' && field === 'name' && !pattern.test(value)) {
                    resolve();
                    return;
                }
                if (this.model_type === 'CarCompany' && field === 'fullname' && !pattern.test(value)) {
                    resolve();
                    return;
                }
                if (this.model_type === 'Expense' && field === 'name' && !pattern.test(value)) {
                    resolve();
                    return;
                }
                if (this.model_type === 'CarCompany' && field !== 'fullname') {
                    resolve();
                    return;
                }
                if (this.model_type === 'Client' && field == 'car_company_id') {
                    resolve();
                    return;
                }
                if (this.model_type === 'DriverCost' && field  === 'name') {
                    resolve();
                    return;
                }
                if (this.model_type === 'DriverCost' && field  === 'business_type') {
                    resolve();
                    return;
                }
                 if (this.model_type === 'Client' && field === 'organ_accout_number') {
                    const acc = value;
                    if (!acc) {
                        resolve();
                        return;
                    }
                    const onlyNumbers = acc.replace(/\D/g, '');
                    const isOnlyNumbers = /^\d+(-\d+)*$/.test(acc);
                    if (!isOnlyNumbers) {
                        reject('เลขที่บัญชีต้องเป็นตัวเลขเท่านั้น ห้ามมีช่องว่างหรืออักขระพิเศษ');
                        return;
                    }
                    if (onlyNumbers.length < 10) {
                        reject('กรุณากรอกเลขบัญชีให้ครบถ้วน (อย่างน้อย 10 หลัก)');
                        return;
                    }
                    resolve();
                    return;
                }
                if (this.model_type === 'Client' && field  === 'bank') {
                    resolve();
                    return;
                }
                if (this.model_type === 'Client' && field  === 'account_type') {
                    resolve();
                    return;
                }     
                if (this.model_type === 'Client' && field  === 'branch') {
                    resolve();
                    return;
                }
                if (this.model_type === 'Client' && field  === 'remark') {
                    resolve();
                    return;
                }
                if (this.model_type === 'Client' && field  === 'data_raw_files') {
                    resolve();
                    return;
                }
                if (this.model_type === 'Client' && field  === 'address') {
                    resolve();
                    return;
                }
                if (this.model_type === 'ClientBranch' && field === 'phone_no') {
                    const phonePattern = /^\d{10}$/;
                    if (!phonePattern.test(value)) {
                        reject("กรุณาระบุเบอร์โทรให้ถูกต้อง 10 หลัก เช่น 0912345678");
                        return;
                    }
                }
               if (this.model_type === 'Client' && field === 'email') {
                    const emailStrict = /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{1,}(?<!\.)@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
                    if (_rule.required && !value) {
                        reject('โปรดระบุ อีเมลองค์กร');
                        return;
                    }
                    if (!_rule.required && !value) {
                        resolve();
                        return;
                    }
                    const [local, domain] = value.split('@');
                    if (!local || !domain) {
                        reject();
                        return;
                    }
                    if (local.length > 64) {
                        reject('อีเมลส่วนหน้าก่อน @ ยาวเกิน 64 ตัวอักษร');
                        return;
                    }
                    if (domain.length > 255) {
                        reject('อีเมลโดเมนยาวเกิน 255 ตัวอักษร');
                        return;
                    }
                    resolve();
                }
                if(this.model_type === 'Client' && field === 'accounting_email') {
                    const emailStrict_accounting = /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{1,}(?<!\.)@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
                    if (_rule.required && !value) {
                        reject('โปรดระบุ อีเมลผู้ติดต่อฝ่ายบัญชี');
                        return;
                    }
                    if (!_rule.required && !value) {
                        resolve();
                        return;
                    }
                    const [local, domain] = value.split('@');
                    if (!local || !domain) {
                        reject();
                        return;
                    }
                    if (local.length > 64) {
                        reject('อีเมลส่วนหน้าก่อน @ ยาวเกิน 64 ตัวอักษร');
                        return;
                    }
                    if (domain.length > 255) {
                        reject('อีเมลโดเมนยาวเกิน 255 ตัวอักษร');
                        return;
                    }
                    resolve();
                }
                setTimeout(() => {
                    SystemService.check_duplicate(
                        this.model_type,
                        `field=${_rule.field}&value=${value}&id=${this.action_type}`
                    ).then((res) => {
                        if (res) {
                            if (this.model_type === 'PartUnit') {
                                reject("ชื่อหน่วยอะไหล่นี้มีอยู่แล้ว กรุณาใช้ชื่ออื่น");
                            } else if (this.model_type === 'CarCompany' && field  === 'fullname') {
                                reject("พบชื่อบริษัทและที่อยู่นี้ในระบบแล้ว กรุณาระบุที่อยู่เพิ่มเติม เช่น เลขที่ อาคาร หรือสาขา");
                            }else if (this.model_type === 'CarType'){
                                reject("ยี่ห้อรถซ้ำ กรุณาตรวจสอบอีกครั้ง");
                            } else if (this.model_type === 'Expense'){
                                reject("ชื่อประเภทนี้มีอยู่แล้ว กรุณาใช้ชื่ออื่น");
                            } else if (this.model_type === 'DriverCost' && field  === 'name') {
                                reject("ชื่อเบี้ยเลี้ยงนี้มีอยู่แล้วในระบบ");
                            } else if (this.model_type === 'DriverCost' && field  === 'business_type') {
                                reject("ประเภทการจองนี้มีอยู่แล้วในระบบ");
                            }
                            else {
                                reject("มีข้อมูลนี้อยู่แล้ว"); 
                            }
                        } else {
                            resolve(); 
                        }
                    }).catch(() => {
                        resolve();
                    });
                }, 0);
            });
        },

        computedRules(field_key) {  
            const alphaNumThai = /^[a-zA-Zก-๙0-9\s]+$/;
            const emailStrict = /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{1,}(?<!\.)@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
            const emailStrict_accounting = /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{1,}(?<!\.)@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
            const phone10 = /^\d{9,10}$/;
            const tax13 = /^\d{13}$/;
            const decimal = /^\d+(\.\d{1,2})?$/;
            const greaterThanZero = /^(?!0+(\.0+)?$)\d+(\.\d+)?$/;

            const duplicate = { validator: this.validate_duplicate_conf, trigger: ['change', 'blur'] };
            const defaultRule = [duplicate];
            const phoneValidator = (_, value) => {
                if (!value) return Promise.resolve();

                const cleaned = value.replace(/-/g, '');
                return /^\d{9,10}$/.test(cleaned)
                    ? Promise.resolve()
                    : Promise.reject('กรุณาระบุเบอร์โทรไม่เกิน 10 หลัก');
            };

            const ruleMap = {
            PartUnit: [
                { pattern: alphaNumThai, message: 'ชื่อหน่วยอะไหล่ต้องเป็นตัวอักษรหรือตัวเลขเท่านั้น', trigger: ['change', 'blur'] },
                { max: 30, message: 'ชื่อหน่วยอะไหล่ต้องไม่เกิน 30 ตัวอักษร', trigger: ['change', 'blur'] },
                duplicate,
            ],

            CarCompany: {
                fullname: [
                { pattern: alphaNumThai, message: 'มีอักขระที่ไม่อนุญาต กรุณาตรวจสอบ', trigger: ['change', 'blur'] },
                { max: 50, message: 'ชื่อบริษัทต้องไม่เกิน 50 ตัวอักษร', trigger: ['change', 'blur'] },
                duplicate,
                ]
            },

            Client: {
                fullname: [
                { pattern: alphaNumThai, message: 'กรุณาระบุชื่อบริษัทใหม่ ห้ามมีตัวอักษรพิเศษต้องห้าม (เช่น @, %, #)', trigger: ['change', 'blur'] },
                ],
                email: [
                { pattern: emailStrict, message: 'รูปแบบ (Format) เบื้องต้นของอีเมล username@domain.tld', trigger: ['change', 'blur'] },
                duplicate,
                ],
                tax_id: [
                { pattern: tax13, message: 'กรุณาระบุเลขประจำตัวผู้เสียภาษีใหม่ ไม่เกิน 13 หลัก', trigger: ['change', 'blur'] },
                ],
                phone_no: [
                {  validator: phoneValidator, message: 'กรุณาระบุเบอร์โทรใหม่ไม่เกิน10หลัก', trigger: ['change', 'blur'] },
                ],
                phone_backup: [
                {  validator: phoneValidator, message: 'กรุณาระบุเบอร์โทรสำรองไม่เกิน10หลัก', trigger: ['change', 'blur'] },
                ],
                accounting_contact: [
                { pattern: alphaNumThai, message: 'กรุณาระบุข้อมูลผู้ติดต่อฝ่ายบัญชีใหม่ห้ามมีตัวอักษรพิเศษต้องห้าม (เช่น @, %, #)', trigger: ['change', 'blur'] },
                ],
                accounting_email: [
                { pattern: emailStrict_accounting,message: 'รูปแบบ (Format) เบื้องต้นของอีเมล username@domain.tld', trigger: ['change', 'blur'] },
                duplicate,
                ],
                accounting_phone: [
                {  validator: phoneValidator, message: 'กรุณาระบุเบอร์โทรผู้ติดต่อฝ่ายบัญชีไม่เกิน10หลัก', trigger: ['change', 'blur'] },
                ],
            },

            Expense: [
                { pattern: /^[a-zA-Zก-๙\s]+$/, message: 'มีอักขระที่ไม่อนุญาต กรุณาตรวจสอบ', trigger: ['change', 'blur'] },
                duplicate,
            ],

            DriverCost: {
                name: [
                { max: 50, message: 'ชื่อเบี้ยเลี้ยงต้องไม่เกิน 50 ตัวอักษร', trigger: ['change', 'blur'] },
                { pattern: alphaNumThai, message: 'ห้ามใช้สัญลักษณ์พิเศษในชื่อเบี้ยเลี้ยง', trigger: ['change', 'blur'] },
                duplicate,
                ],
                business_type: [
                { max: 50, message: 'ชื่อประเภทการจองต้องไม่เกิน 50 ตัวอักษร', trigger: ['change', 'blur'] },
                { pattern: alphaNumThai, message: 'ห้ามใช้สัญลักษณ์พิเศษในชื่อประเภทการจอง', trigger: ['change', 'blur'] },
                duplicate,
                ],
                cost_per_day: [
                { pattern: greaterThanZero, message: 'กรุณากรอกตัวเลขที่มากกว่า 0', trigger: ['change', 'blur'] },
                { pattern: decimal, message: 'ทศนิยมต้องไม่เกิน 2 ตำแหน่ง', trigger: ['change', 'blur'] },
                ],
            },
            };
            const model = this.model_type;
             const rules = ruleMap[model];
             if (Array.isArray(rules)) {
                return [...rules];
            } else if (typeof rules === 'object' && rules[field_key]) {
                return [...rules[field_key]];
            } else {
                const fieldSchema = this.fields?.[field_key];
                const shouldCheckDuplicate = fieldSchema?.required && fieldSchema?.check_duplicate;

                if (shouldCheckDuplicate) {
                    return [duplicate];
                } else {
                    return [];
                }
            }
        },
        async validate_Car(_rule, value) {
            const currentValue = value;
            return new Promise((resolve, reject) => {
                if(_rule.required && !currentValue) {
                        reject('โปรดระบุ');
                }
                const plateNo = this.model_form?.plate_no
                if (plateNo) {
                    const pattern = /^[\u0E00-\u0E7F0-9]{2,3}-[\u0E00-\u0E7F0-9]{3,6}$/;
                    if (!pattern.test(plateNo)) {
                        reject('กรุณากรอกเลขทะเบียนรถให้ถูกต้องตามรูปแบบที่กำหนด (XX-YYYY)');
                    }
                }
                setTimeout(() => {
                    this.$route.params.id == 'create' ? 
                    SystemService.check_duplicate(
                        this.model_type,
                        // this.check_keys_to_modelname[_rule.field],
                        `field=${_rule.field}&value=${currentValue}&id=${this.action_type}`
                    ).then((res) => {
                        if (this.model_form?.plate_no !== currentValue) {
                            return;
                        }
                        if (res) {
                            reject("มีข้อมูลนี้อยู่แล้ว");
                        } else {
                            resolve();
                        }
                    })
                    : resolve();
                }, 0);
            });
        },
        async validate_Car_Company(_rule, value) {
            const currentValue = value;
            return new Promise((resolve, reject) => {
                if(_rule.required && !value) {
                        reject('โปรดระบุ');
                }
                const phone_no = this.model_form?.phone_no;
                if (phone_no) {
                    const onlyNumbers = phone_no.replace(/\D/g, '');
                    const isOnlyNumbers = /^\d+$/.test(phone_no);
                    if (!onlyNumbers.startsWith('0') || !isOnlyNumbers) {
                        reject('เบอร์โทรต้องขึ้นต้นด้วยเลข 0 และต้องเป็นตัวเลขเท่านั้น');
                    }
                    if (onlyNumbers.length < 10) {
                        reject('กรุณากรอกเบอร์โทรให้ครบ 10 หลัก');
                    }
                    
                }
                setTimeout(() => {
                    SystemService.check_duplicate(
                        this.model_type,
                        // this.check_keys_to_modelname[_rule.field],
                        `field=${_rule.field}&value=${value}&id=${this.action_type}`
                    ).then((res) => {
                        if (this.model_form?.phone_no !== currentValue) {
                            return;
                        }
                        if (res) {
                            reject("เบอร์โทรนี้มีผู้ใช้งานแล้ว");
                        } else {
                            resolve();
                        }
                    })
                }, 0);
            });
        },
        async validate_Client(_rule, value) {
            const currentValue = value;
            return new Promise((resolve, reject) => {
                if(_rule.required && !value) {
                        reject('โปรดระบุ');
                }
                const acc = this.model_form?.organ_accout_number;
                if (acc) {
                    const onlyNumbers = acc.replace(/\D/g, '');
                    const isOnlyNumbers = /^\d+$/.test(acc);
                    if (!isOnlyNumbers) {
                        reject('เลขที่บัญชีต้องเป็นตัวเลขเท่านั้น ห้ามมีช่องว่างหรืออักขระพิเศษ');
                    }
                    if (onlyNumbers.length < 10) {
                        reject('กรุณากรอกเลขบัญชีให้ครบถ้วน (อย่างน้อย 10 หลัก)');
                    }
                }
                setTimeout(() => {
                    SystemService.check_duplicate(
                        this.model_type,
                        // this.check_keys_to_modelname[_rule.field],
                        `field=${_rule.field}&value=${value}&id=${this.action_type}`
                    ).then((res) => {
                        if (this.model_form?.organ_accout_number !== currentValue) {
                            return;
                        }
                        if (res) {
                            reject("เลขบัญชีนี้ถูกใช้ไปแล้ว โปรตรวจสอบอีกครั้ง");
                        } else {
                            resolve();
                        }
                    })
                }, 0);
            });
        },
        filterOption (input, option) {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        async remove_uploaded_file({ uid }) {
            // console.log(uid);
            this.model_form[uid] = ''
        },
        show_sub_selectables(parent) {
            try {
                return this.selectables[parent.list].find(({ id }) => id == this.model_form[parent.key])[parent.sub_list_name]
            } catch (er) {
                return []
            }
        },
        async go_remove(id, type) {
            Swal.fire({
                title: `คุณต้องการลบข้อมูลนี้ใช่หรือไม่? [${type}ID: ${id}]`,
                text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้หากลบแล้ว!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่, ลบข้อมูลนี้!',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await SystemService.delete_all(type, id)
                    Swal.fire(
                        'ลบข้อมูลเรียบร้อย!',
                        'ข้อมูลของคุณถูกลบแล้ว',
                        'success'
                    )
                }
            })
        },
        upload_files(e, key) {
            if (e.file.status != 'remove') {
                this.getBase64(e.file.originFileObj, key)
                if (e.file.status == 'uploading' && !this.isLoading) {
                    this.$message.loading('กำลังอัปโหลดไฟล์...');
                    this.isLoading = true;
                }
                if (e.file.status == 'error') {
                    this.$message.success('อัปโหลดไฟล์สำเร็จ')
                    this.isLoading = false;
                }
                return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
            }
        },
        async downloadFile(record) {
            try {
            if (!record.file) {
                console.error("File URL is missing");
                return;
            }

            // ดึงข้อมูลไฟล์จาก URL
            const response = await fetch(record.file);
            if (!response.ok) {
                console.error("Failed to fetch the file:", response.statusText);
                return;
            }

            // แปลงไฟล์เป็น Blob
            const blob = await response.blob();

            // ตรวจสอบว่าไฟล์เป็น PDF หรือไม่
            const fileType = blob.type || "";
            const isPDF = fileType.includes("pdf");

            // สร้าง Blob URL
            const blobUrl = URL.createObjectURL(blob);

            // สร้างลิงก์ดาวน์โหลด
            const link = document.createElement("a");
            link.href = blobUrl;
            const type = this.$route.params.id == 'create' ? 'create_all' : 'update_all';
            link.download = isPDF && type != "create_all" ? `${record.name || record.file_name}.pdf` : (record.name || record.file_name); // บังคับให้ใช้ .pdf สำหรับไฟล์ PDF
            document.body.appendChild(link);
            link.click();

            // ลบลิงก์เพื่อทำความสะอาด
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
            } catch (error) {
            console.error("Error while downloading the file:", error);
            }
        },
        async upload_file_multiple(e, key) {
            if (e.file.status != 'remove') {
                var file = e.file.originFileObj
                if (key) {
                    if(key == 'file_asset_insure'){
                        const vue = this
                        if (!vue.data_raw_files_insure) {
                            vue.data_raw_files_insure = [];
                        }
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function () {
                            if(vue.data_raw_files_insure.map(e => e.file_name).includes(file.name)) return
                            vue.data_raw_files_insure.push({
                                file_name: file.name,
                                name: '',
                                file: reader.result,
                            })
                        };
                    }else{
                        const vue = this
                        if (!vue.data_raw_files) {
                            vue.data_raw_files = [];
                        }
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function () {
                            if(vue.data_raw_files.map(e => e.file_name).includes(file.name)) return
                            vue.data_raw_files.push({
                                file_name: file.name,
                                name: '',
                                file: reader.result,
                            })
                        };
                    }
                } else {
                    return await new Promise((resolve, reject) => {
                        if (file) {
                            if (typeof file == 'string') {
                                resolve(file)
                            } else {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = error => reject(error);
                            }
                        }
                    });
                }
                return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
            }
        },
        async upload_file_multiple_driver(e, key) {
            if (e.file.status != 'remove') {
                var file = e.file.originFileObj;
                if (key === 'document_file') { 
                    const docExtensions = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx'];
                    const docFileExt = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
                    
                    if (!docExtensions.includes(docFileExt)) {
                        this.$message.error('อัปโหลดได้เฉพาะไฟล์: .jpg, .png, .pdf, .doc, .docx เท่านั้น');
                        return; 
                    }
                }
                if (key) {
                    if(key == 'file_asset_insure'){
                        const vue = this
                        if (!vue.data_raw_files_insure) {
                            vue.data_raw_files_insure = [];
                        }
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function () {
                            if(vue.data_raw_files_insure.map(e => e.file_name).includes(file.name)) return
                            vue.data_raw_files_insure.push({
                                file_name: file.name,
                                name: '',
                                file: reader.result,
                            })
                        };
                    }else{ 
                        const vue = this
                        if (!vue.data_raw_files) {
                            vue.data_raw_files = [];
                        }
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function () {
                            if(vue.data_raw_files.map(e => e.file_name).includes(file.name)) return
                            vue.data_raw_files.push({
                                file_name: file.name,
                                name: '',
                                file: reader.result,
                            })
                        };
                    }
                } else {
                    return await new Promise((resolve, reject) => {
                        if (file) {
                            if (typeof file == 'string') {
                                resolve(file)
                            } else {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = error => reject(error);
                            }
                        }
                    });
                }
                
                return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
            }
        },
        handleRecord(record) {
                console.log("record: ", record);
            },
        async upload_file_car(e, key) {
            if (e.file.status != 'remove') {
                var file = e.file.originFileObj
                if (key) {
                    const vue = this
                    if (!vue.model_form[key]) {
                        vue.model_form[key] = [];
                    }
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function () {

                    vue.model_form[key].push({
                    file_name: file.name,
                    name: 'Car',
                    file: reader.result,
                    });
                    };
                } else {
                    return await new Promise((resolve, reject) => {
                        if (file) {
                            if (typeof file == 'string') {
                                resolve(file)
                            } else {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = error => reject(error);
                            }
                        }
                    });
                }
                return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
            }
        },
        async getBase64(file, key) {
            if (key) {
                const vue = this
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    vue.model_form[key] = reader.result
                    vue.model_form[`${key}_file_name`] = file.name
                };
            } else {
                return await new Promise((resolve, reject) => {
                    if (file) {
                        if (typeof file == 'string') {
                            resolve(file)
                        } else {
                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = () => resolve(reader.result);
                            reader.onerror = error => reject(error);
                        }
                    }
                });
            }
        },
        async validate_model_form() {
            try {
                if (this.data_raw_files && this.data_raw_files.length) {
                    this.model_form.data_raw_files = this.data_raw_files
                }
                if (this.data_raw_files_insure && this.data_raw_files_insure.length) {
                    this.model_form.data_raw_files_insure = this.data_raw_files_insure
                }
                if (this.model_form.create_options) {
                    this.model_form.car_options = this.model_form.create_options.map((id) => {
                        return {
                            option_id: id
                        }
                    })
                    delete this.model_form.create_options
                }
                if (this.model_form.photos) {
                    for (var i = 0; i < this.model_form.photos.length; i++) {
                        this.model_form[`photo_${i + 1}`] = await this.getBase64(this.model_form.photos[i].originFileObj)
                    }
                    delete this.model_form.photos
                    delete this.model_form.create_photos
                }
                if(this.model_type == "CarCompany" && this.$route.params.id == 'create'){
                    this.model_form.permissions = "1";
                }
                this.model_form.company_id = this.company_id
            } catch (err) {
                console.log(err);
            }
        },
        async confirmAndSubmit() {
            if ((this.model_type === 'Driver' || this.model_type === 'Car' || this.model_type === 'CarCompany')&&this.$route.params.id == 'create') {
                this.showAlertSubmit = true;
            } else {
                await this.submit_model_data();
            }
        },
        formatToDecimalString(value) {
            if (value === null || value === undefined || value === '') return null; 
            
            const number = parseFloat(value);
            if (isNaN(number)) return value;
            
            return number.toFixed(2); 
        },
        async submit_model_data() {
            const modelType = this.model_type
            const type = this.$route.params.id == 'create' ? 'create_all' : 'update_all';
            if (this.model_type === 'Driver') {
                delete this.model_form.leave_on;
                delete this.model_form.leave_type_id;
                delete this.model_form.working_on;
                this.model_form.document_file = this.data_raw_files
                if (type === 'create_all') {
                    this.model_form.company_3rd = this.disableId
                }
            }
            if (this.model_type === 'Car') {
                if (type === 'create_all') {
                    this.model_form.company_3rd = this.disableId
                }
            }
            if(this.model_form['account_information_name']){
                const fullname = this.model_form['account_information_name'].split(/[\s]+/);
                this.model_form['account_information_name'] = fullname[0]??null;
                this.model_form['account_information_surname'] = fullname[1]??null;
            }
            if(this.model_form['information_name']){
                const fullname = this.model_form['information_name'].split(/[\s]+/);
                this.model_form['information_name'] = fullname[0]??null;
                this.model_form['information_surname'] = fullname[1]??null;
            }
            if (this.model_form.salary_rate && this.car_rental_a) {
                delete this.model_form.salary_rate
            }
            if (this.model_form.id_no && this.car_rental_a) {
                delete this.model_form.id_no
            }
            if (this.model_form.driver_current_car_no && this.car_rental_a) {
                delete this.model_form.driver_current_car_no
            }
            const data = JSON.parse(JSON.stringify(this.model_form));
            const { password, ...newData } = data;
            const lastestData = (password === this.oldPassword || password === null) ? newData : data
            const result = { ...lastestData, 
                document_field_3: (this.model_form.document_field_3 !== null) ? JSON.stringify(this.model_form.document_field_3) : null,
                document_field_4: (this.model_form.document_field_4 !== null) ? JSON.stringify(this.model_form.document_field_4) : null,
                document_field_5: (this.model_form.document_field_5 !== null) ? JSON.stringify(this.model_form.document_field_5) : null,
                document_field_6: (this.model_form.document_field_6 !== null) ? JSON.stringify(this.model_form.document_field_6) : null,
                document_field_7: (this.model_form.document_field_7 !== null) ? JSON.stringify(this.model_form.document_field_7) : null,
                document_field_8: (this.model_form.document_field_8 !== null) ? JSON.stringify(this.model_form.document_field_8) : null,
                document_file: (this.model_form.document_file !== null) ? JSON.stringify(this.model_form.document_file) : null,
                file_asset_insure: (this.model_form.file_asset_insure !== null) ? JSON.stringify(this.model_form.file_asset_insure) : null,
            }
            //  console.log("result",result)
             try {
                Swal.fire({
                    title: 'กรุณารอสักครู่',
                    text: 'กำลังบันทึกข้อมูล',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading();
                    }
                });
                this.validate_model_form();
                if (this.model_type === 'Driver') {
                    if (type === 'create_all') {
                        // await DriverService.createDriver({ data: [data] });
                        await DriverService.createDriver({ data: [result] });
                    } else {
                        await DriverService.updateDriver({ data: [result] }, this.model_form.id);
                        if(this.changeWorkStatus == true){
                            const checkInData = {
                                check_in_type_id: this.model_form.work_status_id == 2 ? 3 : 1, 
                                check_in_datetime:  this.model_form.work_status_id == 2 ? null : dayjs().format("YYYY-MM-DD HH:mm"), 
                                check_out_datetime: this.model_form.work_status_id == 2 ? dayjs().format("YYYY-MM-DD HH:mm") : null,
                                driver_id: this.model_form.id,
                            }
                            await CheckInHistoryService.createCheckIn(checkInData);
                        }
                    }
                } else {
                    if (this.model_form.withholding) {
                        this.model_form.withholding = this.model_form.withholding.id;
                    }
                    if (this.model_form.driver_id) {
                        const existingCars = await CarService.getCarByDriver(this.model_form.driver_id);
                        const isExistingCar = await existingCars.some(car => car.id === this.model_form.id);
                        if (existingCars.length > 0 && !isExistingCar) {
                            Swal.close();
                            const confirmation = await Swal.fire({
                                title: 'คนขับมีรถประจำอยู่แล้ว',
                                text: 'คุณต้องการดำเนินการต่อหรือไม่?',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'ดำเนินการต่อ',
                                cancelButtonText: 'ยกเลิก'
                            });
                            if (!confirmation.isConfirmed) {
                                Swal.fire({
                                    title: 'ยกเลิกการดำเนินการ',
                                    text: 'การดำเนินการถูกยกเลิก',
                                    icon: 'info',
                                    timer: 1500,
                                    showConfirmButton: false
                                });
                                return;
                            }
                            Swal.fire({
                                title: 'กรุณารอสักครู่',
                                text: 'กำลังดำเนินการต่อ',
                                allowOutsideClick: false,
                                showConfirmButton: false,
                                willOpen: () => {
                                    Swal.showLoading();
                                }
                            });
                            //TODO(Fix more behavior)
                            for (const car of existingCars) {
                                await SystemService[type](
                                    'Driver',
                                    { data: { car_id: null, driver_type: 2 } },
                                    car.driver_id
                                );
                                await SystemService[type](
                                    modelType,
                                    { data: { driver_id: null } },
                                    car.id
                                );
                            }
                        }
                        if (this.model_form.driver) {
                            await SystemService[type](
                                'Driver',
                                { data: { car_id: null, driver_type: 2 } },
                                this.model_form.driver.id
                            );
                        }
                        await SystemService[type](
                            'Driver',
                            { data: { car_id: this.model_form.id, driver_type: 1 } },
                            this.model_form.driver_id
                        );
                    }
                    // original //
                    if (this.model_type === "Car") {
                        delete this.model_form?.check_head_registration
                        delete this.model_form?.check_tail_registration
                        delete this.model_form?.unit
                        delete this.model_form?.consumption_rate
                        const carData = (this.model_form);
                        const { carPassword, ...newCarData } = carData;
                        const carLastestData = (carPassword === this.oldPassword || carPassword === null) ? newCarData : carData
                        const carResult = { ...carLastestData,
                            doc_1: (this.model_form.doc_1 !== null) ? JSON.stringify(this.model_form.doc_1) : null,
                            doc_2: (this.model_form.doc_2 !== null) ? JSON.stringify(this.model_form.doc_2) : null,
                            doc_3: (this.model_form.doc_3 !== null) ? JSON.stringify(this.model_form.doc_3) : null,
                            doc_4: (this.model_form.doc_4 !== null) ? JSON.stringify(this.model_form.doc_4) : null,
                            doc_5: (this.model_form.doc_5 !== null) ? JSON.stringify(this.model_form.doc_5) : null,
                            doc_6: (this.model_form.doc_6 !== null) ? JSON.stringify(this.model_form.doc_6) : null,
                            car_book_page: (this.model_form.car_book_page !== null) ? JSON.stringify(this.model_form.car_book_page) : null,
                            car_pic: (this.model_form.car_pic !== null) ? JSON.stringify(this.model_form.car_pic) : null,
                        }

                        const fieldsToFormat = [
                            'car_tax_premium_net', 
                            'car_tax_premium_total_added', 
                            'car_tax_stamps',
                            'car_tax_vat', 
                            'car_tax_total',
                            'insure_premium_net',
                            'insure_premium_capital',
                            'insure_premium_protection',
                            'insure_stamps',
                            'insure_vat',
                            'insure_total',
                            'product_premium_net',
                            'product_premium_capital',
                            'product_premium_protection',
                            'product_stamps',
                            'product_vat',
                            'product_total'
                            
                        ];

                        fieldsToFormat.forEach(field => {
                            if (carResult[field] !== undefined) {
                                carResult[field] = this.formatToDecimalString(carResult[field]);
                            }
                        });

                        const response = await SystemService[type](
                            modelType,
                            type === 'create_all' ? { data: [carResult] } : { data: carResult },
                            this.model_form.id
                        );
                    } else if (this.model_type === "CarCompany") {
                        this.model_form.document_file = this.data_raw_files
                        delete this.model_form.data_raw_files
                        const carCompanyData = (this.model_form);
                        const { carCompanyPassword, ...newCarCompanyData } = carCompanyData;
                        const carCompanyLastestData = (carCompanyPassword === this.oldPassword || carCompanyPassword === null) ? newCarCompanyData : carCompanyData
                        const carCompanyResult = { ...carCompanyLastestData,
                            document_file: (this.model_form.document_file !== null) ? JSON.stringify(this.model_form.document_file) : null,
                        }
                        await SystemService[type](
                            modelType,
                            type === 'create_all' ? { data: [carCompanyResult] } : { data: carCompanyResult },
                            this.model_form.id
                        ) 
                    }else if (this.model_type === "Client") {
                        // const accountTypeMapping = {
                        //     1: "บัญชีเงินฝากออมทรัพย์",
                        //     2: "บัญชีเงินฝากประจำ",
                        //     3: "บัญชีเงินฝากประจำรายเดือนแบบปลอดภาษี",
                        //     4: "บัญชีเงินฝากกระแสรายวัน",
                        //     5: "บัญชีเงินตราระหว่างประเทศ",
                        //     6: "บัญชีเงินฝากแบบขั้นบันได",
                        // };
                        //  const accountTypeText = accountTypeMapping[this.model_form.account_type];
                        const clientData = (this.model_form);
                        const { clientPassword, ...newClientData } = clientData;
                        const clientLastestData = (clientPassword === this.oldPassword || clientPassword === null) ? newClientData : clientData
                        this.model_form?.branches?.forEach(branch => {
                            if (branch.latlng) {
                                const [lat, lng] = branch.latlng.split(',');
                                branch.lat = lat?.trim();
                                branch.lng = lng?.trim();
                                delete branch.latlng;
                            }
                        });

                        const clientResult = { ...clientLastestData,
                            // account_type: (accountTypeText !== null) ? accountTypeText : null,
                            data_raw_files: (this.model_form.data_raw_files !== null) ? JSON.stringify(this.model_form.data_raw_files) : null,
                        }
                        await SystemService[type](
                        modelType,
                        type === 'create_all' ? { data: [clientResult] } : { data: clientResult },
                        this.model_form.id
                    );
                    } else {
                        await SystemService[type](
                        modelType,
                        type === 'create_all' ? { data: [this.model_form] } : { data: this.model_form },
                        this.model_form.id
                    );
                    }
                    
                    // original //
                }
                Swal.close();
                Swal.fire({
                    title: 'บันทึกข้อมูลสำเร็จ',
                    icon: 'success',
                    timer: 2500,
                    timerProgressBar: false,
                    showConfirmButton: false,
                });
            } catch (error) {
                Swal.close();
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถบันทึกข้อมูลได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง',
                });
                console.log(error);
            } finally {
                this.clear_model_data();
            }
        },
        async init_create_edit() {
            try {
                this.car_list = await SystemService.get_all("Car")
                this.car_company = await SystemService.get_all("CarCompany")
                const carOptions = await this.getDropdownCars();
                let driver = this.default_fields_driver.Driver.inputs
                driver.document_field_4.drawer_fields.inputs.driver_main_car.options = carOptions;
                driver.document_field_7.drawer_fields.inputs.driver_work_defect_car.options = carOptions;
                driver.document_field_8.drawer_fields.inputs.driver_accident_car.options = carOptions;
                if (this.model_type === "Car") {
                    this.default_fields.Car.inputs.plate_no.check_rule = [{
                        required: true,
                        validator: this.validate_Car,
                        trigger: 'change',
                    }]
                }
                if (this.$route.params.id != 'create') {
                    let data = await SystemService.get_id(this.model_type, this.$route.params.id)
                    this.companyId = await CarCompanyService.getById(data.car_company_id)
                    if(data.company_3rd == "บริษัทรถร่วม"){
                        this.car_company = await CarCompanyService.get_car_companies_3rd()
                    }
                    if (data) {
                        if (this.model_type === "Driver") {
                            if (data.salary && this.car_rental_a) {
                                data.salary_rate = data.salary
                            }
                            if (data.card_id && this.car_rental_a) {
                                data.id_no = data.card_id
                            }
                            if (data.car_id && this.car_rental_a) {
                                data.driver_current_car_no = this.car_list.find(item => item.id === data.car_id)?.plate_no
                            }
                                data.document_field_3 = this.safeParseJSON(data.document_field_3);
                            data.document_field_4 = this.safeParseJSON(data.document_field_4);
                            data.document_field_5 = this.safeParseJSON(data.document_field_5);
                            data.document_field_6 = this.safeParseJSON(data.document_field_6);
                            data.document_field_7 = this.safeParseJSON(data.document_field_7);
                            data.document_field_8 = this.safeParseJSON(data.document_field_8);
                            data.document_file = this.safeParseJSON(data.document_file);
                            if(data.car_company_id){
                                data.car_company_id = this.safeParseJSON(this.companyId[0].id)
                            }
                            this.disabletest = data.company_3rd === "บริษัทรถร่วม" ? false : true;
                        }
                        if (this.model_type === "CarCompany") {
                            data.document_file = this.safeParseJSON(data.document_file);
                        }
                        if (this.model_type === "Car") {
                            data.doc_1 = this.safeParseJSON(data.doc_1);
                            data.doc_2 = this.safeParseJSON(data.doc_2);
                            data.doc_3 = this.safeParseJSON(data.doc_3);
                            data.doc_4 = this.safeParseJSON(data.doc_4);
                            data.doc_5 = this.safeParseJSON(data.doc_5);
                            data.doc_6 = this.safeParseJSON(data.doc_6);
                            data.data_raw_files_insure = data.data_raw_files_insure;
                            data.car_book_page = this.safeParseJSON(data.car_book_page);
                            data.car_pic = this.safeParseJSON(data.car_pic);
                            this.disabletest = data.company_3rd === "บริษัทรถร่วม" ? false : true;
                        }
                        if(data.information_surname && data.information_surname != ""){
                            data.information_name = data.information_name+" "+data.information_surname;
                        }
                        if(data.account_information_surname && data.account_information_surname != ""){
                            data.account_information_name = data.account_information_name+" "+data.account_information_surname;
                        }
                        if (this.model_type === "Client") {
                            data.data_raw_files = this.safeParseJSON(data.data_raw_files);
                            this.data_raw_files = data.data_raw_files
                            data.branches.forEach(branch => {
                                if (branch.lat && branch.lng) {
                                    branch.latlng = `${branch.lat},${branch.lng}`;
                                }
                            });
                        }
                        if(this.model_type == "CarType"){
                            data.consumption_rate = data?.latest_gas_detail?.consumption_rate ? parseFloat(data.latest_gas_detail.consumption_rate) : null;
                        }
                        this.model_form = this.parse_update_data(data)
                        if (this.model_type === "Driver") {
                            this.data_raw_files = data.document_file
                            this.is_check_license = data.driver_license_no == 1 ? 0 : 1;
                            const checkInDriver = await CheckInHistoryService.getCheckInByDriverId(this.action_type);
                            if (checkInDriver && checkInDriver?.length) {
                                const checkedInValue = checkInDriver[checkInDriver.length - 1];

                                const isNotToday = !dayjs(checkedInValue.created_at).isSame(dayjs(), 'day');
                                if ((isNotToday || this.model_form?.leave_on) || !isNotToday && checkedInValue?.check_in_type_id == 3) {
                                    this.model_form.work_status_id = 2;
                                }else if(this.model_form.working_on){
                                    this.model_form.work_status_id = 13;
                                }else if(!isNotToday && checkedInValue?.check_in_type_id == 1 || checkedInValue?.check_in_type_id == 2){
                                    this.model_form.work_status_id = 3;
                                }
                            }else {
                                this.model_form.work_status_id = 2;
                            }
                        }
                        if (this.model_type === "CarCompany") {
                            this.data_raw_files = data.document_file
                        }
                        if (this.model_type === 'PartType'||this.model_type === 'PartUnit'||this.model_type === 'Part'||this.model_type === 'CarRepairType'||this.model_type === 'CarType') {
                            this.old_part_type = this.model_form['name'];
                        }
                        if(this.model_type === 'Vendor'){
                            this.old_tax_id = this.model_form['tax_id'];
                        }
                        if(this.model_type === 'Part'){
                            this.old_barcode = this.model_form['barcode'];
                        }
                        if (this.model_type === 'Car') {
                            if (this.model_form.head_registration) {
                                this.model_form.check_head_registration = 'ทะเบียนหัว'
                            }
                            if (this.model_form.tail_registration) {
                                this.model_form.check_tail_registration = 'ทะเบียนหาง'
                            }
                        }
                    }
                } else {
                    this.model_form = this.model_data
                    if (this.action_type === 'create' && this.model_type === "Driver") {
                        this.model_form['car_company_id'] = this.car_company[0].id;
                    }
                    if (this.key === 'create' && this.model_type === "Car") {
                        this.model_form['car_company_id'] = this.car_company[0].id;
                    }
                }
                if(this.model_type == 'StockHistory'){
                    this.model_form['withdraw_type_id'] = 2;
                }
                if(this.model_type == 'Part'){
                    this.model_form['withdraw_type_id'] = 1;
                }
                // Set initial value for car_company_id if not already set
                if (!this.model_form['car_company_id'] && this.car_company.length > 0 && this.model_type === "Car") {
                    this.model_form['car_company_id'] = this.car_company[0].id;
                }
            } catch (error) {
                console.error(error);
            }
        },
        clear_model_data() {
            this.$emit('apply_model_data', {})
            this.$router.go(-1)
        },
        logField(field) {
            console.log("Field:",field);
        },
        async get_default_fields() {
            if (this.model_type === 'StockHistory') {
                const part_unit_list = await SystemService.get_all('PartUnit')
                const part_list = await SystemService.get_all('Part')
                this.default_fields.StockHistory.inputs.create_part_withdraw.drawer_fields.inputs.part_id.options = part_list;
                this.default_fields.StockHistory.inputs.create_part_withdraw.drawer_fields.inputs.part_unit_id.options = part_unit_list;
            }
            for (var key in this.default_fields[this.model_type].inputs) {
                const { input_type, modelname, target_key } = this.default_fields[this.model_type].inputs[key]
                if ((input_type == 'select' || input_type == 'checkbox') && modelname) {
                    let res;
                    if (modelname == 'DriverStatus') {
                        res = await DriverService.getDriverWorkStatusAll()
                        res = res.data.filter((item)=>[2,3,13].includes(item.id));
                    } else if (modelname == 'DrivingLicenseType') {
                        res = await DriverService.getDrivingLicenseTypeAll()
                    } else if (modelname == 'Withholding') {
                        res = await WithholdingService.getAll()
                    } else if (modelname == 'Bank') {
                        res = await BankService.getAll()
                    } else if (modelname == 'getAllBankBranches') {
                        res = await BankService.getAllBankBranches()
                    } else if (modelname == 'Client') {
                        const res1 = await SystemService.get_all("ClientBranch")
                        this.selectables.ClientBranch = res1
                        res = await SystemService.get_all(modelname)
                    } else if (modelname == 'CarType'){
                        res = await CarTypeService.getCarTypeByCompany();
                    } else {
                        res = await SystemService.get_all(modelname)
                    }
                    this.selectables[modelname] = res.data ? res.data : res
                    if (modelname === 'CarType' && this.model_form['car_type_id']){
                        this.model_form['consumption_rate'] = this.selectables['CarType'].find(item => item.id === this.model_form['car_type_id'])?.consumption_rate;
                    }
                    if (modelname === 'GasType' && this.model_form['gas_type_id']){
                        this.model_form['unit'] = this.selectables['GasType'].find(item => item.id === this.model_form['gas_type_id'])?.unit;
                    }

                    this.usedDriver = await DriverService.getDriverByCompanyAndMain();
                }
                if (input_type == 'photos') {
                    if (!this.model_form[target_key]) {
                        this.model_form[target_key] = []
                    }
                }
                if (key == 'client_no') {
                    this.model_form[key] = this.model_form.client_no || await SystemService.get_client_no();
                }
            }
            this.selectables['CarGroup'] = await SystemService.get_all('CarGroup')
        },
        async get_default_fields_driver() {
            for (var key in this.default_fields_driver[this.model_type]?.inputs) {
                const { input_type, modelname, target_key } = this.default_fields_driver[this.model_type]?.inputs[key]
                if ((input_type == 'select' || input_type == 'checkbox') && modelname) {
                        if (modelname == 'DriverStatus') {
                        const res = await DriverService.getDriverWorkStatusAll()
                        this.selectables[modelname] = res.data
                    } else if (modelname == 'DrivingLicenseType') {
                        const res = await DriverService.getDrivingLicenseTypeAll()
                        this.selectables[modelname] = res.data
                    } else if (modelname == 'Withholding') {
                        const res = await WithholdingService.getAll()
                        this.selectables[modelname] = res.data
                    }  else if (modelname == 'Bank') {
                        const res = await BankService.getAll()
                        this.selectables[modelname] = res.data
                        // console.log("res", res);
                    }else if (modelname == 'getAllBankBranches') {
                        const res = await BankService.getAllBankBranches()
                        this.selectables[modelname] = res.data
                        // console.log("res", res);
                    }
                     else if (modelname == 'CarCompany') {
                        // Fetch CarCompany data here
                        const res = await SystemService.get_all(modelname);
                        this.selectables[modelname] = res.filter(company => company.fullname);
                    } else if (modelname == 'Vendor') {
                        const res = await SystemService.get_all(modelname);
                        this.selectables[modelname] = res.filter(vendor => vendor.name); // Match using name field
                    } else if (modelname == 'PartUnit') {
                        const res = await SystemService.get_all(modelname);
                        this.selectables[modelname] = res.filter(unit => unit.name);
                    } else if (modelname == 'PartType') {
                        const res = await SystemService.get_all(modelname);
                        this.selectables[modelname] = res.filter(type => type.name);
                    } else if (modelname == 'WithdrawType') {
                        const res = await SystemService.get_all(modelname);
                        this.selectables[modelname] = res.filter(type => type.name); // Filter valid entries
                    } else if (modelname == 'TourType') {
                        const res = await SystemService.get_all(modelname);
                        this.selectables[modelname] = res.filter(type => type.name); // Filter valid types by name
                    }else if (modelname == 'Colorrandom') {
                        const res = await SystemService.get_all(modelname);

                        // กรองรายการให้เหลือเฉพาะที่ต้องการ
                        this.selectables[modelname] = res.filter(type => type.name);

                        // ตรวจสอบว่ามีข้อมูล และเลือกค่าล่าสุด
                        if (this.selectables[modelname]?.length > 0) {
                            const lastColor = this.selectables[modelname][this.selectables[modelname].length - 1];
                            this.model_form['color_id'] = lastColor?.id || null; // ตั้งค่าค่า default
                        } else {
                            console.warn('No colors found in selectables[Colorrandom]');
                        }
                    }
                    {
                        const res = await SystemService.get_all(modelname)
                        this.selectables[modelname] = res
                    }
                }
                if (input_type == 'photos') {
                    if (!this.model_form[target_key]) {
                        this.model_form[target_key] = []
                    }
                }
                if (key == 'client_no') {
                    this.model_form[key] = this.model_form.client_no || await SystemService.get_client_no();
                }
            }
            this.selectables['TypePayment'] = [{'id':1,'label':'โอน'},{'id':2,'label':'เงินสด/เช็ค'}];
            this.selectables['CarGroup'] = await SystemService.get_all('CarGroup')
        },
        clear_drawer_data(key) {
            this.default_fields[this.model_type].inputs[key].create.show = false
            this.default_fields_driver[this.model_type].inputs[key].create.show = false
        },
        parse_update_data(data) {
            try {
                for (var key in data) {
                    if (!data[key]) continue
                    if(key == "password"){
                        this.oldPassword = data[key] ?? null
                        data[key] = null
                        // console.log("oldPassword: ",this.oldPassword)
                        // console.log("password: ",data[key])
                    }
                    if(isNaN(data[key]) == false){
                        data[key] = data[key]
                    }else if(dayjs(data[key]).isValid() && key != 'car_no' && key != 'fullname' && key != 'remark' && key != 'username' && key != 'car_model' && key != 'plate_no' && key != 'driver_no') {
                        data[key] = dayjs(data[key])
                    }
                }

                const array_fields = ['options']
                for (var i = 0; i < array_fields.length; i++) {
                    const key = array_fields[i]
                    if (key in data) {
                        data[`create_${key}`] = data[key].map((item) => {
                            return item.id
                        })
                    }
                }

                const photos_fields = ['photo_1', 'photo_2', 'photo_3', 'photo_4', 'photo_5', 'photo_6', 'photo_7', 'photo_8']
                for (var i = 0; i < photos_fields.length; i++) {
                    const key = photos_fields[i]
                    if (key in data) {
                        if (data[key] != null) {
                            if (data.photos) {
                                data.photos.push({ 
                                    uid: key,
                                    name: data[key].split('/').pop(),
                                    status: 'done',
                                    url: data[key]
                                })
                            } else {
                                data.photos = [{ 
                                    uid: key,
                                    name: data[key].split('/').pop(),
                                    status: 'done',
                                    url: data[key]
                                }]
                            }
                        }
                    }
                }

                const boolean_fields = ['is_3rd_party','is_logis']
                for (var i = 0; i < boolean_fields.length; i++) {
                    const key = boolean_fields[i]
                    if (key in data) {
                        if (data[key] != null) {
                            data[key] = data[key] == 1 ? true : false
                        }
                    }
                }
                this.data_raw_files = data.data_raw_files
                this.data_raw_files_insure = data.data_raw_files_insure
                this.modelname = this.model_type
                return data
            } catch (err) {
                console.log(err)
            }
        },
        init_sex_type() {
            this.sex_types = [
                { name: 'ชาย' },
                { name: 'หญิง' },
                { name: 'ไม่ระบุเพศ' },
            ]
        },
        safeParseJSON(jsonString) {
            try {
                return jsonString ? JSON.parse(jsonString) : null;
            } catch (error) {
                console.error('Error parsing JSON:', jsonString, error);
                return null;
            }
        },
        async getDropdownCars() {
           const cars = await SystemService.get_core("getDropdownCars");
            return cars
        },
        async resetColor() {
        try {
            const id = this.model_form['color_id'];
            const response = await SystemService.updateColorById(id);
            if (response && response.data) {
                const updatedColor = response.data;
                this.selectables['Colorrandom'] = [updatedColor];
                this.model_form['color_id'] = updatedColor.id;
            }
        } catch (error) {
            console.error('Error updating color:', error);
        }
    },

    handleColorSelect(color) {
        this.model_form['color_id'] = color.id;
    },
    async get_company() {
        try {
            const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id);
            
            if (businessType?.data === 2) {
                this.business = true;
                delete this.default_fields_driver.Driver.inputs.driver_job_position;
            } else if (businessType?.data === 3) {
                this.business = true;
                this.logistic_a = true;
                this.default_fields.FleetAndSim.inputs.sub_divider_3_0.label = 'Fuel card & GPS Brand';
                this.default_fields.Insure.inputs.product_premium_total_added.placeholder = 'ประเภทประกันภัย';
                this.default_fields.Insure.inputs.insure_premium_total_added.placeholder = 'ประเภทประกันภัย';
                this.default_fields.Car={
                    ...CarFieldLogistic,
                    inputs: {
                        ...CarFieldLogistic.inputs || {},
                    }
                };
                this.default_fields.Part.inputs.claim_date.placeholder = 'วันที่เพิ่มอะไหล่';
                this.default_fields.Part.inputs.remark.placeholder = 'หมายเหตุ';
                this.default_fields.CarType.title.create = 'เพิ่มประเภทรถ';
                this.default_fields.CarType.title.edit = 'แก้ไขประเภทรถ';
                this.default_fields.CarType.photos[0].label = 'รูปประเภทรถ';
                this.default_fields.CarType.inputs.name.placeholder = 'ชื่อประเภทรถ';
                this.default_fields.CarType.inputs.wording_size = {
                                                                    input_type: 'label',
                                                                    label: 'ขนาดของตู้บรรทุก (เมตร)',
                                                                    required: false,
                                                                    col_span: 23,
                                                                }
                this.default_fields.CarType.inputs.car_width = {
                                                                    input_type: 'number',
                                                                    placeholder: 'กว้าง',
                                                                    check_rule: [
                                                                        { 
                                                                            required: true, 
                                                                            message: `โปรดระบุ กว้าง`
                                                                        }
                                                                    ],
                                                                    col_span: 7,
                                                                    step: 0.01 
                                                                }
                this.default_fields.CarType.inputs.car_length = {
                                                                    input_type: 'number',
                                                                    placeholder: 'ยาว',
                                                                    check_rule: [
                                                                        { 
                                                                            required: true, 
                                                                            message: `โปรดระบุ ยาว`
                                                                        }
                                                                    ],
                                                                    col_span: 7,
                                                                    step: 0.01 
                                                                },
                this.default_fields.CarType.inputs.car_height = {
                                                                    input_type: 'number',
                                                                    placeholder: 'สูง',
                                                                    check_rule: [
                                                                        { 
                                                                            required: true, 
                                                                            message: `โปรดระบุ สูง`
                                                                        }
                                                                    ],
                                                                    col_span: 7,
                                                                    step: 0.01 
                                                                }
                this.default_fields.CarType.inputs.loadable_weight = {
                                                                    input_type: 'number',
                                                                    placeholder: 'น้ำหนักที่บรรทุกได้ (กิโลกรัม)',
                                                                    check_rule: [
                                                                        { 
                                                                            required: true, 
                                                                            message: `โปรดระบุ น้ำหนักที่บรรทุกได้`
                                                                        }
                                                                    ],
                                                                    col_span: 23,
                                                                    step: 0.01 
                                                                }
                this.default_fields.CarType.inputs.consumption_rate = {
                                                                    input_type: 'text',
                                                                    placeholder: 'อัตราการใช้น้ำมัน (กม./ลิตร)',
                                                                    check_rule: [{
                                                                        validator: this.validate_decimal,
                                                                        trigger: 'change',
                                                                    }],
                                                                    col_span: 23,
                                                                    step: 0.01 
                                                                }                                                                
                this.default_fields.Car.inputs.car_type_id.placeholder = 'ประเภทรถ';
                delete this.default_fields.FleetAndSim.inputs.documents;
                delete this.default_fields.FleetAndSim.inputs.doc_1;
                delete this.default_fields.FleetAndSim.inputs.doc_2;
                delete this.default_fields.FleetAndSim.inputs.doc_3;
                delete this.default_fields.FleetAndSim.inputs.doc_4;
                delete this.default_fields.FleetAndSim.inputs.doc_5;
                delete this.default_fields.FleetAndSim.inputs.doc_6;
                delete this.default_fields.Car.inputs.head_registration;
                delete this.default_fields.Car.inputs.tail_registration;
            } else if (businessType?.data === 4) {
                delete this.default_fields.Part.inputs.withdraw_type_id
                this.business = 4;
            } else {
                this.business = false; // Default fallback
            }
            if (businessType.data === 4)
            {
                this.car_rental_a = true
            }
        } catch (error) {
            console.error("Error fetching company details:", error);
        }
    },
    },
    async mounted() {
        this.$emit('apply_model_data', {})
        this.options()
        this.init_sex_type()
        await this.get_company();
        await this.init_create_edit()
        await this.get_default_fields()
        await this.get_default_fields_driver()
    }
}
</script>

<style scoped>
.add_car {
    background-color: #e5e4e2;
}
.upload-container {
    position: relative;
    width: 100%;
    height: 100px;
}

.uploaded-image {
    width: 100%;
    height: 100%;
    transition: filter 0.3s ease;
    cursor: pointer;
}

.upload-container:hover .uploaded-image {
    filter: grayscale(100%);
}

.icon-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.upload-container:hover .material-symbols-outlined {
    color: white;
}

.ant-picker {
    width: 100%;
}
</style>